import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.reflect.construct.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.repeat.js";
import "core-js/modules/es.typed-array.uint32-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.weak-set.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { _nullishCoalesce, _optionalChain } from '@sentry/core';
import { GLOBAL_OBJ, normalize, fill, htmlTreeAsString, browserPerformanceTimeOrigin, logger as logger$1, severityLevelFromString, captureException, addBreadcrumb, uuid4, getClient, getLocationHref, getCurrentScope, getActiveSpan, getDynamicSamplingContextFromSpan, isSentryRequestUrl, dropUndefinedKeys, stringMatchesSomePattern, addEventProcessor, createEnvelope, createEventEnvelopeHeaders, getSdkMetadataForEnvelopeHeader, prepareEvent, getIsolationScope, resolvedSyncPromise, updateRateLimits, isRateLimited, setContext, getRootSpan, spanToJSON, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, isBrowser, parseSampleRate, consoleSandbox } from '@sentry/core';
import { setTimeout as setTimeout$3, addPerformanceInstrumentationHandler, addLcpInstrumentationHandler, addClsInstrumentationHandler, addFidInstrumentationHandler, addInpInstrumentationHandler, SENTRY_XHR_DATA_KEY, addClickKeypressInstrumentationHandler, addHistoryInstrumentationHandler } from '@sentry-internal/browser-utils';

// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
var WINDOW = GLOBAL_OBJ;
var REPLAY_SESSION_KEY = 'sentryReplaySession';
var REPLAY_EVENT_NAME = 'replay_event';
var UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';

// The idle limit for a session after which recording is paused.
var SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms

// The idle limit for a session after which the session expires.
var SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms

/** Default flush delays */
var DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
var DEFAULT_FLUSH_MAX_DELAY = 5500;

/* How long to wait for error checkouts */
var BUFFER_CHECKOUT_TIME = 60000;
var RETRY_BASE_INTERVAL = 5000;
var RETRY_MAX_COUNT = 3;

/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */
var NETWORK_BODY_MAX_SIZE = 150000;

/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */
var CONSOLE_ARG_MAX_SIZE = 5000;

/* Min. time to wait before we consider something a slow click. */
var SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */
var SLOW_CLICK_SCROLL_TIMEOUT = 300;

/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */
var REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB

/** Replays must be min. 5s long before we send them. */
var MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */
var MIN_REPLAY_DURATION_LIMIT = 15000;

/** The max. length of a replay. */
var MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;

function _nullishCoalesce$1(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}
function _optionalChain$5(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;
  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value2;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return (_value2 = value).call.apply(_value2, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }
  return value;
}
var NodeType$3;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$3 || (NodeType$3 = {}));
function isElement$1(n) {
  return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
  var host = _optionalChain$5([n, 'optionalAccess', function (_) {
    return _.host;
  }]);
  return Boolean(_optionalChain$5([host, 'optionalAccess', function (_2) {
    return _2.shadowRoot;
  }]) === n);
}
function isNativeShadowDom(shadowRoot) {
  return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
  if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) {
    cssText = cssText.replace(/\sbackground-clip:\s*text;/g, ' -webkit-background-clip: text; background-clip: text;');
  }
  return cssText;
}
function escapeImportStatement(rule) {
  var cssText = rule.cssText;
  if (cssText.split('"').length < 3) return cssText;
  var statement = ['@import', "url(".concat(JSON.stringify(rule.href), ")")];
  if (rule.layerName === '') {
    statement.push("layer");
  } else if (rule.layerName) {
    statement.push("layer(".concat(rule.layerName, ")"));
  }
  if (rule.supportsText) {
    statement.push("supports(".concat(rule.supportsText, ")"));
  }
  if (rule.media.length) {
    statement.push(rule.media.mediaText);
  }
  return statement.join(' ') + ';';
}
function stringifyStylesheet(s) {
  try {
    var rules = s.rules || s.cssRules;
    return rules ? fixBrowserCompatibilityIssuesInCSS(Array.from(rules, stringifyRule).join('')) : null;
  } catch (error) {
    return null;
  }
}
function fixAllCssProperty(rule) {
  var styles = '';
  for (var i = 0; i < rule.style.length; i++) {
    var styleDeclaration = rule.style;
    var attribute = styleDeclaration[i];
    var isImportant = styleDeclaration.getPropertyPriority(attribute);
    styles += "".concat(attribute, ":").concat(styleDeclaration.getPropertyValue(attribute)).concat(isImportant ? " !important" : '', ";");
  }
  return "".concat(rule.selectorText, " { ").concat(styles, " }");
}
function stringifyRule(rule) {
  var importStringified;
  if (isCSSImportRule(rule)) {
    try {
      importStringified = stringifyStylesheet(rule.styleSheet) || escapeImportStatement(rule);
    } catch (error) {}
  } else if (isCSSStyleRule(rule)) {
    var cssText = rule.cssText;
    var needsSafariColonFix = rule.selectorText.includes(':');
    var needsAllFix = typeof rule.style['all'] === 'string' && rule.style['all'];
    if (needsAllFix) {
      cssText = fixAllCssProperty(rule);
    }
    if (needsSafariColonFix) {
      cssText = fixSafariColons(cssText);
    }
    if (needsSafariColonFix || needsAllFix) {
      return cssText;
    }
  }
  return importStringified || rule.cssText;
}
function fixSafariColons(cssStringified) {
  var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return cssStringified.replace(regex, '$1\\$2');
}
function isCSSImportRule(rule) {
  return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
  return 'selectorText' in rule;
}
var Mirror = /*#__PURE__*/function () {
  function Mirror() {
    _classCallCheck(this, Mirror);
    this.idNodeMap = new Map();
    this.nodeMetaMap = new WeakMap();
  }
  _createClass(Mirror, [{
    key: "getId",
    value: function getId(n) {
      if (!n) return -1;
      var id = _optionalChain$5([this, 'access', function (_3) {
        return _3.getMeta;
      }, 'call', function (_4) {
        return _4(n);
      }, 'optionalAccess', function (_5) {
        return _5.id;
      }]);
      return _nullishCoalesce$1(id, function () {
        return -1;
      });
    }
  }, {
    key: "getNode",
    value: function getNode(id) {
      return this.idNodeMap.get(id) || null;
    }
  }, {
    key: "getIds",
    value: function getIds() {
      return Array.from(this.idNodeMap.keys());
    }
  }, {
    key: "getMeta",
    value: function getMeta(n) {
      return this.nodeMetaMap.get(n) || null;
    }
  }, {
    key: "removeNodeFromMap",
    value: function removeNodeFromMap(n) {
      var _this = this;
      var id = this.getId(n);
      this.idNodeMap.delete(id);
      if (n.childNodes) {
        n.childNodes.forEach(function (childNode) {
          return _this.removeNodeFromMap(childNode);
        });
      }
    }
  }, {
    key: "has",
    value: function has(id) {
      return this.idNodeMap.has(id);
    }
  }, {
    key: "hasNode",
    value: function hasNode(node) {
      return this.nodeMetaMap.has(node);
    }
  }, {
    key: "add",
    value: function add(n, meta) {
      var id = meta.id;
      this.idNodeMap.set(id, n);
      this.nodeMetaMap.set(n, meta);
    }
  }, {
    key: "replace",
    value: function replace(id, n) {
      var oldNode = this.getNode(id);
      if (oldNode) {
        var meta = this.nodeMetaMap.get(oldNode);
        if (meta) this.nodeMetaMap.set(n, meta);
      }
      this.idNodeMap.set(id, n);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.idNodeMap = new Map();
      this.nodeMetaMap = new WeakMap();
    }
  }]);
  return Mirror;
}();
function createMirror() {
  return new Mirror();
}
function shouldMaskInput(_ref) {
  var maskInputOptions = _ref.maskInputOptions,
    tagName = _ref.tagName,
    type = _ref.type;
  if (tagName === 'OPTION') {
    tagName = 'SELECT';
  }
  return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function maskInputValue(_ref2) {
  var isMasked = _ref2.isMasked,
    element = _ref2.element,
    value = _ref2.value,
    maskInputFn = _ref2.maskInputFn;
  var text = value || '';
  if (!isMasked) {
    return text;
  }
  if (maskInputFn) {
    text = maskInputFn(text, element);
  }
  return '*'.repeat(text.length);
}
function toLowerCase(str) {
  return str.toLowerCase();
}
function toUpperCase(str) {
  return str.toUpperCase();
}
var ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function is2DCanvasBlank(canvas) {
  var ctx = canvas.getContext('2d');
  if (!ctx) return true;
  var chunkSize = 50;
  for (var x = 0; x < canvas.width; x += chunkSize) {
    for (var y = 0; y < canvas.height; y += chunkSize) {
      var getImageData = ctx.getImageData;
      var originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
      var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
      if (pixelBuffer.some(function (pixel) {
        return pixel !== 0;
      })) return false;
    }
  }
  return true;
}
function getInputType(element) {
  var type = element.type;
  return element.hasAttribute('data-rr-is-password') ? 'password' : type ? toLowerCase(type) : null;
}
function getInputValue(el, tagName, type) {
  if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) {
    return el.getAttribute('value') || '';
  }
  return el.value;
}
function extractFileExtension(path, baseURL) {
  var url;
  try {
    url = new URL(path, _nullishCoalesce$1(baseURL, function () {
      return window.location.href;
    }));
  } catch (err) {
    return null;
  }
  var regex = /\.([0-9a-z]+)(?:$)/i;
  var match = url.pathname.match(regex);
  return _nullishCoalesce$1(_optionalChain$5([match, 'optionalAccess', function (_6) {
    return _6[1];
  }]), function () {
    return null;
  });
}
var cachedImplementations$1 = {};
function getImplementation$1(name) {
  var cached = cachedImplementations$1[name];
  if (cached) {
    return cached;
  }
  var document = window.document;
  var impl = window[name];
  if (document && typeof document.createElement === 'function') {
    try {
      var sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      var contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow[name]) {
        impl = contentWindow[name];
      }
      document.head.removeChild(sandbox);
    } catch (e) {}
  }
  return cachedImplementations$1[name] = impl.bind(window);
}
function setTimeout$2() {
  return getImplementation$1('setTimeout').apply(void 0, arguments);
}
function clearTimeout$2() {
  return getImplementation$1('clearTimeout').apply(void 0, arguments);
}
function getIframeContentDocument(iframe) {
  try {
    return iframe.contentDocument;
  } catch (e) {}
}
var _id = 1;
var tagNameRegex = new RegExp('[^a-z0-9-_:]');
var IGNORED_NODE = -2;
function genId() {
  return _id++;
}
function getValidTagName(element) {
  if (element instanceof HTMLFormElement) {
    return 'form';
  }
  var processedTagName = toLowerCase(element.tagName);
  if (tagNameRegex.test(processedTagName)) {
    return 'div';
  }
  return processedTagName;
}
function extractOrigin(url) {
  var origin = '';
  if (url.indexOf('//') > -1) {
    origin = url.split('/').slice(0, 3).join('/');
  } else {
    origin = url.split('/')[0];
  }
  origin = origin.split('?')[0];
  return origin;
}
var canvasService;
var canvasCtx;
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var URL_WWW_MATCH = /^www\..*/i;
var DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
  return (cssText || '').replace(URL_IN_CSS_REF, function (origin, quote1, path1, quote2, path2, path3) {
    var filePath = path1 || path2 || path3;
    var maybeQuote = quote1 || quote2 || '';
    if (!filePath) {
      return origin;
    }
    if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) {
      return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
    }
    if (DATA_URI.test(filePath)) {
      return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
    }
    if (filePath[0] === '/') {
      return "url(".concat(maybeQuote).concat(extractOrigin(href) + filePath).concat(maybeQuote, ")");
    }
    var stack = href.split('/');
    var parts = filePath.split('/');
    stack.pop();
    var _iterator = _createForOfIteratorHelper(parts),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var part = _step.value;
        if (part === '.') {
          continue;
        } else if (part === '..') {
          stack.pop();
        } else {
          stack.push(part);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return "url(".concat(maybeQuote).concat(stack.join('/')).concat(maybeQuote, ")");
  });
}
var SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
  if (attributeValue.trim() === '') {
    return attributeValue;
  }
  var pos = 0;
  function collectCharacters(regEx) {
    var chars;
    var match = regEx.exec(attributeValue.substring(pos));
    if (match) {
      chars = match[0];
      pos += chars.length;
      return chars;
    }
    return '';
  }
  var output = [];
  while (true) {
    collectCharacters(SRCSET_COMMAS_OR_SPACES);
    if (pos >= attributeValue.length) {
      break;
    }
    var url = collectCharacters(SRCSET_NOT_SPACES);
    if (url.slice(-1) === ',') {
      url = absoluteToDoc(doc, url.substring(0, url.length - 1));
      output.push(url);
    } else {
      var descriptorsStr = '';
      url = absoluteToDoc(doc, url);
      var inParens = false;
      while (true) {
        var c = attributeValue.charAt(pos);
        if (c === '') {
          output.push((url + descriptorsStr).trim());
          break;
        } else if (!inParens) {
          if (c === ',') {
            pos += 1;
            output.push((url + descriptorsStr).trim());
            break;
          } else if (c === '(') {
            inParens = true;
          }
        } else {
          if (c === ')') {
            inParens = false;
          }
        }
        descriptorsStr += c;
        pos += 1;
      }
    }
  }
  return output.join(', ');
}
var cachedDocument = new WeakMap();
function absoluteToDoc(doc, attributeValue) {
  if (!attributeValue || attributeValue.trim() === '') {
    return attributeValue;
  }
  return getHref(doc, attributeValue);
}
function isSVGElement(el) {
  return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function getHref(doc, customHref) {
  var a = cachedDocument.get(doc);
  if (!a) {
    a = doc.createElement('a');
    cachedDocument.set(doc, a);
  }
  if (!customHref) {
    customHref = '';
  } else if (customHref.startsWith('blob:') || customHref.startsWith('data:')) {
    return customHref;
  }
  a.setAttribute('href', customHref);
  return a.href;
}
function transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
  if (!value) {
    return value;
  }
  if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) {
    return absoluteToDoc(doc, value);
  } else if (name === 'xlink:href' && value[0] !== '#') {
    return absoluteToDoc(doc, value);
  } else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) {
    return absoluteToDoc(doc, value);
  } else if (name === 'srcset') {
    return getAbsoluteSrcsetString(doc, value);
  } else if (name === 'style') {
    return absoluteToStylesheet(value, getHref(doc));
  } else if (tagName === 'object' && name === 'data') {
    return absoluteToDoc(doc, value);
  }
  if (typeof maskAttributeFn === 'function') {
    return maskAttributeFn(name, value, element);
  }
  return value;
}
function ignoreAttribute(tagName, name, _value) {
  return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
  try {
    if (unblockSelector && element.matches(unblockSelector)) {
      return false;
    }
    if (typeof blockClass === 'string') {
      if (element.classList.contains(blockClass)) {
        return true;
      }
    } else {
      for (var eIndex = element.classList.length; eIndex--;) {
        var className = element.classList[eIndex];
        if (blockClass.test(className)) {
          return true;
        }
      }
    }
    if (blockSelector) {
      return element.matches(blockSelector);
    }
  } catch (e) {}
  return false;
}
function elementClassMatchesRegex(el, regex) {
  for (var eIndex = el.classList.length; eIndex--;) {
    var className = el.classList[eIndex];
    if (regex.test(className)) {
      return true;
    }
  }
  return false;
}
function distanceToMatch(node, matchPredicate) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var distance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (!node) return -1;
  if (node.nodeType !== node.ELEMENT_NODE) return -1;
  if (distance > limit) return -1;
  if (matchPredicate(node)) return distance;
  return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
  return function (node) {
    var el = node;
    if (el === null) return false;
    try {
      if (className) {
        if (typeof className === 'string') {
          if (el.matches(".".concat(className))) return true;
        } else if (elementClassMatchesRegex(el, className)) {
          return true;
        }
      }
      if (selector && el.matches(selector)) return true;
      return false;
    } catch (e2) {
      return false;
    }
  };
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
  try {
    var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (el === null) return false;
    if (el.tagName === 'INPUT') {
      var autocomplete = el.getAttribute('autocomplete');
      var disallowedAutocompleteValues = ['current-password', 'new-password', 'cc-number', 'cc-exp', 'cc-exp-month', 'cc-exp-year', 'cc-csc'];
      if (disallowedAutocompleteValues.includes(autocomplete)) {
        return true;
      }
    }
    var maskDistance = -1;
    var unmaskDistance = -1;
    if (maskAllText) {
      unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector));
      if (unmaskDistance < 0) {
        return true;
      }
      maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
    } else {
      maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector));
      if (maskDistance < 0) {
        return false;
      }
      unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
    }
    return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
  } catch (e) {}
  return !!maskAllText;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
  var win = iframeEl.contentWindow;
  if (!win) {
    return;
  }
  var fired = false;
  var readyState;
  try {
    readyState = win.document.readyState;
  } catch (error) {
    return;
  }
  if (readyState !== 'complete') {
    var timer = setTimeout$2(function () {
      if (!fired) {
        listener();
        fired = true;
      }
    }, iframeLoadTimeout);
    iframeEl.addEventListener('load', function () {
      clearTimeout$2(timer);
      fired = true;
      listener();
    });
    return;
  }
  var blankUrl = 'about:blank';
  if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
    setTimeout$2(listener, 0);
    return iframeEl.addEventListener('load', listener);
  }
  iframeEl.addEventListener('load', listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
  var fired = false;
  var styleSheetLoaded;
  try {
    styleSheetLoaded = link.sheet;
  } catch (error) {
    return;
  }
  if (styleSheetLoaded) return;
  var timer = setTimeout$2(function () {
    if (!fired) {
      listener();
      fired = true;
    }
  }, styleSheetLoadTimeout);
  link.addEventListener('load', function () {
    clearTimeout$2(timer);
    fired = true;
    listener();
  });
}
function serializeNode(n, options) {
  var doc = options.doc,
    mirror = options.mirror,
    blockClass = options.blockClass,
    blockSelector = options.blockSelector,
    unblockSelector = options.unblockSelector,
    maskAllText = options.maskAllText,
    maskAttributeFn = options.maskAttributeFn,
    maskTextClass = options.maskTextClass,
    unmaskTextClass = options.unmaskTextClass,
    maskTextSelector = options.maskTextSelector,
    unmaskTextSelector = options.unmaskTextSelector,
    inlineStylesheet = options.inlineStylesheet,
    _options$maskInputOpt = options.maskInputOptions,
    maskInputOptions = _options$maskInputOpt === void 0 ? {} : _options$maskInputOpt,
    maskTextFn = options.maskTextFn,
    maskInputFn = options.maskInputFn,
    _options$dataURLOptio = options.dataURLOptions,
    dataURLOptions = _options$dataURLOptio === void 0 ? {} : _options$dataURLOptio,
    inlineImages = options.inlineImages,
    recordCanvas = options.recordCanvas,
    keepIframeSrcFn = options.keepIframeSrcFn,
    _options$newlyAddedEl = options.newlyAddedElement,
    newlyAddedElement = _options$newlyAddedEl === void 0 ? false : _options$newlyAddedEl;
  var rootId = getRootId(doc, mirror);
  switch (n.nodeType) {
    case n.DOCUMENT_NODE:
      if (n.compatMode !== 'CSS1Compat') {
        return {
          type: NodeType$3.Document,
          childNodes: [],
          compatMode: n.compatMode
        };
      } else {
        return {
          type: NodeType$3.Document,
          childNodes: []
        };
      }
    case n.DOCUMENT_TYPE_NODE:
      return {
        type: NodeType$3.DocumentType,
        name: n.name,
        publicId: n.publicId,
        systemId: n.systemId,
        rootId: rootId
      };
    case n.ELEMENT_NODE:
      return serializeElementNode(n, {
        doc: doc,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        inlineStylesheet: inlineStylesheet,
        maskAttributeFn: maskAttributeFn,
        maskInputOptions: maskInputOptions,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        rootId: rootId,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector
      });
    case n.TEXT_NODE:
      return serializeTextNode(n, {
        doc: doc,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        maskTextFn: maskTextFn,
        maskInputOptions: maskInputOptions,
        maskInputFn: maskInputFn,
        rootId: rootId
      });
    case n.CDATA_SECTION_NODE:
      return {
        type: NodeType$3.CDATA,
        textContent: '',
        rootId: rootId
      };
    case n.COMMENT_NODE:
      return {
        type: NodeType$3.Comment,
        textContent: n.textContent || '',
        rootId: rootId
      };
    default:
      return false;
  }
}
function getRootId(doc, mirror) {
  if (!mirror.hasNode(doc)) return undefined;
  var docId = mirror.getId(doc);
  return docId === 1 ? undefined : docId;
}
function serializeTextNode(n, options) {
  var maskAllText = options.maskAllText,
    maskTextClass = options.maskTextClass,
    unmaskTextClass = options.unmaskTextClass,
    maskTextSelector = options.maskTextSelector,
    unmaskTextSelector = options.unmaskTextSelector,
    maskTextFn = options.maskTextFn,
    maskInputOptions = options.maskInputOptions,
    maskInputFn = options.maskInputFn,
    rootId = options.rootId;
  var parentTagName = n.parentNode && n.parentNode.tagName;
  var textContent = n.textContent;
  var isStyle = parentTagName === 'STYLE' ? true : undefined;
  var isScript = parentTagName === 'SCRIPT' ? true : undefined;
  var isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
  if (isStyle && textContent) {
    try {
      if (n.nextSibling || n.previousSibling) {} else if (_optionalChain$5([n, 'access', function (_7) {
        return _7.parentNode;
      }, 'access', function (_8) {
        return _8.sheet;
      }, 'optionalAccess', function (_9) {
        return _9.cssRules;
      }])) {
        textContent = stringifyStylesheet(n.parentNode.sheet);
      }
    } catch (err) {
      console.warn("Cannot get CSS styles from text's parentNode. Error: ".concat(err), n);
    }
    textContent = absoluteToStylesheet(textContent, getHref(options.doc));
  }
  if (isScript) {
    textContent = 'SCRIPT_PLACEHOLDER';
  }
  var forceMask = needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
  if (!isStyle && !isScript && !isTextarea && textContent && forceMask) {
    textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
  }
  if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) {
    textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
  }
  if (parentTagName === 'OPTION' && textContent) {
    var isInputMasked = shouldMaskInput({
      type: null,
      tagName: parentTagName,
      maskInputOptions: maskInputOptions
    });
    textContent = maskInputValue({
      isMasked: needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
      element: n,
      value: textContent,
      maskInputFn: maskInputFn
    });
  }
  return {
    type: NodeType$3.Text,
    textContent: textContent || '',
    isStyle: isStyle,
    rootId: rootId
  };
}
function serializeElementNode(n, options) {
  var doc = options.doc,
    blockClass = options.blockClass,
    blockSelector = options.blockSelector,
    unblockSelector = options.unblockSelector,
    inlineStylesheet = options.inlineStylesheet,
    _options$maskInputOpt2 = options.maskInputOptions,
    maskInputOptions = _options$maskInputOpt2 === void 0 ? {} : _options$maskInputOpt2,
    maskAttributeFn = options.maskAttributeFn,
    maskInputFn = options.maskInputFn,
    _options$dataURLOptio2 = options.dataURLOptions,
    dataURLOptions = _options$dataURLOptio2 === void 0 ? {} : _options$dataURLOptio2,
    inlineImages = options.inlineImages,
    recordCanvas = options.recordCanvas,
    keepIframeSrcFn = options.keepIframeSrcFn,
    _options$newlyAddedEl2 = options.newlyAddedElement,
    newlyAddedElement = _options$newlyAddedEl2 === void 0 ? false : _options$newlyAddedEl2,
    rootId = options.rootId,
    maskAllText = options.maskAllText,
    maskTextClass = options.maskTextClass,
    unmaskTextClass = options.unmaskTextClass,
    maskTextSelector = options.maskTextSelector,
    unmaskTextSelector = options.unmaskTextSelector;
  var needBlock = _isBlockedElement(n, blockClass, blockSelector, unblockSelector);
  var tagName = getValidTagName(n);
  var attributes = {};
  var len = n.attributes.length;
  for (var i = 0; i < len; i++) {
    var attr = n.attributes[i];
    if (attr.name && !ignoreAttribute(tagName, attr.name, attr.value)) {
      attributes[attr.name] = transformAttribute(doc, tagName, toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
  }
  if (tagName === 'link' && inlineStylesheet) {
    var stylesheet = Array.from(doc.styleSheets).find(function (s) {
      return s.href === n.href;
    });
    var cssText = null;
    if (stylesheet) {
      cssText = stringifyStylesheet(stylesheet);
    }
    if (cssText) {
      attributes.rel = null;
      attributes.href = null;
      attributes.crossorigin = null;
      attributes._cssText = absoluteToStylesheet(cssText, stylesheet.href);
    }
  }
  if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
    var _cssText = stringifyStylesheet(n.sheet);
    if (_cssText) {
      attributes._cssText = absoluteToStylesheet(_cssText, getHref(doc));
    }
  }
  if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
    var el = n;
    var type = getInputType(el);
    var value = getInputValue(el, toUpperCase(tagName), type);
    var checked = el.checked;
    if (type !== 'submit' && type !== 'button' && value) {
      var forceMask = needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, shouldMaskInput({
        type: type,
        tagName: toUpperCase(tagName),
        maskInputOptions: maskInputOptions
      }));
      attributes.value = maskInputValue({
        isMasked: forceMask,
        element: el,
        value: value,
        maskInputFn: maskInputFn
      });
    }
    if (checked) {
      attributes.checked = checked;
    }
  }
  if (tagName === 'option') {
    if (n.selected && !maskInputOptions['select']) {
      attributes.selected = true;
    } else {
      delete attributes.selected;
    }
  }
  if (tagName === 'canvas' && recordCanvas) {
    if (n.__context === '2d') {
      if (!is2DCanvasBlank(n)) {
        attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      }
    } else if (!('__context' in n)) {
      var canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      var blankCanvas = doc.createElement('canvas');
      blankCanvas.width = n.width;
      blankCanvas.height = n.height;
      var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      if (canvasDataURL !== blankCanvasDataURL) {
        attributes.rr_dataURL = canvasDataURL;
      }
    }
  }
  if (tagName === 'img' && inlineImages) {
    if (!canvasService) {
      canvasService = doc.createElement('canvas');
      canvasCtx = canvasService.getContext('2d');
    }
    var image = n;
    var imageSrc = image.currentSrc || image.getAttribute('src') || '<unknown-src>';
    var priorCrossOrigin = image.crossOrigin;
    var recordInlineImage = function recordInlineImage() {
      image.removeEventListener('load', recordInlineImage);
      try {
        canvasService.width = image.naturalWidth;
        canvasService.height = image.naturalHeight;
        canvasCtx.drawImage(image, 0, 0);
        attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      } catch (err) {
        if (image.crossOrigin !== 'anonymous') {
          image.crossOrigin = 'anonymous';
          if (image.complete && image.naturalWidth !== 0) recordInlineImage();else image.addEventListener('load', recordInlineImage);
          return;
        } else {
          console.warn("Cannot inline img src=".concat(imageSrc, "! Error: ").concat(err));
        }
      }
      if (image.crossOrigin === 'anonymous') {
        priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute('crossorigin');
      }
    };
    if (image.complete && image.naturalWidth !== 0) recordInlineImage();else image.addEventListener('load', recordInlineImage);
  }
  if (tagName === 'audio' || tagName === 'video') {
    attributes.rr_mediaState = n.paused ? 'paused' : 'played';
    attributes.rr_mediaCurrentTime = n.currentTime;
  }
  if (!newlyAddedElement) {
    if (n.scrollLeft) {
      attributes.rr_scrollLeft = n.scrollLeft;
    }
    if (n.scrollTop) {
      attributes.rr_scrollTop = n.scrollTop;
    }
  }
  if (needBlock) {
    var _n$getBoundingClientR = n.getBoundingClientRect(),
      width = _n$getBoundingClientR.width,
      height = _n$getBoundingClientR.height;
    attributes = {
      class: attributes.class,
      rr_width: "".concat(width, "px"),
      rr_height: "".concat(height, "px")
    };
  }
  if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
    if (!needBlock && !getIframeContentDocument(n)) {
      attributes.rr_src = attributes.src;
    }
    delete attributes.src;
  }
  var isCustomElement;
  try {
    if (customElements.get(tagName)) isCustomElement = true;
  } catch (e) {}
  return {
    type: NodeType$3.Element,
    tagName: tagName,
    attributes: attributes,
    childNodes: [],
    isSVG: isSVGElement(n) || undefined,
    needBlock: needBlock,
    rootId: rootId,
    isCustom: isCustomElement
  };
}
function lowerIfExists(maybeAttr) {
  if (maybeAttr === undefined || maybeAttr === null) {
    return '';
  } else {
    return maybeAttr.toLowerCase();
  }
}
function slimDOMExcluded(sn, slimDOMOptions) {
  if (slimDOMOptions.comment && sn.type === NodeType$3.Comment) {
    return true;
  } else if (sn.type === NodeType$3.Element) {
    if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && extractFileExtension(sn.attributes.href) === 'js')) {
      return true;
    } else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || lowerIfExists(sn.attributes.name) === 'application-name' || lowerIfExists(sn.attributes.rel) === 'icon' || lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) {
      return true;
    } else if (sn.tagName === 'meta') {
      if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
        return true;
      } else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === 'pinterest')) {
        return true;
      } else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === 'robots' || lowerIfExists(sn.attributes.name) === 'googlebot' || lowerIfExists(sn.attributes.name) === 'bingbot')) {
        return true;
      } else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) {
        return true;
      } else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === 'author' || lowerIfExists(sn.attributes.name) === 'generator' || lowerIfExists(sn.attributes.name) === 'framework' || lowerIfExists(sn.attributes.name) === 'publisher' || lowerIfExists(sn.attributes.name) === 'progid' || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) {
        return true;
      } else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === 'google-site-verification' || lowerIfExists(sn.attributes.name) === 'yandex-verification' || lowerIfExists(sn.attributes.name) === 'csrf-token' || lowerIfExists(sn.attributes.name) === 'p:domain_verify' || lowerIfExists(sn.attributes.name) === 'verify-v1' || lowerIfExists(sn.attributes.name) === 'verification' || lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) {
        return true;
      }
    }
  }
  return false;
}
function serializeNodeWithId(n, options) {
  var doc = options.doc,
    mirror = options.mirror,
    blockClass = options.blockClass,
    blockSelector = options.blockSelector,
    unblockSelector = options.unblockSelector,
    maskAllText = options.maskAllText,
    maskTextClass = options.maskTextClass,
    unmaskTextClass = options.unmaskTextClass,
    maskTextSelector = options.maskTextSelector,
    unmaskTextSelector = options.unmaskTextSelector,
    _options$skipChild = options.skipChild,
    skipChild = _options$skipChild === void 0 ? false : _options$skipChild,
    _options$inlineStyles = options.inlineStylesheet,
    inlineStylesheet = _options$inlineStyles === void 0 ? true : _options$inlineStyles,
    _options$maskInputOpt3 = options.maskInputOptions,
    maskInputOptions = _options$maskInputOpt3 === void 0 ? {} : _options$maskInputOpt3,
    maskAttributeFn = options.maskAttributeFn,
    maskTextFn = options.maskTextFn,
    maskInputFn = options.maskInputFn,
    slimDOMOptions = options.slimDOMOptions,
    _options$dataURLOptio3 = options.dataURLOptions,
    dataURLOptions = _options$dataURLOptio3 === void 0 ? {} : _options$dataURLOptio3,
    _options$inlineImages = options.inlineImages,
    inlineImages = _options$inlineImages === void 0 ? false : _options$inlineImages,
    _options$recordCanvas = options.recordCanvas,
    recordCanvas = _options$recordCanvas === void 0 ? false : _options$recordCanvas,
    onSerialize = options.onSerialize,
    onIframeLoad = options.onIframeLoad,
    _options$iframeLoadTi = options.iframeLoadTimeout,
    iframeLoadTimeout = _options$iframeLoadTi === void 0 ? 5000 : _options$iframeLoadTi,
    onStylesheetLoad = options.onStylesheetLoad,
    _options$stylesheetLo = options.stylesheetLoadTimeout,
    stylesheetLoadTimeout = _options$stylesheetLo === void 0 ? 5000 : _options$stylesheetLo,
    _options$keepIframeSr = options.keepIframeSrcFn,
    keepIframeSrcFn = _options$keepIframeSr === void 0 ? function () {
      return false;
    } : _options$keepIframeSr,
    _options$newlyAddedEl3 = options.newlyAddedElement,
    newlyAddedElement = _options$newlyAddedEl3 === void 0 ? false : _options$newlyAddedEl3;
  var _options$preserveWhit = options.preserveWhiteSpace,
    preserveWhiteSpace = _options$preserveWhit === void 0 ? true : _options$preserveWhit;
  var _serializedNode = serializeNode(n, {
    doc: doc,
    mirror: mirror,
    blockClass: blockClass,
    blockSelector: blockSelector,
    maskAllText: maskAllText,
    unblockSelector: unblockSelector,
    maskTextClass: maskTextClass,
    unmaskTextClass: unmaskTextClass,
    maskTextSelector: maskTextSelector,
    unmaskTextSelector: unmaskTextSelector,
    inlineStylesheet: inlineStylesheet,
    maskInputOptions: maskInputOptions,
    maskAttributeFn: maskAttributeFn,
    maskTextFn: maskTextFn,
    maskInputFn: maskInputFn,
    dataURLOptions: dataURLOptions,
    inlineImages: inlineImages,
    recordCanvas: recordCanvas,
    keepIframeSrcFn: keepIframeSrcFn,
    newlyAddedElement: newlyAddedElement
  });
  if (!_serializedNode) {
    console.warn(n, 'not serialized');
    return null;
  }
  var id;
  if (mirror.hasNode(n)) {
    id = mirror.getId(n);
  } else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$3.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) {
    id = IGNORED_NODE;
  } else {
    id = genId();
  }
  var serializedNode = Object.assign(_serializedNode, {
    id: id
  });
  mirror.add(n, serializedNode);
  if (id === IGNORED_NODE) {
    return null;
  }
  if (onSerialize) {
    onSerialize(n);
  }
  var recordChild = !skipChild;
  if (serializedNode.type === NodeType$3.Element) {
    recordChild = recordChild && !serializedNode.needBlock;
    delete serializedNode.needBlock;
    var shadowRoot = n.shadowRoot;
    if (shadowRoot && isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
  }
  if ((serializedNode.type === NodeType$3.Document || serializedNode.type === NodeType$3.Element) && recordChild) {
    if (slimDOMOptions.headWhitespace && serializedNode.type === NodeType$3.Element && serializedNode.tagName === 'head') {
      preserveWhiteSpace = false;
    }
    var bypassOptions = {
      doc: doc,
      mirror: mirror,
      blockClass: blockClass,
      blockSelector: blockSelector,
      maskAllText: maskAllText,
      unblockSelector: unblockSelector,
      maskTextClass: maskTextClass,
      unmaskTextClass: unmaskTextClass,
      maskTextSelector: maskTextSelector,
      unmaskTextSelector: unmaskTextSelector,
      skipChild: skipChild,
      inlineStylesheet: inlineStylesheet,
      maskInputOptions: maskInputOptions,
      maskAttributeFn: maskAttributeFn,
      maskTextFn: maskTextFn,
      maskInputFn: maskInputFn,
      slimDOMOptions: slimDOMOptions,
      dataURLOptions: dataURLOptions,
      inlineImages: inlineImages,
      recordCanvas: recordCanvas,
      preserveWhiteSpace: preserveWhiteSpace,
      onSerialize: onSerialize,
      onIframeLoad: onIframeLoad,
      iframeLoadTimeout: iframeLoadTimeout,
      onStylesheetLoad: onStylesheetLoad,
      stylesheetLoadTimeout: stylesheetLoadTimeout,
      keepIframeSrcFn: keepIframeSrcFn
    };
    for (var _i = 0, _Array$from = Array.from(n.childNodes); _i < _Array$from.length; _i++) {
      var childN = _Array$from[_i];
      var serializedChildNode = serializeNodeWithId(childN, bypassOptions);
      if (serializedChildNode) {
        serializedNode.childNodes.push(serializedChildNode);
      }
    }
    if (isElement$1(n) && n.shadowRoot) {
      for (var _i2 = 0, _Array$from2 = Array.from(n.shadowRoot.childNodes); _i2 < _Array$from2.length; _i2++) {
        var _childN = _Array$from2[_i2];
        var _serializedChildNode = serializeNodeWithId(_childN, bypassOptions);
        if (_serializedChildNode) {
          isNativeShadowDom(n.shadowRoot) && (_serializedChildNode.isShadow = true);
          serializedNode.childNodes.push(_serializedChildNode);
        }
      }
    }
  }
  if (n.parentNode && isShadowRoot(n.parentNode) && isNativeShadowDom(n.parentNode)) {
    serializedNode.isShadow = true;
  }
  if (serializedNode.type === NodeType$3.Element && serializedNode.tagName === 'iframe') {
    onceIframeLoaded(n, function () {
      var iframeDoc = getIframeContentDocument(n);
      if (iframeDoc && onIframeLoad) {
        var serializedIframeNode = serializeNodeWithId(iframeDoc, {
          doc: iframeDoc,
          mirror: mirror,
          blockClass: blockClass,
          blockSelector: blockSelector,
          unblockSelector: unblockSelector,
          maskAllText: maskAllText,
          maskTextClass: maskTextClass,
          unmaskTextClass: unmaskTextClass,
          maskTextSelector: maskTextSelector,
          unmaskTextSelector: unmaskTextSelector,
          skipChild: false,
          inlineStylesheet: inlineStylesheet,
          maskInputOptions: maskInputOptions,
          maskAttributeFn: maskAttributeFn,
          maskTextFn: maskTextFn,
          maskInputFn: maskInputFn,
          slimDOMOptions: slimDOMOptions,
          dataURLOptions: dataURLOptions,
          inlineImages: inlineImages,
          recordCanvas: recordCanvas,
          preserveWhiteSpace: preserveWhiteSpace,
          onSerialize: onSerialize,
          onIframeLoad: onIframeLoad,
          iframeLoadTimeout: iframeLoadTimeout,
          onStylesheetLoad: onStylesheetLoad,
          stylesheetLoadTimeout: stylesheetLoadTimeout,
          keepIframeSrcFn: keepIframeSrcFn
        });
        if (serializedIframeNode) {
          onIframeLoad(n, serializedIframeNode);
        }
      }
    }, iframeLoadTimeout);
  }
  if (serializedNode.type === NodeType$3.Element && serializedNode.tagName === 'link' && typeof serializedNode.attributes.rel === 'string' && (serializedNode.attributes.rel === 'stylesheet' || serializedNode.attributes.rel === 'preload' && typeof serializedNode.attributes.href === 'string' && extractFileExtension(serializedNode.attributes.href) === 'css')) {
    onceStylesheetLoaded(n, function () {
      if (onStylesheetLoad) {
        var serializedLinkNode = serializeNodeWithId(n, {
          doc: doc,
          mirror: mirror,
          blockClass: blockClass,
          blockSelector: blockSelector,
          unblockSelector: unblockSelector,
          maskAllText: maskAllText,
          maskTextClass: maskTextClass,
          unmaskTextClass: unmaskTextClass,
          maskTextSelector: maskTextSelector,
          unmaskTextSelector: unmaskTextSelector,
          skipChild: false,
          inlineStylesheet: inlineStylesheet,
          maskInputOptions: maskInputOptions,
          maskAttributeFn: maskAttributeFn,
          maskTextFn: maskTextFn,
          maskInputFn: maskInputFn,
          slimDOMOptions: slimDOMOptions,
          dataURLOptions: dataURLOptions,
          inlineImages: inlineImages,
          recordCanvas: recordCanvas,
          preserveWhiteSpace: preserveWhiteSpace,
          onSerialize: onSerialize,
          onIframeLoad: onIframeLoad,
          iframeLoadTimeout: iframeLoadTimeout,
          onStylesheetLoad: onStylesheetLoad,
          stylesheetLoadTimeout: stylesheetLoadTimeout,
          keepIframeSrcFn: keepIframeSrcFn
        });
        if (serializedLinkNode) {
          onStylesheetLoad(n, serializedLinkNode);
        }
      }
    }, stylesheetLoadTimeout);
  }
  return serializedNode;
}
function snapshot(n, options) {
  var _ref3 = options || {},
    _ref3$mirror = _ref3.mirror,
    mirror = _ref3$mirror === void 0 ? new Mirror() : _ref3$mirror,
    _ref3$blockClass = _ref3.blockClass,
    blockClass = _ref3$blockClass === void 0 ? 'rr-block' : _ref3$blockClass,
    _ref3$blockSelector = _ref3.blockSelector,
    blockSelector = _ref3$blockSelector === void 0 ? null : _ref3$blockSelector,
    _ref3$unblockSelector = _ref3.unblockSelector,
    unblockSelector = _ref3$unblockSelector === void 0 ? null : _ref3$unblockSelector,
    _ref3$maskAllText = _ref3.maskAllText,
    maskAllText = _ref3$maskAllText === void 0 ? false : _ref3$maskAllText,
    _ref3$maskTextClass = _ref3.maskTextClass,
    maskTextClass = _ref3$maskTextClass === void 0 ? 'rr-mask' : _ref3$maskTextClass,
    _ref3$unmaskTextClass = _ref3.unmaskTextClass,
    unmaskTextClass = _ref3$unmaskTextClass === void 0 ? null : _ref3$unmaskTextClass,
    _ref3$maskTextSelecto = _ref3.maskTextSelector,
    maskTextSelector = _ref3$maskTextSelecto === void 0 ? null : _ref3$maskTextSelecto,
    _ref3$unmaskTextSelec = _ref3.unmaskTextSelector,
    unmaskTextSelector = _ref3$unmaskTextSelec === void 0 ? null : _ref3$unmaskTextSelec,
    _ref3$inlineStyleshee = _ref3.inlineStylesheet,
    inlineStylesheet = _ref3$inlineStyleshee === void 0 ? true : _ref3$inlineStyleshee,
    _ref3$inlineImages = _ref3.inlineImages,
    inlineImages = _ref3$inlineImages === void 0 ? false : _ref3$inlineImages,
    _ref3$recordCanvas = _ref3.recordCanvas,
    recordCanvas = _ref3$recordCanvas === void 0 ? false : _ref3$recordCanvas,
    _ref3$maskAllInputs = _ref3.maskAllInputs,
    maskAllInputs = _ref3$maskAllInputs === void 0 ? false : _ref3$maskAllInputs,
    maskAttributeFn = _ref3.maskAttributeFn,
    maskTextFn = _ref3.maskTextFn,
    maskInputFn = _ref3.maskInputFn,
    _ref3$slimDOM = _ref3.slimDOM,
    slimDOM = _ref3$slimDOM === void 0 ? false : _ref3$slimDOM,
    dataURLOptions = _ref3.dataURLOptions,
    preserveWhiteSpace = _ref3.preserveWhiteSpace,
    onSerialize = _ref3.onSerialize,
    onIframeLoad = _ref3.onIframeLoad,
    iframeLoadTimeout = _ref3.iframeLoadTimeout,
    onStylesheetLoad = _ref3.onStylesheetLoad,
    stylesheetLoadTimeout = _ref3.stylesheetLoadTimeout,
    _ref3$keepIframeSrcFn = _ref3.keepIframeSrcFn,
    keepIframeSrcFn = _ref3$keepIframeSrcFn === void 0 ? function () {
      return false;
    } : _ref3$keepIframeSrcFn;
  var maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    'datetime-local': true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true
  } : maskAllInputs === false ? {} : maskAllInputs;
  var slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaDescKeywords: slimDOM === 'all',
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaAuthorship: true,
    headMetaVerification: true
  } : slimDOM === false ? {} : slimDOM;
  return serializeNodeWithId(n, {
    doc: n,
    mirror: mirror,
    blockClass: blockClass,
    blockSelector: blockSelector,
    unblockSelector: unblockSelector,
    maskAllText: maskAllText,
    maskTextClass: maskTextClass,
    unmaskTextClass: unmaskTextClass,
    maskTextSelector: maskTextSelector,
    unmaskTextSelector: unmaskTextSelector,
    skipChild: false,
    inlineStylesheet: inlineStylesheet,
    maskInputOptions: maskInputOptions,
    maskAttributeFn: maskAttributeFn,
    maskTextFn: maskTextFn,
    maskInputFn: maskInputFn,
    slimDOMOptions: slimDOMOptions,
    dataURLOptions: dataURLOptions,
    inlineImages: inlineImages,
    recordCanvas: recordCanvas,
    preserveWhiteSpace: preserveWhiteSpace,
    onSerialize: onSerialize,
    onIframeLoad: onIframeLoad,
    iframeLoadTimeout: iframeLoadTimeout,
    onStylesheetLoad: onStylesheetLoad,
    stylesheetLoadTimeout: stylesheetLoadTimeout,
    keepIframeSrcFn: keepIframeSrcFn,
    newlyAddedElement: false
  });
}
function _optionalChain$4(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;
  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value3;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return (_value3 = value).call.apply(_value3, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }
  return value;
}
function on(type, fn) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  var options = {
    capture: true,
    passive: true
  };
  target.addEventListener(type, fn, options);
  return function () {
    return target.removeEventListener(type, fn, options);
  };
}
var DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' + '\r\n' + 'now you can use replayer.getMirror() to access the mirror instance of a replayer,' + '\r\n' + 'or you can use record.mirror to access the mirror instance during recording.';
var _mirror = {
  map: {},
  getId: function getId() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return -1;
  },
  getNode: function getNode() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return null;
  },
  removeNodeFromMap: function removeNodeFromMap() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  },
  has: function has() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return false;
  },
  reset: function reset() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
  _mirror = new Proxy(_mirror, {
    get: function get(target, prop, receiver) {
      if (prop === 'map') {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
      }
      return Reflect.get(target, prop, receiver);
    }
  });
}
function throttle$1(func, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout = null;
  var previous = 0;
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    var now = Date.now();
    if (!previous && options.leading === false) {
      previous = now;
    }
    var remaining = wait - (now - previous);
    var context = this;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout$1(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(context, args);
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout$1(function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        func.apply(context, args);
      }, remaining);
    }
  };
}
function hookSetter(target, key, d, isRevoked) {
  var win = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window;
  var original = win.Object.getOwnPropertyDescriptor(target, key);
  win.Object.defineProperty(target, key, isRevoked ? d : {
    set: function set(value) {
      var _this2 = this;
      setTimeout$1(function () {
        d.set.call(_this2, value);
      }, 0);
      if (original && original.set) {
        original.set.call(this, value);
      }
    }
  });
  return function () {
    return hookSetter(target, key, original || {}, true);
  };
}
function patch(source, name, replacement) {
  try {
    if (!(name in source)) {
      return function () {};
    }
    var original = source[name];
    var wrapped = replacement(original);
    if (typeof wrapped === 'function') {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __rrweb_original__: {
          enumerable: false,
          value: original
        }
      });
    }
    source[name] = wrapped;
    return function () {
      source[name] = original;
    };
  } catch (e2) {
    return function () {};
  }
}
var nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) {
  nowTimestamp = function nowTimestamp() {
    return new Date().getTime();
  };
}
function getWindowScroll(win) {
  var doc = win.document;
  return {
    left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : _optionalChain$4([doc, 'optionalAccess', function (_) {
      return _.documentElement;
    }, 'access', function (_2) {
      return _2.scrollLeft;
    }]) || _optionalChain$4([doc, 'optionalAccess', function (_3) {
      return _3.body;
    }, 'optionalAccess', function (_4) {
      return _4.parentElement;
    }, 'optionalAccess', function (_5) {
      return _5.scrollLeft;
    }]) || _optionalChain$4([doc, 'optionalAccess', function (_6) {
      return _6.body;
    }, 'optionalAccess', function (_7) {
      return _7.scrollLeft;
    }]) || 0,
    top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : _optionalChain$4([doc, 'optionalAccess', function (_8) {
      return _8.documentElement;
    }, 'access', function (_9) {
      return _9.scrollTop;
    }]) || _optionalChain$4([doc, 'optionalAccess', function (_10) {
      return _10.body;
    }, 'optionalAccess', function (_11) {
      return _11.parentElement;
    }, 'optionalAccess', function (_12) {
      return _12.scrollTop;
    }]) || _optionalChain$4([doc, 'optionalAccess', function (_13) {
      return _13.body;
    }, 'optionalAccess', function (_14) {
      return _14.scrollTop;
    }]) || 0
  };
}
function getWindowHeight() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function getWindowWidth() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function closestElementOfNode(node) {
  if (!node) {
    return null;
  }
  var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
  return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
  if (!node) {
    return false;
  }
  var el = closestElementOfNode(node);
  if (!el) {
    return false;
  }
  var blockedPredicate = createMatchPredicate(blockClass, blockSelector);
  if (!checkAncestors) {
    var isUnblocked = unblockSelector && el.matches(unblockSelector);
    return blockedPredicate(el) && !isUnblocked;
  }
  var blockDistance = distanceToMatch(el, blockedPredicate);
  var unblockDistance = -1;
  if (blockDistance < 0) {
    return false;
  }
  if (unblockSelector) {
    unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
  }
  if (blockDistance > -1 && unblockDistance < 0) {
    return true;
  }
  return blockDistance < unblockDistance;
}
function isSerialized(n, mirror) {
  return mirror.getId(n) !== -1;
}
function isIgnored(n, mirror) {
  return mirror.getId(n) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror) {
  if (isShadowRoot(target)) {
    return false;
  }
  var id = mirror.getId(target);
  if (!mirror.has(id)) {
    return true;
  }
  if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) {
    return false;
  }
  if (!target.parentNode) {
    return true;
  }
  return isAncestorRemoved(target.parentNode, mirror);
}
function legacy_isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
function polyfill() {
  var _this3 = this;
  var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  if ('NodeList' in win && !win.NodeList.prototype.forEach) {
    win.NodeList.prototype.forEach = Array.prototype.forEach;
  }
  if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) {
    win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
  }
  if (!Node.prototype.contains) {
    Node.prototype.contains = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      var node = args[0];
      if (!(0 in args)) {
        throw new TypeError('1 argument is required');
      }
      do {
        if (_this3 === node) {
          return true;
        }
      } while (node = node && node.parentNode);
      return false;
    };
  }
}
function isSerializedIframe(n, mirror) {
  return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function isSerializedStylesheet(n, mirror) {
  return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function hasShadowRoot(n) {
  return Boolean(_optionalChain$4([n, 'optionalAccess', function (_18) {
    return _18.shadowRoot;
  }]));
}
var StyleSheetMirror = /*#__PURE__*/function () {
  function StyleSheetMirror() {
    _classCallCheck(this, StyleSheetMirror);
    this.id = 1;
    this.styleIDMap = new WeakMap();
    this.idStyleMap = new Map();
  }
  _createClass(StyleSheetMirror, [{
    key: "getId",
    value: function getId(stylesheet) {
      return _nullishCoalesce(this.styleIDMap.get(stylesheet), function () {
        return -1;
      });
    }
  }, {
    key: "has",
    value: function has(stylesheet) {
      return this.styleIDMap.has(stylesheet);
    }
  }, {
    key: "add",
    value: function add(stylesheet, id) {
      if (this.has(stylesheet)) return this.getId(stylesheet);
      var newId;
      if (id === undefined) {
        newId = this.id++;
      } else newId = id;
      this.styleIDMap.set(stylesheet, newId);
      this.idStyleMap.set(newId, stylesheet);
      return newId;
    }
  }, {
    key: "getStyle",
    value: function getStyle(id) {
      return this.idStyleMap.get(id) || null;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.styleIDMap = new WeakMap();
      this.idStyleMap = new Map();
      this.id = 1;
    }
  }, {
    key: "generateId",
    value: function generateId() {
      return this.id++;
    }
  }]);
  return StyleSheetMirror;
}();
function getShadowHost(n) {
  var shadowHost = null;
  if (_optionalChain$4([n, 'access', function (_19) {
    return _19.getRootNode;
  }, 'optionalCall', function (_20) {
    return _20();
  }, 'optionalAccess', function (_21) {
    return _21.nodeType;
  }]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
  return shadowHost;
}
function getRootShadowHost(n) {
  var rootShadowHost = n;
  var shadowHost;
  while (shadowHost = getShadowHost(rootShadowHost)) rootShadowHost = shadowHost;
  return rootShadowHost;
}
function shadowHostInDom(n) {
  var doc = n.ownerDocument;
  if (!doc) return false;
  var shadowHost = getRootShadowHost(n);
  return doc.contains(shadowHost);
}
function inDom(n) {
  var doc = n.ownerDocument;
  if (!doc) return false;
  return doc.contains(n) || shadowHostInDom(n);
}
var cachedImplementations = {};
function getImplementation(name) {
  var cached = cachedImplementations[name];
  if (cached) {
    return cached;
  }
  var document = window.document;
  var impl = window[name];
  if (document && typeof document.createElement === 'function') {
    try {
      var sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      var contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow[name]) {
        impl = contentWindow[name];
      }
      document.head.removeChild(sandbox);
    } catch (e) {}
  }
  return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame() {
  return getImplementation('requestAnimationFrame').apply(void 0, arguments);
}
function setTimeout$1() {
  return getImplementation('setTimeout').apply(void 0, arguments);
}
function clearTimeout$1() {
  return getImplementation('clearTimeout').apply(void 0, arguments);
}
var EventType = /* @__PURE__ */function (EventType2) {
  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
  EventType2[EventType2["Load"] = 1] = "Load";
  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
  EventType2[EventType2["Meta"] = 4] = "Meta";
  EventType2[EventType2["Custom"] = 5] = "Custom";
  EventType2[EventType2["Plugin"] = 6] = "Plugin";
  return EventType2;
}(EventType || {});
var IncrementalSource = /* @__PURE__ */function (IncrementalSource2) {
  IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
  IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
  IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
  IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
  IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
  IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
  IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
  IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
  IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
  IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
  IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
  IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
  IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
  IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
  IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
  IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
  IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
  return IncrementalSource2;
}(IncrementalSource || {});
var MouseInteractions = /* @__PURE__ */function (MouseInteractions2) {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
}(MouseInteractions || {});
var PointerTypes = /* @__PURE__ */function (PointerTypes2) {
  PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
  PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
  PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
  return PointerTypes2;
}(PointerTypes || {});
var NodeType$1;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$1 || (NodeType$1 = {}));
var NodeType$2;
(function (NodeType) {
  NodeType[NodeType["PLACEHOLDER"] = 0] = "PLACEHOLDER";
  NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
  NodeType[NodeType["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
  NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
  NodeType[NodeType["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
  NodeType[NodeType["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
  NodeType[NodeType["ENTITY_NODE"] = 6] = "ENTITY_NODE";
  NodeType[NodeType["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
  NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
  NodeType[NodeType["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
  NodeType[NodeType["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
  NodeType[NodeType["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
})(NodeType$2 || (NodeType$2 = {}));
function getIFrameContentDocument(iframe) {
  try {
    return iframe.contentDocument;
  } catch (e) {}
}
function getIFrameContentWindow(iframe) {
  try {
    return iframe.contentWindow;
  } catch (e) {}
}
function _optionalChain$3(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;
  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value4;
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        return (_value4 = value).call.apply(_value4, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }
  return value;
}
function isNodeInLinkedList(n) {
  return '__ln' in n;
}
var DoubleLinkedList = /*#__PURE__*/function () {
  function DoubleLinkedList() {
    _classCallCheck(this, DoubleLinkedList);
    this.length = 0;
    this.head = null;
    this.tail = null;
  }
  _createClass(DoubleLinkedList, [{
    key: "get",
    value: function get(position) {
      if (position >= this.length) {
        throw new Error('Position outside of list range');
      }
      var current = this.head;
      for (var index = 0; index < position; index++) {
        current = _optionalChain$3([current, 'optionalAccess', function (_) {
          return _.next;
        }]) || null;
      }
      return current;
    }
  }, {
    key: "addNode",
    value: function addNode(n) {
      var node = {
        value: n,
        previous: null,
        next: null
      };
      n.__ln = node;
      if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
        var current = n.previousSibling.__ln.next;
        node.next = current;
        node.previous = n.previousSibling.__ln;
        n.previousSibling.__ln.next = node;
        if (current) {
          current.previous = node;
        }
      } else if (n.nextSibling && isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
        var _current = n.nextSibling.__ln.previous;
        node.previous = _current;
        node.next = n.nextSibling.__ln;
        n.nextSibling.__ln.previous = node;
        if (_current) {
          _current.next = node;
        }
      } else {
        if (this.head) {
          this.head.previous = node;
        }
        node.next = this.head;
        this.head = node;
      }
      if (node.next === null) {
        this.tail = node;
      }
      this.length++;
    }
  }, {
    key: "removeNode",
    value: function removeNode(n) {
      var current = n.__ln;
      if (!this.head) {
        return;
      }
      if (!current.previous) {
        this.head = current.next;
        if (this.head) {
          this.head.previous = null;
        } else {
          this.tail = null;
        }
      } else {
        current.previous.next = current.next;
        if (current.next) {
          current.next.previous = current.previous;
        } else {
          this.tail = current.previous;
        }
      }
      if (n.__ln) {
        delete n.__ln;
      }
      this.length--;
    }
  }]);
  return DoubleLinkedList;
}();
var moveKey = function moveKey(id, parentId) {
  return "".concat(id, "@").concat(parentId);
};
var MutationBuffer = /*#__PURE__*/function () {
  function MutationBuffer() {
    var _this4 = this;
    _classCallCheck(this, MutationBuffer);
    this.frozen = false;
    this.locked = false;
    this.texts = [];
    this.attributes = [];
    this.attributeMap = new WeakMap();
    this.removes = [];
    this.mapRemoves = [];
    this.movedMap = {};
    this.addedSet = new Set();
    this.movedSet = new Set();
    this.droppedSet = new Set();
    this.processMutations = function (mutations) {
      mutations.forEach(_this4.processMutation);
      _this4.emit();
    };
    this.emit = function () {
      if (_this4.frozen || _this4.locked) {
        return;
      }
      var adds = [];
      var addedIds = new Set();
      var addList = new DoubleLinkedList();
      var getNextId = function getNextId(n) {
        var ns = n;
        var nextId = IGNORED_NODE;
        while (nextId === IGNORED_NODE) {
          ns = ns && ns.nextSibling;
          nextId = ns && _this4.mirror.getId(ns);
        }
        return nextId;
      };
      var pushAdd = function pushAdd(n) {
        if (!n.parentNode || !inDom(n)) {
          return;
        }
        var parentId = isShadowRoot(n.parentNode) ? _this4.mirror.getId(getShadowHost(n)) : _this4.mirror.getId(n.parentNode);
        var nextId = getNextId(n);
        if (parentId === -1 || nextId === -1) {
          return addList.addNode(n);
        }
        var sn = serializeNodeWithId(n, {
          doc: _this4.doc,
          mirror: _this4.mirror,
          blockClass: _this4.blockClass,
          blockSelector: _this4.blockSelector,
          maskAllText: _this4.maskAllText,
          unblockSelector: _this4.unblockSelector,
          maskTextClass: _this4.maskTextClass,
          unmaskTextClass: _this4.unmaskTextClass,
          maskTextSelector: _this4.maskTextSelector,
          unmaskTextSelector: _this4.unmaskTextSelector,
          skipChild: true,
          newlyAddedElement: true,
          inlineStylesheet: _this4.inlineStylesheet,
          maskInputOptions: _this4.maskInputOptions,
          maskAttributeFn: _this4.maskAttributeFn,
          maskTextFn: _this4.maskTextFn,
          maskInputFn: _this4.maskInputFn,
          slimDOMOptions: _this4.slimDOMOptions,
          dataURLOptions: _this4.dataURLOptions,
          recordCanvas: _this4.recordCanvas,
          inlineImages: _this4.inlineImages,
          onSerialize: function onSerialize(currentN) {
            if (isSerializedIframe(currentN, _this4.mirror) && !isBlocked(currentN, _this4.blockClass, _this4.blockSelector, _this4.unblockSelector, false)) {
              _this4.iframeManager.addIframe(currentN);
            }
            if (isSerializedStylesheet(currentN, _this4.mirror)) {
              _this4.stylesheetManager.trackLinkElement(currentN);
            }
            if (hasShadowRoot(n)) {
              _this4.shadowDomManager.addShadowRoot(n.shadowRoot, _this4.doc);
            }
          },
          onIframeLoad: function onIframeLoad(iframe, childSn) {
            if (isBlocked(iframe, _this4.blockClass, _this4.blockSelector, _this4.unblockSelector, false)) {
              return;
            }
            _this4.iframeManager.attachIframe(iframe, childSn);
            if (iframe.contentWindow) {
              _this4.canvasManager.addWindow(iframe.contentWindow);
            }
            _this4.shadowDomManager.observeAttachShadow(iframe);
          },
          onStylesheetLoad: function onStylesheetLoad(link, childSn) {
            _this4.stylesheetManager.attachLinkElement(link, childSn);
          }
        });
        if (sn) {
          adds.push({
            parentId: parentId,
            nextId: nextId,
            node: sn
          });
          addedIds.add(sn.id);
        }
      };
      while (_this4.mapRemoves.length) {
        _this4.mirror.removeNodeFromMap(_this4.mapRemoves.shift());
      }
      var _iterator2 = _createForOfIteratorHelper(_this4.movedSet),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var n = _step2.value;
          if (isParentRemoved(_this4.removes, n, _this4.mirror) && !_this4.movedSet.has(n.parentNode)) {
            continue;
          }
          pushAdd(n);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(_this4.addedSet),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _n = _step3.value;
          if (!isAncestorInSet(_this4.droppedSet, _n) && !isParentRemoved(_this4.removes, _n, _this4.mirror)) {
            pushAdd(_n);
          } else if (isAncestorInSet(_this4.movedSet, _n)) {
            pushAdd(_n);
          } else {
            _this4.droppedSet.add(_n);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var candidate = null;
      while (addList.length) {
        var node = null;
        if (candidate) {
          var parentId = _this4.mirror.getId(candidate.value.parentNode);
          var nextId = getNextId(candidate.value);
          if (parentId !== -1 && nextId !== -1) {
            node = candidate;
          }
        }
        if (!node) {
          var tailNode = addList.tail;
          while (tailNode) {
            var _node = tailNode;
            tailNode = tailNode.previous;
            if (_node) {
              var _parentId = _this4.mirror.getId(_node.value.parentNode);
              var _nextId = getNextId(_node.value);
              if (_nextId === -1) continue;else if (_parentId !== -1) {
                node = _node;
                break;
              } else {
                var unhandledNode = _node.value;
                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  var shadowHost = unhandledNode.parentNode.host;
                  var _parentId2 = _this4.mirror.getId(shadowHost);
                  if (_parentId2 !== -1) {
                    node = _node;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!node) {
          while (addList.head) {
            addList.removeNode(addList.head.value);
          }
          break;
        }
        candidate = node.previous;
        addList.removeNode(node.value);
        pushAdd(node.value);
      }
      var payload = {
        texts: _this4.texts.map(function (text) {
          return {
            id: _this4.mirror.getId(text.node),
            value: text.value
          };
        }).filter(function (text) {
          return !addedIds.has(text.id);
        }).filter(function (text) {
          return _this4.mirror.has(text.id);
        }),
        attributes: _this4.attributes.map(function (attribute) {
          var attributes = attribute.attributes;
          if (typeof attributes.style === 'string') {
            var diffAsStr = JSON.stringify(attribute.styleDiff);
            var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
            if (diffAsStr.length < attributes.style.length) {
              if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) {
                attributes.style = attribute.styleDiff;
              }
            }
          }
          return {
            id: _this4.mirror.getId(attribute.node),
            attributes: attributes
          };
        }).filter(function (attribute) {
          return !addedIds.has(attribute.id);
        }).filter(function (attribute) {
          return _this4.mirror.has(attribute.id);
        }),
        removes: _this4.removes,
        adds: adds
      };
      if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) {
        return;
      }
      _this4.texts = [];
      _this4.attributes = [];
      _this4.attributeMap = new WeakMap();
      _this4.removes = [];
      _this4.addedSet = new Set();
      _this4.movedSet = new Set();
      _this4.droppedSet = new Set();
      _this4.movedMap = {};
      _this4.mutationCb(payload);
    };
    this.processMutation = function (m) {
      if (isIgnored(m.target, _this4.mirror)) {
        return;
      }
      switch (m.type) {
        case 'characterData':
          {
            var value = m.target.textContent;
            if (!isBlocked(m.target, _this4.blockClass, _this4.blockSelector, _this4.unblockSelector, false) && value !== m.oldValue) {
              _this4.texts.push({
                value: needMaskingText(m.target, _this4.maskTextClass, _this4.maskTextSelector, _this4.unmaskTextClass, _this4.unmaskTextSelector, _this4.maskAllText) && value ? _this4.maskTextFn ? _this4.maskTextFn(value, closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                node: m.target
              });
            }
            break;
          }
        case 'attributes':
          {
            var target = m.target;
            var attributeName = m.attributeName;
            var _value5 = m.target.getAttribute(attributeName);
            if (attributeName === 'value') {
              var type = getInputType(target);
              var tagName = target.tagName;
              _value5 = getInputValue(target, tagName, type);
              var isInputMasked = shouldMaskInput({
                maskInputOptions: _this4.maskInputOptions,
                tagName: tagName,
                type: type
              });
              var forceMask = needMaskingText(m.target, _this4.maskTextClass, _this4.maskTextSelector, _this4.unmaskTextClass, _this4.unmaskTextSelector, isInputMasked);
              _value5 = maskInputValue({
                isMasked: forceMask,
                element: target,
                value: _value5,
                maskInputFn: _this4.maskInputFn
              });
            }
            if (isBlocked(m.target, _this4.blockClass, _this4.blockSelector, _this4.unblockSelector, false) || _value5 === m.oldValue) {
              return;
            }
            var item = _this4.attributeMap.get(m.target);
            if (target.tagName === 'IFRAME' && attributeName === 'src' && !_this4.keepIframeSrcFn(_value5)) {
              var iframeDoc = getIFrameContentDocument(target);
              if (!iframeDoc) {
                attributeName = 'rr_src';
              } else {
                return;
              }
            }
            if (!item) {
              item = {
                node: m.target,
                attributes: {},
                styleDiff: {},
                _unchangedStyles: {}
              };
              _this4.attributes.push(item);
              _this4.attributeMap.set(m.target, item);
            }
            if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') {
              target.setAttribute('data-rr-is-password', 'true');
            }
            if (!ignoreAttribute(target.tagName, attributeName)) {
              item.attributes[attributeName] = transformAttribute(_this4.doc, toLowerCase(target.tagName), toLowerCase(attributeName), _value5, target, _this4.maskAttributeFn);
              if (attributeName === 'style') {
                if (!_this4.unattachedDoc) {
                  try {
                    _this4.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch (e) {
                    _this4.unattachedDoc = _this4.doc;
                  }
                }
                var old = _this4.unattachedDoc.createElement('span');
                if (m.oldValue) {
                  old.setAttribute('style', m.oldValue);
                }
                for (var _i3 = 0, _Array$from3 = Array.from(target.style); _i3 < _Array$from3.length; _i3++) {
                  var pname = _Array$from3[_i3];
                  var newValue = target.style.getPropertyValue(pname);
                  var newPriority = target.style.getPropertyPriority(pname);
                  if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                    if (newPriority === '') {
                      item.styleDiff[pname] = newValue;
                    } else {
                      item.styleDiff[pname] = [newValue, newPriority];
                    }
                  } else {
                    item._unchangedStyles[pname] = [newValue, newPriority];
                  }
                }
                for (var _i4 = 0, _Array$from4 = Array.from(old.style); _i4 < _Array$from4.length; _i4++) {
                  var _pname = _Array$from4[_i4];
                  if (target.style.getPropertyValue(_pname) === '') {
                    item.styleDiff[_pname] = false;
                  }
                }
              }
            }
            break;
          }
        case 'childList':
          {
            if (isBlocked(m.target, _this4.blockClass, _this4.blockSelector, _this4.unblockSelector, true)) {
              return;
            }
            m.addedNodes.forEach(function (n) {
              return _this4.genAdds(n, m.target);
            });
            m.removedNodes.forEach(function (n) {
              var nodeId = _this4.mirror.getId(n);
              var parentId = isShadowRoot(m.target) ? _this4.mirror.getId(m.target.host) : _this4.mirror.getId(m.target);
              if (isBlocked(m.target, _this4.blockClass, _this4.blockSelector, _this4.unblockSelector, false) || isIgnored(n, _this4.mirror) || !isSerialized(n, _this4.mirror)) {
                return;
              }
              if (_this4.addedSet.has(n)) {
                deepDelete(_this4.addedSet, n);
                _this4.droppedSet.add(n);
              } else if (_this4.addedSet.has(m.target) && nodeId === -1) ;else if (isAncestorRemoved(m.target, _this4.mirror)) ;else if (_this4.movedSet.has(n) && _this4.movedMap[moveKey(nodeId, parentId)]) {
                deepDelete(_this4.movedSet, n);
              } else {
                _this4.removes.push({
                  parentId: parentId,
                  id: nodeId,
                  isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : undefined
                });
              }
              _this4.mapRemoves.push(n);
            });
            break;
          }
      }
    };
    this.genAdds = function (n, target) {
      if (_this4.processedNodeManager.inOtherBuffer(n, _this4)) return;
      if (_this4.addedSet.has(n) || _this4.movedSet.has(n)) return;
      if (_this4.mirror.hasNode(n)) {
        if (isIgnored(n, _this4.mirror)) {
          return;
        }
        _this4.movedSet.add(n);
        var targetId = null;
        if (target && _this4.mirror.hasNode(target)) {
          targetId = _this4.mirror.getId(target);
        }
        if (targetId && targetId !== -1) {
          _this4.movedMap[moveKey(_this4.mirror.getId(n), targetId)] = true;
        }
      } else {
        _this4.addedSet.add(n);
        _this4.droppedSet.delete(n);
      }
      if (!isBlocked(n, _this4.blockClass, _this4.blockSelector, _this4.unblockSelector, false)) {
        n.childNodes.forEach(function (childN) {
          return _this4.genAdds(childN);
        });
        if (hasShadowRoot(n)) {
          n.shadowRoot.childNodes.forEach(function (childN) {
            _this4.processedNodeManager.add(childN, _this4);
            _this4.genAdds(childN, n);
          });
        }
      }
    };
  }
  _createClass(MutationBuffer, [{
    key: "init",
    value: function init(options) {
      var _this5 = this;
      ['mutationCb', 'blockClass', 'blockSelector', 'unblockSelector', 'maskAllText', 'maskTextClass', 'unmaskTextClass', 'maskTextSelector', 'unmaskTextSelector', 'inlineStylesheet', 'maskInputOptions', 'maskAttributeFn', 'maskTextFn', 'maskInputFn', 'keepIframeSrcFn', 'recordCanvas', 'inlineImages', 'slimDOMOptions', 'dataURLOptions', 'doc', 'mirror', 'iframeManager', 'stylesheetManager', 'shadowDomManager', 'canvasManager', 'processedNodeManager'].forEach(function (key) {
        _this5[key] = options[key];
      });
    }
  }, {
    key: "freeze",
    value: function freeze() {
      this.frozen = true;
      this.canvasManager.freeze();
    }
  }, {
    key: "unfreeze",
    value: function unfreeze() {
      this.frozen = false;
      this.canvasManager.unfreeze();
      this.emit();
    }
  }, {
    key: "isFrozen",
    value: function isFrozen() {
      return this.frozen;
    }
  }, {
    key: "lock",
    value: function lock() {
      this.locked = true;
      this.canvasManager.lock();
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this.locked = false;
      this.canvasManager.unlock();
      this.emit();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.shadowDomManager.reset();
      this.canvasManager.reset();
    }
  }]);
  return MutationBuffer;
}();
function deepDelete(addsSet, n) {
  addsSet.delete(n);
  n.childNodes.forEach(function (childN) {
    return deepDelete(addsSet, childN);
  });
}
function isParentRemoved(removes, n, mirror) {
  if (removes.length === 0) return false;
  return _isParentRemoved(removes, n, mirror);
}
function _isParentRemoved(removes, n, mirror) {
  var node = n.parentNode;
  var _loop = function _loop() {
    var parentId = mirror.getId(node);
    if (removes.some(function (r) {
      return r.id === parentId;
    })) {
      return {
        v: true
      };
    }
    node = node.parentNode;
  };
  while (node) {
    var _ret = _loop();
    if (_typeof(_ret) === "object") return _ret.v;
  }
  return false;
}
function isAncestorInSet(set, n) {
  if (set.size === 0) return false;
  return _isAncestorInSet(set, n);
}
function _isAncestorInSet(set, n) {
  var parentNode = n.parentNode;
  if (!parentNode) {
    return false;
  }
  if (set.has(parentNode)) {
    return true;
  }
  return _isAncestorInSet(set, parentNode);
}
var errorHandler;
function registerErrorHandler(handler) {
  errorHandler = handler;
}
function unregisterErrorHandler() {
  errorHandler = undefined;
}
var callbackWrapper = function callbackWrapper(cb) {
  if (!errorHandler) {
    return cb;
  }
  var rrwebWrapped = function rrwebWrapped() {
    try {
      return cb.apply(void 0, arguments);
    } catch (error) {
      if (errorHandler && errorHandler(error) === true) {
        return function () {};
      }
      throw error;
    }
  };
  return rrwebWrapped;
};
function _optionalChain$2(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;
  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value6;
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }
        return (_value6 = value).call.apply(_value6, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }
  return value;
}
var mutationBuffers = [];
function getEventTarget(event) {
  try {
    if ('composedPath' in event) {
      var path = event.composedPath();
      if (path.length) {
        return path[0];
      }
    } else if ('path' in event && event.path.length) {
      return event.path[0];
    }
  } catch (e2) {}
  return event && event.target;
}
function initMutationObserver(options, rootEl) {
  var mutationBuffer = new MutationBuffer();
  mutationBuffers.push(mutationBuffer);
  mutationBuffer.init(options);
  var mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
  var angularZoneSymbol = _optionalChain$2([window, 'optionalAccess', function (_) {
    return _.Zone;
  }, 'optionalAccess', function (_2) {
    return _2.__symbol__;
  }, 'optionalCall', function (_3) {
    return _3('MutationObserver');
  }]);
  if (angularZoneSymbol && window[angularZoneSymbol]) {
    mutationObserverCtor = window[angularZoneSymbol];
  }
  var observer = new mutationObserverCtor(callbackWrapper(function (mutations) {
    if (options.onMutation && options.onMutation(mutations) === false) {
      return;
    }
    mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
  }));
  observer.observe(rootEl, {
    attributes: true,
    attributeOldValue: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return observer;
}
function initMoveObserver(_ref4) {
  var mousemoveCb = _ref4.mousemoveCb,
    sampling = _ref4.sampling,
    doc = _ref4.doc,
    mirror = _ref4.mirror;
  if (sampling.mousemove === false) {
    return function () {};
  }
  var threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
  var callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
  var positions = [];
  var timeBaseline;
  var wrappedCb = throttle$1(callbackWrapper(function (source) {
    var totalOffset = Date.now() - timeBaseline;
    mousemoveCb(positions.map(function (p) {
      p.timeOffset -= totalOffset;
      return p;
    }), source);
    positions = [];
    timeBaseline = null;
  }), callbackThreshold);
  var updatePosition = callbackWrapper(throttle$1(callbackWrapper(function (evt) {
    var target = getEventTarget(evt);
    var _ref5 = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt,
      clientX = _ref5.clientX,
      clientY = _ref5.clientY;
    if (!timeBaseline) {
      timeBaseline = nowTimestamp();
    }
    positions.push({
      x: clientX,
      y: clientY,
      id: mirror.getId(target),
      timeOffset: nowTimestamp() - timeBaseline
    });
    wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
  }), threshold, {
    trailing: false
  }));
  var handlers = [on('mousemove', updatePosition, doc), on('touchmove', updatePosition, doc), on('drag', updatePosition, doc)];
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}
function initMouseInteractionObserver(_ref6) {
  var mouseInteractionCb = _ref6.mouseInteractionCb,
    doc = _ref6.doc,
    mirror = _ref6.mirror,
    blockClass = _ref6.blockClass,
    blockSelector = _ref6.blockSelector,
    unblockSelector = _ref6.unblockSelector,
    sampling = _ref6.sampling;
  if (sampling.mouseInteraction === false) {
    return function () {};
  }
  var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
  var handlers = [];
  var currentPointerType = null;
  var getHandler = function getHandler(eventKey) {
    return function (event) {
      var target = getEventTarget(event);
      if (isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
        return;
      }
      var pointerType = null;
      var thisEventKey = eventKey;
      if ('pointerType' in event) {
        switch (event.pointerType) {
          case 'mouse':
            pointerType = PointerTypes.Mouse;
            break;
          case 'touch':
            pointerType = PointerTypes.Touch;
            break;
          case 'pen':
            pointerType = PointerTypes.Pen;
            break;
        }
        if (pointerType === PointerTypes.Touch) {
          if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) {
            thisEventKey = 'TouchStart';
          } else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) {
            thisEventKey = 'TouchEnd';
          }
        } else if (pointerType === PointerTypes.Pen) ;
      } else if (legacy_isTouchEvent(event)) {
        pointerType = PointerTypes.Touch;
      }
      if (pointerType !== null) {
        currentPointerType = pointerType;
        if (thisEventKey.startsWith('Touch') && pointerType === PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === PointerTypes.Mouse) {
          pointerType = null;
        }
      } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
        pointerType = currentPointerType;
        currentPointerType = null;
      }
      var e = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
      if (!e) {
        return;
      }
      var id = mirror.getId(target);
      var clientX = e.clientX,
        clientY = e.clientY;
      callbackWrapper(mouseInteractionCb)(_objectSpread({
        type: MouseInteractions[thisEventKey],
        id: id,
        x: clientX,
        y: clientY
      }, pointerType !== null && {
        pointerType: pointerType
      }));
    };
  };
  Object.keys(MouseInteractions).filter(function (key) {
    return Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false;
  }).forEach(function (eventKey) {
    var eventName = toLowerCase(eventKey);
    var handler = getHandler(eventKey);
    if (window.PointerEvent) {
      switch (MouseInteractions[eventKey]) {
        case MouseInteractions.MouseDown:
        case MouseInteractions.MouseUp:
          eventName = eventName.replace('mouse', 'pointer');
          break;
        case MouseInteractions.TouchStart:
        case MouseInteractions.TouchEnd:
          return;
      }
    }
    handlers.push(on(eventName, handler, doc));
  });
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}
function initScrollObserver(_ref7) {
  var scrollCb = _ref7.scrollCb,
    doc = _ref7.doc,
    mirror = _ref7.mirror,
    blockClass = _ref7.blockClass,
    blockSelector = _ref7.blockSelector,
    unblockSelector = _ref7.unblockSelector,
    sampling = _ref7.sampling;
  var updatePosition = callbackWrapper(throttle$1(callbackWrapper(function (evt) {
    var target = getEventTarget(evt);
    if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
      return;
    }
    var id = mirror.getId(target);
    if (target === doc && doc.defaultView) {
      var scrollLeftTop = getWindowScroll(doc.defaultView);
      scrollCb({
        id: id,
        x: scrollLeftTop.left,
        y: scrollLeftTop.top
      });
    } else {
      scrollCb({
        id: id,
        x: target.scrollLeft,
        y: target.scrollTop
      });
    }
  }), sampling.scroll || 100));
  return on('scroll', updatePosition, doc);
}
function initViewportResizeObserver(_ref8, _ref9) {
  var viewportResizeCb = _ref8.viewportResizeCb;
  var win = _ref9.win;
  var lastH = -1;
  var lastW = -1;
  var updateDimension = callbackWrapper(throttle$1(callbackWrapper(function () {
    var height = getWindowHeight();
    var width = getWindowWidth();
    if (lastH !== height || lastW !== width) {
      viewportResizeCb({
        width: Number(width),
        height: Number(height)
      });
      lastH = height;
      lastW = width;
    }
  }), 200));
  return on('resize', updateDimension, win);
}
var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
var lastInputValueMap = new WeakMap();
function initInputObserver(_ref10) {
  var inputCb = _ref10.inputCb,
    doc = _ref10.doc,
    mirror = _ref10.mirror,
    blockClass = _ref10.blockClass,
    blockSelector = _ref10.blockSelector,
    unblockSelector = _ref10.unblockSelector,
    ignoreClass = _ref10.ignoreClass,
    ignoreSelector = _ref10.ignoreSelector,
    maskInputOptions = _ref10.maskInputOptions,
    maskInputFn = _ref10.maskInputFn,
    sampling = _ref10.sampling,
    userTriggeredOnInput = _ref10.userTriggeredOnInput,
    maskTextClass = _ref10.maskTextClass,
    unmaskTextClass = _ref10.unmaskTextClass,
    maskTextSelector = _ref10.maskTextSelector,
    unmaskTextSelector = _ref10.unmaskTextSelector;
  function eventHandler(event) {
    var target = getEventTarget(event);
    var userTriggered = event.isTrusted;
    var tagName = target && toUpperCase(target.tagName);
    if (tagName === 'OPTION') target = target.parentElement;
    if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
      return;
    }
    var el = target;
    if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) {
      return;
    }
    var type = getInputType(target);
    var text = getInputValue(el, tagName, type);
    var isChecked = false;
    var isInputMasked = shouldMaskInput({
      maskInputOptions: maskInputOptions,
      tagName: tagName,
      type: type
    });
    var forceMask = needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
    if (type === 'radio' || type === 'checkbox') {
      isChecked = target.checked;
    }
    text = maskInputValue({
      isMasked: forceMask,
      element: target,
      value: text,
      maskInputFn: maskInputFn
    });
    cbWithDedup(target, userTriggeredOnInput ? {
      text: text,
      isChecked: isChecked,
      userTriggered: userTriggered
    } : {
      text: text,
      isChecked: isChecked
    });
    var name = target.name;
    if (type === 'radio' && name && isChecked) {
      doc.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")).forEach(function (el) {
        if (el !== target) {
          var _text = maskInputValue({
            isMasked: forceMask,
            element: el,
            value: getInputValue(el, tagName, type),
            maskInputFn: maskInputFn
          });
          cbWithDedup(el, userTriggeredOnInput ? {
            text: _text,
            isChecked: !isChecked,
            userTriggered: false
          } : {
            text: _text,
            isChecked: !isChecked
          });
        }
      });
    }
  }
  function cbWithDedup(target, v) {
    var lastInputValue = lastInputValueMap.get(target);
    if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
      lastInputValueMap.set(target, v);
      var id = mirror.getId(target);
      callbackWrapper(inputCb)(_objectSpread(_objectSpread({}, v), {}, {
        id: id
      }));
    }
  }
  var events = sampling.input === 'last' ? ['change'] : ['input', 'change'];
  var handlers = events.map(function (eventName) {
    return on(eventName, callbackWrapper(eventHandler), doc);
  });
  var currentWindow = doc.defaultView;
  if (!currentWindow) {
    return function () {
      handlers.forEach(function (h) {
        return h();
      });
    };
  }
  var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
  var hookProperties = [[currentWindow.HTMLInputElement.prototype, 'value'], [currentWindow.HTMLInputElement.prototype, 'checked'], [currentWindow.HTMLSelectElement.prototype, 'value'], [currentWindow.HTMLTextAreaElement.prototype, 'value'], [currentWindow.HTMLSelectElement.prototype, 'selectedIndex'], [currentWindow.HTMLOptionElement.prototype, 'selected']];
  if (propertyDescriptor && propertyDescriptor.set) {
    handlers.push.apply(handlers, _toConsumableArray(hookProperties.map(function (p) {
      return hookSetter(p[0], p[1], {
        set: function set() {
          callbackWrapper(eventHandler)({
            target: this,
            isTrusted: false
          });
        }
      }, false, currentWindow);
    })));
  }
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}
function getNestedCSSRulePositions(rule) {
  var positions = [];
  function recurse(childRule, pos) {
    if (hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
      var rules = Array.from(childRule.parentRule.cssRules);
      var index = rules.indexOf(childRule);
      pos.unshift(index);
    } else if (childRule.parentStyleSheet) {
      var _rules = Array.from(childRule.parentStyleSheet.cssRules);
      var _index = _rules.indexOf(childRule);
      pos.unshift(_index);
    }
    return pos;
  }
  return recurse(rule, positions);
}
function getIdAndStyleId(sheet, mirror, styleMirror) {
  var id, styleId;
  if (!sheet) return {};
  if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);else styleId = styleMirror.getId(sheet);
  return {
    styleId: styleId,
    id: id
  };
}
function initStyleSheetObserver(_ref11, _ref12) {
  var styleSheetRuleCb = _ref11.styleSheetRuleCb,
    mirror = _ref11.mirror,
    stylesheetManager = _ref11.stylesheetManager;
  var win = _ref12.win;
  if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
    return function () {};
  }
  var insertRule = win.CSSStyleSheet.prototype.insertRule;
  win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
    apply: callbackWrapper(function (target, thisArg, argumentsList) {
      var _argumentsList = _slicedToArray(argumentsList, 2),
        rule = _argumentsList[0],
        index = _argumentsList[1];
      var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror),
        id = _getIdAndStyleId.id,
        styleId = _getIdAndStyleId.styleId;
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id: id,
          styleId: styleId,
          adds: [{
            rule: rule,
            index: index
          }]
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
  win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
    apply: callbackWrapper(function (target, thisArg, argumentsList) {
      var _argumentsList2 = _slicedToArray(argumentsList, 1),
        index = _argumentsList2[0];
      var _getIdAndStyleId2 = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror),
        id = _getIdAndStyleId2.id,
        styleId = _getIdAndStyleId2.styleId;
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id: id,
          styleId: styleId,
          removes: [{
            index: index
          }]
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  var replace;
  if (win.CSSStyleSheet.prototype.replace) {
    replace = win.CSSStyleSheet.prototype.replace;
    win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
      apply: callbackWrapper(function (target, thisArg, argumentsList) {
        var _argumentsList3 = _slicedToArray(argumentsList, 1),
          text = _argumentsList3[0];
        var _getIdAndStyleId3 = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror),
          id = _getIdAndStyleId3.id,
          styleId = _getIdAndStyleId3.styleId;
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id: id,
            styleId: styleId,
            replace: text
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  }
  var replaceSync;
  if (win.CSSStyleSheet.prototype.replaceSync) {
    replaceSync = win.CSSStyleSheet.prototype.replaceSync;
    win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
      apply: callbackWrapper(function (target, thisArg, argumentsList) {
        var _argumentsList4 = _slicedToArray(argumentsList, 1),
          text = _argumentsList4[0];
        var _getIdAndStyleId4 = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror),
          id = _getIdAndStyleId4.id,
          styleId = _getIdAndStyleId4.styleId;
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id: id,
            styleId: styleId,
            replaceSync: text
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  }
  var supportedNestedCSSRuleTypes = {};
  if (canMonkeyPatchNestedCSSRule('CSSGroupingRule')) {
    supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
  } else {
    if (canMonkeyPatchNestedCSSRule('CSSMediaRule')) {
      supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
    }
    if (canMonkeyPatchNestedCSSRule('CSSConditionRule')) {
      supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
    }
    if (canMonkeyPatchNestedCSSRule('CSSSupportsRule')) {
      supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
  }
  var unmodifiedFunctions = {};
  Object.entries(supportedNestedCSSRuleTypes).forEach(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
      typeKey = _ref14[0],
      type = _ref14[1];
    unmodifiedFunctions[typeKey] = {
      insertRule: type.prototype.insertRule,
      deleteRule: type.prototype.deleteRule
    };
    type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
      apply: callbackWrapper(function (target, thisArg, argumentsList) {
        var _argumentsList5 = _slicedToArray(argumentsList, 2),
          rule = _argumentsList5[0],
          index = _argumentsList5[1];
        var _getIdAndStyleId5 = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror),
          id = _getIdAndStyleId5.id,
          styleId = _getIdAndStyleId5.styleId;
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id: id,
            styleId: styleId,
            adds: [{
              rule: rule,
              index: [].concat(_toConsumableArray(getNestedCSSRulePositions(thisArg)), [index || 0])
            }]
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
    type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
      apply: callbackWrapper(function (target, thisArg, argumentsList) {
        var _argumentsList6 = _slicedToArray(argumentsList, 1),
          index = _argumentsList6[0];
        var _getIdAndStyleId6 = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror),
          id = _getIdAndStyleId6.id,
          styleId = _getIdAndStyleId6.styleId;
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id: id,
            styleId: styleId,
            removes: [{
              index: [].concat(_toConsumableArray(getNestedCSSRulePositions(thisArg)), [index])
            }]
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  });
  return callbackWrapper(function () {
    win.CSSStyleSheet.prototype.insertRule = insertRule;
    win.CSSStyleSheet.prototype.deleteRule = deleteRule;
    replace && (win.CSSStyleSheet.prototype.replace = replace);
    replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
    Object.entries(supportedNestedCSSRuleTypes).forEach(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 2),
        typeKey = _ref16[0],
        type = _ref16[1];
      type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
      type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
    });
  });
}
function initAdoptedStyleSheetObserver(_ref17, host) {
  var mirror = _ref17.mirror,
    stylesheetManager = _ref17.stylesheetManager;
  var hostId = null;
  if (host.nodeName === '#document') hostId = mirror.getId(host);else hostId = mirror.getId(host.host);
  var patchTarget = host.nodeName === '#document' ? _optionalChain$2([host, 'access', function (_4) {
    return _4.defaultView;
  }, 'optionalAccess', function (_5) {
    return _5.Document;
  }]) : _optionalChain$2([host, 'access', function (_6) {
    return _6.ownerDocument;
  }, 'optionalAccess', function (_7) {
    return _7.defaultView;
  }, 'optionalAccess', function (_8) {
    return _8.ShadowRoot;
  }]);
  var originalPropertyDescriptor = _optionalChain$2([patchTarget, 'optionalAccess', function (_9) {
    return _9.prototype;
  }]) ? Object.getOwnPropertyDescriptor(_optionalChain$2([patchTarget, 'optionalAccess', function (_10) {
    return _10.prototype;
  }]), 'adoptedStyleSheets') : undefined;
  if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function () {};
  Object.defineProperty(host, 'adoptedStyleSheets', {
    configurable: originalPropertyDescriptor.configurable,
    enumerable: originalPropertyDescriptor.enumerable,
    get: function get() {
      var _this6 = this;
      return _optionalChain$2([originalPropertyDescriptor, 'access', function (_11) {
        return _11.get;
      }, 'optionalAccess', function (_12) {
        return _12.call;
      }, 'call', function (_13) {
        return _13(_this6);
      }]);
    },
    set: function set(sheets) {
      var _this7 = this;
      var result = _optionalChain$2([originalPropertyDescriptor, 'access', function (_14) {
        return _14.set;
      }, 'optionalAccess', function (_15) {
        return _15.call;
      }, 'call', function (_16) {
        return _16(_this7, sheets);
      }]);
      if (hostId !== null && hostId !== -1) {
        try {
          stylesheetManager.adoptStyleSheets(sheets, hostId);
        } catch (e) {}
      }
      return result;
    }
  });
  return callbackWrapper(function () {
    Object.defineProperty(host, 'adoptedStyleSheets', {
      configurable: originalPropertyDescriptor.configurable,
      enumerable: originalPropertyDescriptor.enumerable,
      get: originalPropertyDescriptor.get,
      set: originalPropertyDescriptor.set
    });
  });
}
function initStyleDeclarationObserver(_ref18, _ref19) {
  var styleDeclarationCb = _ref18.styleDeclarationCb,
    mirror = _ref18.mirror,
    ignoreCSSAttributes = _ref18.ignoreCSSAttributes,
    stylesheetManager = _ref18.stylesheetManager;
  var win = _ref19.win;
  var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
  win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
    apply: callbackWrapper(function (target, thisArg, argumentsList) {
      var _argumentsList7 = _slicedToArray(argumentsList, 3),
        property = _argumentsList7[0],
        value = _argumentsList7[1],
        priority = _argumentsList7[2];
      if (ignoreCSSAttributes.has(property)) {
        return setProperty.apply(thisArg, [property, value, priority]);
      }
      var _getIdAndStyleId7 = getIdAndStyleId(_optionalChain$2([thisArg, 'access', function (_17) {
          return _17.parentRule;
        }, 'optionalAccess', function (_18) {
          return _18.parentStyleSheet;
        }]), mirror, stylesheetManager.styleMirror),
        id = _getIdAndStyleId7.id,
        styleId = _getIdAndStyleId7.styleId;
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id: id,
          styleId: styleId,
          set: {
            property: property,
            value: value,
            priority: priority
          },
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
  win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
    apply: callbackWrapper(function (target, thisArg, argumentsList) {
      var _argumentsList8 = _slicedToArray(argumentsList, 1),
        property = _argumentsList8[0];
      if (ignoreCSSAttributes.has(property)) {
        return removeProperty.apply(thisArg, [property]);
      }
      var _getIdAndStyleId8 = getIdAndStyleId(_optionalChain$2([thisArg, 'access', function (_19) {
          return _19.parentRule;
        }, 'optionalAccess', function (_20) {
          return _20.parentStyleSheet;
        }]), mirror, stylesheetManager.styleMirror),
        id = _getIdAndStyleId8.id,
        styleId = _getIdAndStyleId8.styleId;
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id: id,
          styleId: styleId,
          remove: {
            property: property
          },
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  return callbackWrapper(function () {
    win.CSSStyleDeclaration.prototype.setProperty = setProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
  });
}
function initMediaInteractionObserver(_ref20) {
  var mediaInteractionCb = _ref20.mediaInteractionCb,
    blockClass = _ref20.blockClass,
    blockSelector = _ref20.blockSelector,
    unblockSelector = _ref20.unblockSelector,
    mirror = _ref20.mirror,
    sampling = _ref20.sampling,
    doc = _ref20.doc;
  var handler = callbackWrapper(function (type) {
    return throttle$1(callbackWrapper(function (event) {
      var target = getEventTarget(event);
      if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
        return;
      }
      var currentTime = target.currentTime,
        volume = target.volume,
        muted = target.muted,
        playbackRate = target.playbackRate;
      mediaInteractionCb({
        type: type,
        id: mirror.getId(target),
        currentTime: currentTime,
        volume: volume,
        muted: muted,
        playbackRate: playbackRate
      });
    }), sampling.media || 500);
  });
  var handlers = [on('play', handler(0), doc), on('pause', handler(1), doc), on('seeked', handler(2), doc), on('volumechange', handler(3), doc), on('ratechange', handler(4), doc)];
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}
function initFontObserver(_ref21) {
  var fontCb = _ref21.fontCb,
    doc = _ref21.doc;
  var win = doc.defaultView;
  if (!win) {
    return function () {};
  }
  var handlers = [];
  var fontMap = new WeakMap();
  var originalFontFace = win.FontFace;
  win.FontFace = function FontFace(family, source, descriptors) {
    var fontFace = new originalFontFace(family, source, descriptors);
    fontMap.set(fontFace, {
      family: family,
      buffer: typeof source !== 'string',
      descriptors: descriptors,
      fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
    });
    return fontFace;
  };
  var restoreHandler = patch(doc.fonts, 'add', function (original) {
    return function (fontFace) {
      setTimeout$1(callbackWrapper(function () {
        var p = fontMap.get(fontFace);
        if (p) {
          fontCb(p);
          fontMap.delete(fontFace);
        }
      }), 0);
      return original.apply(this, [fontFace]);
    };
  });
  handlers.push(function () {
    win.FontFace = originalFontFace;
  });
  handlers.push(restoreHandler);
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}
function initSelectionObserver(param) {
  var doc = param.doc,
    mirror = param.mirror,
    blockClass = param.blockClass,
    blockSelector = param.blockSelector,
    unblockSelector = param.unblockSelector,
    selectionCb = param.selectionCb;
  var collapsed = true;
  var updateSelection = callbackWrapper(function () {
    var selection = doc.getSelection();
    if (!selection || collapsed && _optionalChain$2([selection, 'optionalAccess', function (_21) {
      return _21.isCollapsed;
    }])) return;
    collapsed = selection.isCollapsed || false;
    var ranges = [];
    var count = selection.rangeCount || 0;
    for (var i = 0; i < count; i++) {
      var range = selection.getRangeAt(i);
      var startContainer = range.startContainer,
        startOffset = range.startOffset,
        endContainer = range.endContainer,
        endOffset = range.endOffset;
      var blocked = isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
      if (blocked) continue;
      ranges.push({
        start: mirror.getId(startContainer),
        startOffset: startOffset,
        end: mirror.getId(endContainer),
        endOffset: endOffset
      });
    }
    selectionCb({
      ranges: ranges
    });
  });
  updateSelection();
  return on('selectionchange', updateSelection);
}
function initCustomElementObserver(_ref22) {
  var doc = _ref22.doc,
    customElementCb = _ref22.customElementCb;
  var win = doc.defaultView;
  if (!win || !win.customElements) return function () {};
  var restoreHandler = patch(win.customElements, 'define', function (original) {
    return function (name, constructor, options) {
      try {
        customElementCb({
          define: {
            name: name
          }
        });
      } catch (e) {}
      return original.apply(this, [name, constructor, options]);
    };
  });
  return restoreHandler;
}
function initObservers(o) {
  var _hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentWindow = o.doc.defaultView;
  if (!currentWindow) {
    return function () {};
  }
  var mutationObserver;
  if (o.recordDOM) {
    mutationObserver = initMutationObserver(o, o.doc);
  }
  var mousemoveHandler = initMoveObserver(o);
  var mouseInteractionHandler = initMouseInteractionObserver(o);
  var scrollHandler = initScrollObserver(o);
  var viewportResizeHandler = initViewportResizeObserver(o, {
    win: currentWindow
  });
  var inputHandler = initInputObserver(o);
  var mediaInteractionHandler = initMediaInteractionObserver(o);
  var styleSheetObserver = function styleSheetObserver() {};
  var adoptedStyleSheetObserver = function adoptedStyleSheetObserver() {};
  var styleDeclarationObserver = function styleDeclarationObserver() {};
  var fontObserver = function fontObserver() {};
  if (o.recordDOM) {
    styleSheetObserver = initStyleSheetObserver(o, {
      win: currentWindow
    });
    adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o, o.doc);
    styleDeclarationObserver = initStyleDeclarationObserver(o, {
      win: currentWindow
    });
    if (o.collectFonts) {
      fontObserver = initFontObserver(o);
    }
  }
  var selectionObserver = initSelectionObserver(o);
  var customElementObserver = initCustomElementObserver(o);
  var pluginHandlers = [];
  var _iterator4 = _createForOfIteratorHelper(o.plugins),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var plugin = _step4.value;
      pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return callbackWrapper(function () {
    mutationBuffers.forEach(function (b) {
      return b.reset();
    });
    _optionalChain$2([mutationObserver, 'optionalAccess', function (_22) {
      return _22.disconnect;
    }, 'call', function (_23) {
      return _23();
    }]);
    mousemoveHandler();
    mouseInteractionHandler();
    scrollHandler();
    viewportResizeHandler();
    inputHandler();
    mediaInteractionHandler();
    styleSheetObserver();
    adoptedStyleSheetObserver();
    styleDeclarationObserver();
    fontObserver();
    selectionObserver();
    customElementObserver();
    pluginHandlers.forEach(function (h) {
      return h();
    });
  });
}
function hasNestedCSSRule(prop) {
  return typeof window[prop] !== 'undefined';
}
function canMonkeyPatchNestedCSSRule(prop) {
  return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
var CrossOriginIframeMirror = /*#__PURE__*/function () {
  function CrossOriginIframeMirror(generateIdFn) {
    _classCallCheck(this, CrossOriginIframeMirror);
    this.generateIdFn = generateIdFn;
    this.iframeIdToRemoteIdMap = new WeakMap();
    this.iframeRemoteIdToIdMap = new WeakMap();
  }
  _createClass(CrossOriginIframeMirror, [{
    key: "getId",
    value: function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
      var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
      var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
      var id = idToRemoteIdMap.get(remoteId);
      if (!id) {
        id = this.generateIdFn();
        idToRemoteIdMap.set(remoteId, id);
        remoteIdToIdMap.set(id, remoteId);
      }
      return id;
    }
  }, {
    key: "getIds",
    value: function getIds(iframe, remoteId) {
      var _this8 = this;
      var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
      var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
      return remoteId.map(function (id) {
        return _this8.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
      });
    }
  }, {
    key: "getRemoteId",
    value: function getRemoteId(iframe, id, map) {
      var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
      if (typeof id !== 'number') return id;
      var remoteId = remoteIdToIdMap.get(id);
      if (!remoteId) return -1;
      return remoteId;
    }
  }, {
    key: "getRemoteIds",
    value: function getRemoteIds(iframe, ids) {
      var _this9 = this;
      var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
      return ids.map(function (id) {
        return _this9.getRemoteId(iframe, id, remoteIdToIdMap);
      });
    }
  }, {
    key: "reset",
    value: function reset(iframe) {
      if (!iframe) {
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
        return;
      }
      this.iframeIdToRemoteIdMap.delete(iframe);
      this.iframeRemoteIdToIdMap.delete(iframe);
    }
  }, {
    key: "getIdToRemoteIdMap",
    value: function getIdToRemoteIdMap(iframe) {
      var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
      if (!idToRemoteIdMap) {
        idToRemoteIdMap = new Map();
        this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
      }
      return idToRemoteIdMap;
    }
  }, {
    key: "getRemoteIdToIdMap",
    value: function getRemoteIdToIdMap(iframe) {
      var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
      if (!remoteIdToIdMap) {
        remoteIdToIdMap = new Map();
        this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
      }
      return remoteIdToIdMap;
    }
  }]);
  return CrossOriginIframeMirror;
}();
function _optionalChain$1(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;
  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value7;
        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }
        return (_value7 = value).call.apply(_value7, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }
  return value;
}
var IframeManagerNoop = /*#__PURE__*/function () {
  function IframeManagerNoop() {
    _classCallCheck(this, IframeManagerNoop);
    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
    this.crossOriginIframeRootIdMap = new WeakMap();
  }
  _createClass(IframeManagerNoop, [{
    key: "addIframe",
    value: function addIframe() {}
  }, {
    key: "addLoadListener",
    value: function addLoadListener() {}
  }, {
    key: "attachIframe",
    value: function attachIframe() {}
  }]);
  return IframeManagerNoop;
}();
var IframeManager = /*#__PURE__*/function () {
  function IframeManager(options) {
    _classCallCheck(this, IframeManager);
    this.iframes = new WeakMap();
    this.crossOriginIframeMap = new WeakMap();
    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
    this.crossOriginIframeRootIdMap = new WeakMap();
    this.mutationCb = options.mutationCb;
    this.wrappedEmit = options.wrappedEmit;
    this.stylesheetManager = options.stylesheetManager;
    this.recordCrossOriginIframes = options.recordCrossOriginIframes;
    this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
    this.mirror = options.mirror;
    if (this.recordCrossOriginIframes) {
      window.addEventListener('message', this.handleMessage.bind(this));
    }
  }
  _createClass(IframeManager, [{
    key: "addIframe",
    value: function addIframe(iframeEl) {
      this.iframes.set(iframeEl, true);
      if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
  }, {
    key: "addLoadListener",
    value: function addLoadListener(cb) {
      this.loadListener = cb;
    }
  }, {
    key: "attachIframe",
    value: function attachIframe(iframeEl, childSn) {
      this.mutationCb({
        adds: [{
          parentId: this.mirror.getId(iframeEl),
          nextId: null,
          node: childSn
        }],
        removes: [],
        texts: [],
        attributes: [],
        isAttachIframe: true
      });
      _optionalChain$1([this, 'access', function (_) {
        return _.loadListener;
      }, 'optionalCall', function (_2) {
        return _2(iframeEl);
      }]);
      var iframeDoc = getIFrameContentDocument(iframeEl);
      if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(message) {
      var crossOriginMessageEvent = message;
      if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
      var iframeSourceWindow = message.source;
      if (!iframeSourceWindow) return;
      var iframeEl = this.crossOriginIframeMap.get(message.source);
      if (!iframeEl) return;
      var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
      if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
  }, {
    key: "transformCrossOriginEvent",
    value: function transformCrossOriginEvent(iframeEl, e) {
      var _this10 = this;
      switch (e.type) {
        case EventType.FullSnapshot:
          {
            this.crossOriginIframeMirror.reset(iframeEl);
            this.crossOriginIframeStyleMirror.reset(iframeEl);
            this.replaceIdOnNode(e.data.node, iframeEl);
            var rootId = e.data.node.id;
            this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
            this.patchRootIdOnNode(e.data.node, rootId);
            return {
              timestamp: e.timestamp,
              type: EventType.IncrementalSnapshot,
              data: {
                source: IncrementalSource.Mutation,
                adds: [{
                  parentId: this.mirror.getId(iframeEl),
                  nextId: null,
                  node: e.data.node
                }],
                removes: [],
                texts: [],
                attributes: [],
                isAttachIframe: true
              }
            };
          }
        case EventType.Meta:
        case EventType.Load:
        case EventType.DomContentLoaded:
          {
            return false;
          }
        case EventType.Plugin:
          {
            return e;
          }
        case EventType.Custom:
          {
            this.replaceIds(e.data.payload, iframeEl, ['id', 'parentId', 'previousId', 'nextId']);
            return e;
          }
        case EventType.IncrementalSnapshot:
          {
            switch (e.data.source) {
              case IncrementalSource.Mutation:
                {
                  e.data.adds.forEach(function (n) {
                    _this10.replaceIds(n, iframeEl, ['parentId', 'nextId', 'previousId']);
                    _this10.replaceIdOnNode(n.node, iframeEl);
                    var rootId = _this10.crossOriginIframeRootIdMap.get(iframeEl);
                    rootId && _this10.patchRootIdOnNode(n.node, rootId);
                  });
                  e.data.removes.forEach(function (n) {
                    _this10.replaceIds(n, iframeEl, ['parentId', 'id']);
                  });
                  e.data.attributes.forEach(function (n) {
                    _this10.replaceIds(n, iframeEl, ['id']);
                  });
                  e.data.texts.forEach(function (n) {
                    _this10.replaceIds(n, iframeEl, ['id']);
                  });
                  return e;
                }
              case IncrementalSource.Drag:
              case IncrementalSource.TouchMove:
              case IncrementalSource.MouseMove:
                {
                  e.data.positions.forEach(function (p) {
                    _this10.replaceIds(p, iframeEl, ['id']);
                  });
                  return e;
                }
              case IncrementalSource.ViewportResize:
                {
                  return false;
                }
              case IncrementalSource.MediaInteraction:
              case IncrementalSource.MouseInteraction:
              case IncrementalSource.Scroll:
              case IncrementalSource.CanvasMutation:
              case IncrementalSource.Input:
                {
                  this.replaceIds(e.data, iframeEl, ['id']);
                  return e;
                }
              case IncrementalSource.StyleSheetRule:
              case IncrementalSource.StyleDeclaration:
                {
                  this.replaceIds(e.data, iframeEl, ['id']);
                  this.replaceStyleIds(e.data, iframeEl, ['styleId']);
                  return e;
                }
              case IncrementalSource.Font:
                {
                  return e;
                }
              case IncrementalSource.Selection:
                {
                  e.data.ranges.forEach(function (range) {
                    _this10.replaceIds(range, iframeEl, ['start', 'end']);
                  });
                  return e;
                }
              case IncrementalSource.AdoptedStyleSheet:
                {
                  this.replaceIds(e.data, iframeEl, ['id']);
                  this.replaceStyleIds(e.data, iframeEl, ['styleIds']);
                  _optionalChain$1([e, 'access', function (_3) {
                    return _3.data;
                  }, 'access', function (_4) {
                    return _4.styles;
                  }, 'optionalAccess', function (_5) {
                    return _5.forEach;
                  }, 'call', function (_6) {
                    return _6(function (style) {
                      _this10.replaceStyleIds(style, iframeEl, ['styleId']);
                    });
                  }]);
                  return e;
                }
            }
          }
      }
      return false;
    }
  }, {
    key: "replace",
    value: function replace(iframeMirror, obj, iframeEl, keys) {
      var _iterator5 = _createForOfIteratorHelper(keys),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var key = _step5.value;
          if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
          if (Array.isArray(obj[key])) {
            obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
          } else {
            obj[key] = iframeMirror.getId(iframeEl, obj[key]);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return obj;
    }
  }, {
    key: "replaceIds",
    value: function replaceIds(obj, iframeEl, keys) {
      return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
  }, {
    key: "replaceStyleIds",
    value: function replaceStyleIds(obj, iframeEl, keys) {
      return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
  }, {
    key: "replaceIdOnNode",
    value: function replaceIdOnNode(node, iframeEl) {
      var _this11 = this;
      this.replaceIds(node, iframeEl, ['id', 'rootId']);
      if ('childNodes' in node) {
        node.childNodes.forEach(function (child) {
          _this11.replaceIdOnNode(child, iframeEl);
        });
      }
    }
  }, {
    key: "patchRootIdOnNode",
    value: function patchRootIdOnNode(node, rootId) {
      var _this12 = this;
      if (node.type !== NodeType$3.Document && !node.rootId) node.rootId = rootId;
      if ('childNodes' in node) {
        node.childNodes.forEach(function (child) {
          _this12.patchRootIdOnNode(child, rootId);
        });
      }
    }
  }]);
  return IframeManager;
}();
var ShadowDomManagerNoop = /*#__PURE__*/function () {
  function ShadowDomManagerNoop() {
    _classCallCheck(this, ShadowDomManagerNoop);
  }
  _createClass(ShadowDomManagerNoop, [{
    key: "init",
    value: function init() {}
  }, {
    key: "addShadowRoot",
    value: function addShadowRoot() {}
  }, {
    key: "observeAttachShadow",
    value: function observeAttachShadow() {}
  }, {
    key: "reset",
    value: function reset() {}
  }]);
  return ShadowDomManagerNoop;
}();
var ShadowDomManager = /*#__PURE__*/function () {
  function ShadowDomManager(options) {
    _classCallCheck(this, ShadowDomManager);
    this.shadowDoms = new WeakSet();
    this.restoreHandlers = [];
    this.mutationCb = options.mutationCb;
    this.scrollCb = options.scrollCb;
    this.bypassOptions = options.bypassOptions;
    this.mirror = options.mirror;
    this.init();
  }
  _createClass(ShadowDomManager, [{
    key: "init",
    value: function init() {
      this.reset();
      this.patchAttachShadow(Element, document);
    }
  }, {
    key: "addShadowRoot",
    value: function addShadowRoot(shadowRoot, doc) {
      var _this13 = this;
      if (!isNativeShadowDom(shadowRoot)) return;
      if (this.shadowDoms.has(shadowRoot)) return;
      this.shadowDoms.add(shadowRoot);
      this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
      var observer = initMutationObserver(_objectSpread(_objectSpread({}, this.bypassOptions), {}, {
        doc: doc,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      }), shadowRoot);
      this.restoreHandlers.push(function () {
        return observer.disconnect();
      });
      this.restoreHandlers.push(initScrollObserver(_objectSpread(_objectSpread({}, this.bypassOptions), {}, {
        scrollCb: this.scrollCb,
        doc: shadowRoot,
        mirror: this.mirror
      })));
      setTimeout$1(function () {
        if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) _this13.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, _this13.mirror.getId(shadowRoot.host));
        _this13.restoreHandlers.push(initAdoptedStyleSheetObserver({
          mirror: _this13.mirror,
          stylesheetManager: _this13.bypassOptions.stylesheetManager
        }, shadowRoot));
      }, 0);
    }
  }, {
    key: "observeAttachShadow",
    value: function observeAttachShadow(iframeElement) {
      var iframeDoc = getIFrameContentDocument(iframeElement);
      var iframeWindow = getIFrameContentWindow(iframeElement);
      if (!iframeDoc || !iframeWindow) return;
      this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
  }, {
    key: "patchAttachShadow",
    value: function patchAttachShadow(element, doc) {
      var manager = this;
      this.restoreHandlers.push(patch(element.prototype, 'attachShadow', function (original) {
        return function (option) {
          var shadowRoot = original.call(this, option);
          if (this.shadowRoot && inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
          return shadowRoot;
        };
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      this.restoreHandlers.forEach(function (handler) {
        try {
          handler();
        } catch (e) {}
      });
      this.restoreHandlers = [];
      this.shadowDoms = new WeakSet();
      this.bypassOptions.canvasManager.resetShadowRoots();
    }
  }]);
  return ShadowDomManager;
}();
var CanvasManagerNoop = /*#__PURE__*/function () {
  function CanvasManagerNoop() {
    _classCallCheck(this, CanvasManagerNoop);
  }
  _createClass(CanvasManagerNoop, [{
    key: "reset",
    value: function reset() {}
  }, {
    key: "freeze",
    value: function freeze() {}
  }, {
    key: "unfreeze",
    value: function unfreeze() {}
  }, {
    key: "lock",
    value: function lock() {}
  }, {
    key: "unlock",
    value: function unlock() {}
  }, {
    key: "snapshot",
    value: function snapshot() {}
  }, {
    key: "addWindow",
    value: function addWindow() {}
  }, {
    key: "addShadowRoot",
    value: function addShadowRoot() {}
  }, {
    key: "resetShadowRoots",
    value: function resetShadowRoots() {}
  }]);
  return CanvasManagerNoop;
}();
var StylesheetManager = /*#__PURE__*/function () {
  function StylesheetManager(options) {
    _classCallCheck(this, StylesheetManager);
    this.trackedLinkElements = new WeakSet();
    this.styleMirror = new StyleSheetMirror();
    this.mutationCb = options.mutationCb;
    this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
  }
  _createClass(StylesheetManager, [{
    key: "attachLinkElement",
    value: function attachLinkElement(linkEl, childSn) {
      if ('_cssText' in childSn.attributes) this.mutationCb({
        adds: [],
        removes: [],
        texts: [],
        attributes: [{
          id: childSn.id,
          attributes: childSn.attributes
        }]
      });
      this.trackLinkElement(linkEl);
    }
  }, {
    key: "trackLinkElement",
    value: function trackLinkElement(linkEl) {
      if (this.trackedLinkElements.has(linkEl)) return;
      this.trackedLinkElements.add(linkEl);
      this.trackStylesheetInLinkElement(linkEl);
    }
  }, {
    key: "adoptStyleSheets",
    value: function adoptStyleSheets(sheets, hostId) {
      if (sheets.length === 0) return;
      var adoptedStyleSheetData = {
        id: hostId,
        styleIds: []
      };
      var styles = [];
      var _iterator6 = _createForOfIteratorHelper(sheets),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var sheet = _step6.value;
          var styleId = void 0;
          if (!this.styleMirror.has(sheet)) {
            styleId = this.styleMirror.add(sheet);
            styles.push({
              styleId: styleId,
              rules: Array.from(sheet.rules || CSSRule, function (r, index) {
                return {
                  rule: stringifyRule(r),
                  index: index
                };
              })
            });
          } else styleId = this.styleMirror.getId(sheet);
          adoptedStyleSheetData.styleIds.push(styleId);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      if (styles.length > 0) adoptedStyleSheetData.styles = styles;
      this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.styleMirror.reset();
      this.trackedLinkElements = new WeakSet();
    }
  }, {
    key: "trackStylesheetInLinkElement",
    value: function trackStylesheetInLinkElement(linkEl) {}
  }]);
  return StylesheetManager;
}();
var ProcessedNodeManager = /*#__PURE__*/function () {
  function ProcessedNodeManager() {
    _classCallCheck(this, ProcessedNodeManager);
    this.nodeMap = new WeakMap();
    this.active = false;
  }
  _createClass(ProcessedNodeManager, [{
    key: "inOtherBuffer",
    value: function inOtherBuffer(node, thisBuffer) {
      var buffers = this.nodeMap.get(node);
      return buffers && Array.from(buffers).some(function (buffer) {
        return buffer !== thisBuffer;
      });
    }
  }, {
    key: "add",
    value: function add(node, buffer) {
      var _this14 = this;
      if (!this.active) {
        this.active = true;
        onRequestAnimationFrame(function () {
          _this14.nodeMap = new WeakMap();
          _this14.active = false;
        });
      }
      this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
  return ProcessedNodeManager;
}();
var wrappedEmit;
var _takeFullSnapshot;
try {
  if (Array.from([1], function (x) {
    return x * 2;
  })[0] !== 2) {
    var cleanFrame = document.createElement('iframe');
    document.body.appendChild(cleanFrame);
    Array.from = _optionalChain([cleanFrame, 'access', function (_) {
      return _.contentWindow;
    }, 'optionalAccess', function (_2) {
      return _2.Array;
    }, 'access', function (_3) {
      return _3.from;
    }]) || Array.from;
    document.body.removeChild(cleanFrame);
  }
} catch (err) {
  console.debug('Unable to override Array.from', err);
}
var mirror = createMirror();
function record() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var emit = options.emit,
    checkoutEveryNms = options.checkoutEveryNms,
    checkoutEveryNth = options.checkoutEveryNth,
    _options$blockClass = options.blockClass,
    blockClass = _options$blockClass === void 0 ? 'rr-block' : _options$blockClass,
    _options$blockSelecto = options.blockSelector,
    blockSelector = _options$blockSelecto === void 0 ? null : _options$blockSelecto,
    _options$unblockSelec = options.unblockSelector,
    unblockSelector = _options$unblockSelec === void 0 ? null : _options$unblockSelec,
    _options$ignoreClass = options.ignoreClass,
    ignoreClass = _options$ignoreClass === void 0 ? 'rr-ignore' : _options$ignoreClass,
    _options$ignoreSelect = options.ignoreSelector,
    ignoreSelector = _options$ignoreSelect === void 0 ? null : _options$ignoreSelect,
    _options$maskAllText = options.maskAllText,
    maskAllText = _options$maskAllText === void 0 ? false : _options$maskAllText,
    _options$maskTextClas = options.maskTextClass,
    maskTextClass = _options$maskTextClas === void 0 ? 'rr-mask' : _options$maskTextClas,
    _options$unmaskTextCl = options.unmaskTextClass,
    unmaskTextClass = _options$unmaskTextCl === void 0 ? null : _options$unmaskTextCl,
    _options$maskTextSele = options.maskTextSelector,
    maskTextSelector = _options$maskTextSele === void 0 ? null : _options$maskTextSele,
    _options$unmaskTextSe = options.unmaskTextSelector,
    unmaskTextSelector = _options$unmaskTextSe === void 0 ? null : _options$unmaskTextSe,
    _options$inlineStyles2 = options.inlineStylesheet,
    inlineStylesheet = _options$inlineStyles2 === void 0 ? true : _options$inlineStyles2,
    maskAllInputs = options.maskAllInputs,
    _maskInputOptions = options.maskInputOptions,
    _slimDOMOptions = options.slimDOMOptions,
    maskAttributeFn = options.maskAttributeFn,
    maskInputFn = options.maskInputFn,
    maskTextFn = options.maskTextFn,
    _options$maxCanvasSiz = options.maxCanvasSize,
    maxCanvasSize = _options$maxCanvasSiz === void 0 ? null : _options$maxCanvasSiz,
    packFn = options.packFn,
    _options$sampling = options.sampling,
    sampling = _options$sampling === void 0 ? {} : _options$sampling,
    _options$dataURLOptio4 = options.dataURLOptions,
    dataURLOptions = _options$dataURLOptio4 === void 0 ? {} : _options$dataURLOptio4,
    mousemoveWait = options.mousemoveWait,
    _options$recordDOM = options.recordDOM,
    recordDOM = _options$recordDOM === void 0 ? true : _options$recordDOM,
    _options$recordCanvas2 = options.recordCanvas,
    recordCanvas = _options$recordCanvas2 === void 0 ? false : _options$recordCanvas2,
    _options$recordCrossO = options.recordCrossOriginIframes,
    recordCrossOriginIframes = _options$recordCrossO === void 0 ? false : _options$recordCrossO,
    _options$recordAfter = options.recordAfter,
    recordAfter = _options$recordAfter === void 0 ? options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load' : _options$recordAfter,
    _options$userTriggere = options.userTriggeredOnInput,
    userTriggeredOnInput = _options$userTriggere === void 0 ? false : _options$userTriggere,
    _options$collectFonts = options.collectFonts,
    collectFonts = _options$collectFonts === void 0 ? false : _options$collectFonts,
    _options$inlineImages2 = options.inlineImages,
    inlineImages = _options$inlineImages2 === void 0 ? false : _options$inlineImages2,
    plugins = options.plugins,
    _options$keepIframeSr2 = options.keepIframeSrcFn,
    keepIframeSrcFn = _options$keepIframeSr2 === void 0 ? function () {
      return false;
    } : _options$keepIframeSr2,
    _options$ignoreCSSAtt = options.ignoreCSSAttributes,
    ignoreCSSAttributes = _options$ignoreCSSAtt === void 0 ? new Set([]) : _options$ignoreCSSAtt,
    errorHandler = options.errorHandler,
    onMutation = options.onMutation,
    getCanvasManager = options.getCanvasManager;
  registerErrorHandler(errorHandler);
  var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
  var passEmitsToParent = false;
  if (!inEmittingFrame) {
    try {
      if (window.parent.document) {
        passEmitsToParent = false;
      }
    } catch (e) {
      passEmitsToParent = true;
    }
  }
  if (inEmittingFrame && !emit) {
    throw new Error('emit function is required');
  }
  if (!inEmittingFrame && !passEmitsToParent) {
    return function () {};
  }
  if (mousemoveWait !== undefined && sampling.mousemove === undefined) {
    sampling.mousemove = mousemoveWait;
  }
  mirror.reset();
  var maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    'datetime-local': true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true,
    radio: true,
    checkbox: true
  } : _maskInputOptions !== undefined ? _maskInputOptions : {};
  var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaVerification: true,
    headMetaAuthorship: _slimDOMOptions === 'all',
    headMetaDescKeywords: _slimDOMOptions === 'all'
  } : _slimDOMOptions ? _slimDOMOptions : {};
  polyfill();
  var lastFullSnapshotEvent;
  var incrementalSnapshotCount = 0;
  var eventProcessor = function eventProcessor(e) {
    var _iterator7 = _createForOfIteratorHelper(plugins || []),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var plugin = _step7.value;
        if (plugin.eventProcessor) {
          e = plugin.eventProcessor(e);
        }
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    if (packFn && !passEmitsToParent) {
      e = packFn(e);
    }
    return e;
  };
  wrappedEmit = function wrappedEmit(r, isCheckout) {
    var e = r;
    e.timestamp = nowTimestamp();
    if (_optionalChain([mutationBuffers, 'access', function (_4) {
      return _4[0];
    }, 'optionalAccess', function (_5) {
      return _5.isFrozen;
    }, 'call', function (_6) {
      return _6();
    }]) && e.type !== EventType.FullSnapshot && !(e.type === EventType.IncrementalSnapshot && e.data.source === IncrementalSource.Mutation)) {
      mutationBuffers.forEach(function (buf) {
        return buf.unfreeze();
      });
    }
    if (inEmittingFrame) {
      _optionalChain([emit, 'optionalCall', function (_7) {
        return _7(eventProcessor(e), isCheckout);
      }]);
    } else if (passEmitsToParent) {
      var message = {
        type: 'rrweb',
        event: eventProcessor(e),
        origin: window.location.origin,
        isCheckout: isCheckout
      };
      window.parent.postMessage(message, '*');
    }
    if (e.type === EventType.FullSnapshot) {
      lastFullSnapshotEvent = e;
      incrementalSnapshotCount = 0;
    } else if (e.type === EventType.IncrementalSnapshot) {
      if (e.data.source === IncrementalSource.Mutation && e.data.isAttachIframe) {
        return;
      }
      incrementalSnapshotCount++;
      var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
      var exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
      if (exceedCount || exceedTime) {
        takeFullSnapshot(true);
      }
    }
  };
  var wrappedMutationEmit = function wrappedMutationEmit(m) {
    wrappedEmit({
      type: EventType.IncrementalSnapshot,
      data: _objectSpread({
        source: IncrementalSource.Mutation
      }, m)
    });
  };
  var wrappedScrollEmit = function wrappedScrollEmit(p) {
    return wrappedEmit({
      type: EventType.IncrementalSnapshot,
      data: _objectSpread({
        source: IncrementalSource.Scroll
      }, p)
    });
  };
  var wrappedCanvasMutationEmit = function wrappedCanvasMutationEmit(p) {
    return wrappedEmit({
      type: EventType.IncrementalSnapshot,
      data: _objectSpread({
        source: IncrementalSource.CanvasMutation
      }, p)
    });
  };
  var wrappedAdoptedStyleSheetEmit = function wrappedAdoptedStyleSheetEmit(a) {
    return wrappedEmit({
      type: EventType.IncrementalSnapshot,
      data: _objectSpread({
        source: IncrementalSource.AdoptedStyleSheet
      }, a)
    });
  };
  var stylesheetManager = new StylesheetManager({
    mutationCb: wrappedMutationEmit,
    adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
  });
  var iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new IframeManagerNoop() : new IframeManager({
    mirror: mirror,
    mutationCb: wrappedMutationEmit,
    stylesheetManager: stylesheetManager,
    recordCrossOriginIframes: recordCrossOriginIframes,
    wrappedEmit: wrappedEmit
  });
  var _iterator8 = _createForOfIteratorHelper(plugins || []),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var plugin = _step8.value;
      if (plugin.getMirror) plugin.getMirror({
        nodeMirror: mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
      });
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  var processedNodeManager = new ProcessedNodeManager();
  var canvasManager = _getCanvasManager(getCanvasManager, {
    mirror: mirror,
    win: window,
    mutationCb: function mutationCb(p) {
      return wrappedEmit({
        type: EventType.IncrementalSnapshot,
        data: _objectSpread({
          source: IncrementalSource.CanvasMutation
        }, p)
      });
    },
    recordCanvas: recordCanvas,
    blockClass: blockClass,
    blockSelector: blockSelector,
    unblockSelector: unblockSelector,
    maxCanvasSize: maxCanvasSize,
    sampling: sampling['canvas'],
    dataURLOptions: dataURLOptions,
    errorHandler: errorHandler
  });
  var shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new ShadowDomManagerNoop() : new ShadowDomManager({
    mutationCb: wrappedMutationEmit,
    scrollCb: wrappedScrollEmit,
    bypassOptions: {
      onMutation: onMutation,
      blockClass: blockClass,
      blockSelector: blockSelector,
      unblockSelector: unblockSelector,
      maskAllText: maskAllText,
      maskTextClass: maskTextClass,
      unmaskTextClass: unmaskTextClass,
      maskTextSelector: maskTextSelector,
      unmaskTextSelector: unmaskTextSelector,
      inlineStylesheet: inlineStylesheet,
      maskInputOptions: maskInputOptions,
      dataURLOptions: dataURLOptions,
      maskAttributeFn: maskAttributeFn,
      maskTextFn: maskTextFn,
      maskInputFn: maskInputFn,
      recordCanvas: recordCanvas,
      inlineImages: inlineImages,
      sampling: sampling,
      slimDOMOptions: slimDOMOptions,
      iframeManager: iframeManager,
      stylesheetManager: stylesheetManager,
      canvasManager: canvasManager,
      keepIframeSrcFn: keepIframeSrcFn,
      processedNodeManager: processedNodeManager
    },
    mirror: mirror
  });
  var takeFullSnapshot = function takeFullSnapshot() {
    var isCheckout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!recordDOM) {
      return;
    }
    wrappedEmit({
      type: EventType.Meta,
      data: {
        href: window.location.href,
        width: getWindowWidth(),
        height: getWindowHeight()
      }
    }, isCheckout);
    stylesheetManager.reset();
    shadowDomManager.init();
    mutationBuffers.forEach(function (buf) {
      return buf.lock();
    });
    var node = snapshot(document, {
      mirror: mirror,
      blockClass: blockClass,
      blockSelector: blockSelector,
      unblockSelector: unblockSelector,
      maskAllText: maskAllText,
      maskTextClass: maskTextClass,
      unmaskTextClass: unmaskTextClass,
      maskTextSelector: maskTextSelector,
      unmaskTextSelector: unmaskTextSelector,
      inlineStylesheet: inlineStylesheet,
      maskAllInputs: maskInputOptions,
      maskAttributeFn: maskAttributeFn,
      maskInputFn: maskInputFn,
      maskTextFn: maskTextFn,
      slimDOM: slimDOMOptions,
      dataURLOptions: dataURLOptions,
      recordCanvas: recordCanvas,
      inlineImages: inlineImages,
      onSerialize: function onSerialize(n) {
        if (isSerializedIframe(n, mirror)) {
          iframeManager.addIframe(n);
        }
        if (isSerializedStylesheet(n, mirror)) {
          stylesheetManager.trackLinkElement(n);
        }
        if (hasShadowRoot(n)) {
          shadowDomManager.addShadowRoot(n.shadowRoot, document);
        }
      },
      onIframeLoad: function onIframeLoad(iframe, childSn) {
        iframeManager.attachIframe(iframe, childSn);
        if (iframe.contentWindow) {
          canvasManager.addWindow(iframe.contentWindow);
        }
        shadowDomManager.observeAttachShadow(iframe);
      },
      onStylesheetLoad: function onStylesheetLoad(linkEl, childSn) {
        stylesheetManager.attachLinkElement(linkEl, childSn);
      },
      keepIframeSrcFn: keepIframeSrcFn
    });
    if (!node) {
      return console.warn('Failed to snapshot the document');
    }
    wrappedEmit({
      type: EventType.FullSnapshot,
      data: {
        node: node,
        initialOffset: getWindowScroll(window)
      }
    });
    mutationBuffers.forEach(function (buf) {
      return buf.unlock();
    });
    if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
  };
  _takeFullSnapshot = takeFullSnapshot;
  try {
    var _handlers = [];
    var observe = function observe(doc) {
      return callbackWrapper(initObservers)({
        onMutation: onMutation,
        mutationCb: wrappedMutationEmit,
        mousemoveCb: function mousemoveCb(positions, source) {
          return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: source,
              positions: positions
            }
          });
        },
        mouseInteractionCb: function mouseInteractionCb(d) {
          return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.MouseInteraction
            }, d)
          });
        },
        scrollCb: wrappedScrollEmit,
        viewportResizeCb: function viewportResizeCb(d) {
          return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.ViewportResize
            }, d)
          });
        },
        inputCb: function inputCb(v) {
          return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.Input
            }, v)
          });
        },
        mediaInteractionCb: function mediaInteractionCb(p) {
          return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.MediaInteraction
            }, p)
          });
        },
        styleSheetRuleCb: function styleSheetRuleCb(r) {
          return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.StyleSheetRule
            }, r)
          });
        },
        styleDeclarationCb: function styleDeclarationCb(r) {
          return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.StyleDeclaration
            }, r)
          });
        },
        canvasMutationCb: wrappedCanvasMutationEmit,
        fontCb: function fontCb(p) {
          return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.Font
            }, p)
          });
        },
        selectionCb: function selectionCb(p) {
          wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.Selection
            }, p)
          });
        },
        customElementCb: function customElementCb(c) {
          wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.CustomElement
            }, c)
          });
        },
        blockClass: blockClass,
        ignoreClass: ignoreClass,
        ignoreSelector: ignoreSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        maskInputOptions: maskInputOptions,
        inlineStylesheet: inlineStylesheet,
        sampling: sampling,
        recordDOM: recordDOM,
        recordCanvas: recordCanvas,
        inlineImages: inlineImages,
        userTriggeredOnInput: userTriggeredOnInput,
        collectFonts: collectFonts,
        doc: doc,
        maskAttributeFn: maskAttributeFn,
        maskInputFn: maskInputFn,
        maskTextFn: maskTextFn,
        keepIframeSrcFn: keepIframeSrcFn,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        mirror: mirror,
        iframeManager: iframeManager,
        stylesheetManager: stylesheetManager,
        shadowDomManager: shadowDomManager,
        processedNodeManager: processedNodeManager,
        canvasManager: canvasManager,
        ignoreCSSAttributes: ignoreCSSAttributes,
        plugins: _optionalChain([plugins, 'optionalAccess', function (_8) {
          return _8.filter;
        }, 'call', function (_9) {
          return _9(function (p) {
            return p.observer;
          });
        }, 'optionalAccess', function (_10) {
          return _10.map;
        }, 'call', function (_11) {
          return _11(function (p) {
            return {
              observer: p.observer,
              options: p.options,
              callback: function callback(payload) {
                return wrappedEmit({
                  type: EventType.Plugin,
                  data: {
                    plugin: p.name,
                    payload: payload
                  }
                });
              }
            };
          });
        }]) || []
      }, {});
    };
    iframeManager.addLoadListener(function (iframeEl) {
      try {
        _handlers.push(observe(iframeEl.contentDocument));
      } catch (error) {
        console.warn(error);
      }
    });
    var init = function init() {
      takeFullSnapshot();
      _handlers.push(observe(document));
    };
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      init();
    } else {
      _handlers.push(on('DOMContentLoaded', function () {
        wrappedEmit({
          type: EventType.DomContentLoaded,
          data: {}
        });
        if (recordAfter === 'DOMContentLoaded') init();
      }));
      _handlers.push(on('load', function () {
        wrappedEmit({
          type: EventType.Load,
          data: {}
        });
        if (recordAfter === 'load') init();
      }, window));
    }
    return function () {
      _handlers.forEach(function (h) {
        return h();
      });
      processedNodeManager.destroy();
      _takeFullSnapshot = undefined;
      unregisterErrorHandler();
    };
  } catch (error) {
    console.warn(error);
  }
}
function takeFullSnapshot(isCheckout) {
  if (!_takeFullSnapshot) {
    throw new Error('please take full snapshot after start recording');
  }
  _takeFullSnapshot(isCheckout);
}
record.mirror = mirror;
record.takeFullSnapshot = takeFullSnapshot;
function _getCanvasManager(getCanvasManagerFn, options) {
  try {
    return getCanvasManagerFn ? getCanvasManagerFn(options) : new CanvasManagerNoop();
  } catch (e2) {
    console.warn('Unable to initialize CanvasManager');
    return new CanvasManagerNoop();
  }
}
var ReplayEventTypeIncrementalSnapshot = 3;
var ReplayEventTypeCustom = 5;

/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */
function timestampToMs(timestamp) {
  var isMs = timestamp > 9999999999;
  return isMs ? timestamp : timestamp * 1000;
}

/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */
function timestampToS(timestamp) {
  var isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1000 : timestamp;
}

/**
 * Add a breadcrumb event to replay.
 */
function addBreadcrumbEvent(replay, breadcrumb) {
  if (breadcrumb.category === 'sentry.transaction') {
    return;
  }
  if (['ui.click', 'ui.input'].includes(breadcrumb.category)) {
    replay.triggerUserActivity();
  } else {
    replay.checkAndHandleExpiredSession();
  }
  replay.addUpdate(function () {
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    replay.throttledAddEvent({
      type: EventType.Custom,
      // TODO: We were converting from ms to seconds for breadcrumbs, spans,
      // but maybe we should just keep them as milliseconds
      timestamp: (breadcrumb.timestamp || 0) * 1000,
      data: {
        tag: 'breadcrumb',
        // normalize to max. 10 depth and 1_000 properties per object
        payload: normalize(breadcrumb, 10, 1000)
      }
    });

    // Do not flush after console log messages
    return breadcrumb.category === 'console';
  });
}
var INTERACTIVE_SELECTOR = 'button,a';

/** Get the closest interactive parent element, or else return the given element. */
function getClosestInteractive(element) {
  var closestInteractive = element.closest(INTERACTIVE_SELECTOR);
  return closestInteractive || element;
}

/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */
function getClickTargetNode(event) {
  var target = getTargetNode(event);
  if (!target || !(target instanceof Element)) {
    return target;
  }
  return getClosestInteractive(target);
}

/** Get the event target node. */
function getTargetNode(event) {
  if (isEventWithTarget(event)) {
    return event.target;
  }
  return event;
}
function isEventWithTarget(event) {
  return _typeof(event) === 'object' && !!event && 'target' in event;
}
var handlers;

/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */
function onWindowOpen(cb) {
  // Ensure to only register this once
  if (!handlers) {
    handlers = [];
    monkeyPatchWindowOpen();
  }
  handlers.push(cb);
  return function () {
    var pos = handlers ? handlers.indexOf(cb) : -1;
    if (pos > -1) {
      handlers.splice(pos, 1);
    }
  };
}
function monkeyPatchWindowOpen() {
  fill(WINDOW, 'open', function (originalWindowOpen) {
    return function () {
      if (handlers) {
        try {
          handlers.forEach(function (handler) {
            return handler();
          });
        } catch (e) {
          // ignore errors in here
        }
      }
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }
      return originalWindowOpen.apply(WINDOW, args);
    };
  });
}

/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */
var IncrementalMutationSources = new Set([IncrementalSource.Mutation, IncrementalSource.StyleSheetRule, IncrementalSource.StyleDeclaration, IncrementalSource.AdoptedStyleSheet, IncrementalSource.CanvasMutation, IncrementalSource.Selection, IncrementalSource.MediaInteraction]);

/** Handle a click. */
function handleClick(clickDetector, clickBreadcrumb, node) {
  clickDetector.handleClick(clickBreadcrumb, node);
}

/** A click detector class that can be used to detect slow or rage clicks on elements. */
var ClickDetector = /*#__PURE__*/function () {
  // protected for testing

  function ClickDetector(replay, slowClickConfig) {
    var _addBreadcrumbEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : addBreadcrumbEvent;
    _classCallCheck(this, ClickDetector);
    this._lastMutation = 0;
    this._lastScroll = 0;
    this._clicks = [];

    // We want everything in s, but options are in ms
    this._timeout = slowClickConfig.timeout / 1000;
    this._threshold = slowClickConfig.threshold / 1000;
    this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
    this._replay = replay;
    this._ignoreSelector = slowClickConfig.ignoreSelector;
    this._addBreadcrumbEvent = _addBreadcrumbEvent;
  }

  /** Register click detection handlers on mutation or scroll. */
  _createClass(ClickDetector, [{
    key: "addListeners",
    value: function addListeners() {
      var _this15 = this;
      var cleanupWindowOpen = onWindowOpen(function () {
        // Treat window.open as mutation
        _this15._lastMutation = nowInSeconds();
      });
      this._teardown = function () {
        cleanupWindowOpen();
        _this15._clicks = [];
        _this15._lastMutation = 0;
        _this15._lastScroll = 0;
      };
    }

    /** Clean up listeners. */
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (this._teardown) {
        this._teardown();
      }
      if (this._checkClickTimeout) {
        clearTimeout(this._checkClickTimeout);
      }
    }

    /** @inheritDoc */
  }, {
    key: "handleClick",
    value: function handleClick(breadcrumb, node) {
      if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) {
        return;
      }
      var newClick = {
        timestamp: timestampToS(breadcrumb.timestamp),
        clickBreadcrumb: breadcrumb,
        // Set this to 0 so we know it originates from the click breadcrumb
        clickCount: 0,
        node: node
      };

      // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
      if (this._clicks.some(function (click) {
        return click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1;
      })) {
        return;
      }
      this._clicks.push(newClick);

      // If this is the first new click, set a timeout to check for multi clicks
      if (this._clicks.length === 1) {
        this._scheduleCheckClicks();
      }
    }

    /** @inheritDoc */
  }, {
    key: "registerMutation",
    value: function registerMutation() {
      var timestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      this._lastMutation = timestampToS(timestamp);
    }

    /** @inheritDoc */
  }, {
    key: "registerScroll",
    value: function registerScroll() {
      var timestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      this._lastScroll = timestampToS(timestamp);
    }

    /** @inheritDoc */
  }, {
    key: "registerClick",
    value: function registerClick(element) {
      var node = getClosestInteractive(element);
      this._handleMultiClick(node);
    }

    /** Count multiple clicks on elements. */
  }, {
    key: "_handleMultiClick",
    value: function _handleMultiClick(node) {
      this._getClicks(node).forEach(function (click) {
        click.clickCount++;
      });
    }

    /** Get all pending clicks for a given node. */
  }, {
    key: "_getClicks",
    value: function _getClicks(node) {
      return this._clicks.filter(function (click) {
        return click.node === node;
      });
    }

    /** Check the clicks that happened. */
  }, {
    key: "_checkClicks",
    value: function _checkClicks() {
      var _this16 = this;
      var timedOutClicks = [];
      var now = nowInSeconds();
      this._clicks.forEach(function (click) {
        if (!click.mutationAfter && _this16._lastMutation) {
          click.mutationAfter = click.timestamp <= _this16._lastMutation ? _this16._lastMutation - click.timestamp : undefined;
        }
        if (!click.scrollAfter && _this16._lastScroll) {
          click.scrollAfter = click.timestamp <= _this16._lastScroll ? _this16._lastScroll - click.timestamp : undefined;
        }

        // All of these are in seconds!
        if (click.timestamp + _this16._timeout <= now) {
          timedOutClicks.push(click);
        }
      });

      // Remove "old" clicks
      for (var _i5 = 0, _timedOutClicks = timedOutClicks; _i5 < _timedOutClicks.length; _i5++) {
        var click = _timedOutClicks[_i5];
        var pos = this._clicks.indexOf(click);
        if (pos > -1) {
          this._generateBreadcrumbs(click);
          this._clicks.splice(pos, 1);
        }
      }

      // Trigger new check, unless no clicks left
      if (this._clicks.length) {
        this._scheduleCheckClicks();
      }
    }

    /** Generate matching breadcrumb(s) for the click. */
  }, {
    key: "_generateBreadcrumbs",
    value: function _generateBreadcrumbs(click) {
      var replay = this._replay;
      var hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
      var hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
      var isSlowClick = !hadScroll && !hadMutation;
      var clickCount = click.clickCount,
        clickBreadcrumb = click.clickBreadcrumb;

      // Slow click
      if (isSlowClick) {
        // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
        // If not, it means we just timed out without scroll & mutation
        var timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
        var endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
        var breadcrumb = {
          type: 'default',
          message: clickBreadcrumb.message,
          timestamp: clickBreadcrumb.timestamp,
          category: 'ui.slowClickDetected',
          data: _objectSpread(_objectSpread({}, clickBreadcrumb.data), {}, {
            url: WINDOW.location.href,
            route: replay.getCurrentRoute(),
            timeAfterClickMs: timeAfterClickMs,
            endReason: endReason,
            // If clickCount === 0, it means multiClick was not correctly captured here
            // - we still want to send 1 in this case
            clickCount: clickCount || 1
          })
        };
        this._addBreadcrumbEvent(replay, breadcrumb);
        return;
      }

      // Multi click
      if (clickCount > 1) {
        var _breadcrumb = {
          type: 'default',
          message: clickBreadcrumb.message,
          timestamp: clickBreadcrumb.timestamp,
          category: 'ui.multiClick',
          data: _objectSpread(_objectSpread({}, clickBreadcrumb.data), {}, {
            url: WINDOW.location.href,
            route: replay.getCurrentRoute(),
            clickCount: clickCount,
            metric: true
          })
        };
        this._addBreadcrumbEvent(replay, _breadcrumb);
      }
    }

    /** Schedule to check current clicks. */
  }, {
    key: "_scheduleCheckClicks",
    value: function _scheduleCheckClicks() {
      var _this17 = this;
      if (this._checkClickTimeout) {
        clearTimeout(this._checkClickTimeout);
      }
      this._checkClickTimeout = setTimeout$3(function () {
        return _this17._checkClicks();
      }, 1000);
    }
  }]);
  return ClickDetector;
}();
var SLOW_CLICK_TAGS = ['A', 'BUTTON', 'INPUT'];

/** exported for tests only */
function ignoreElement(node, ignoreSelector) {
  if (!SLOW_CLICK_TAGS.includes(node.tagName)) {
    return true;
  }

  // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
  if (node.tagName === 'INPUT' && !['submit', 'button'].includes(node.getAttribute('type') || '')) {
    return true;
  }

  // If <a> tag, detect special variants that may not lead to an action
  // If target !== _self, we may open the link somewhere else, which would lead to no action
  // Also, when downloading a file, we may not leave the page, but still not trigger an action
  if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) {
    return true;
  }
  if (ignoreSelector && node.matches(ignoreSelector)) {
    return true;
  }
  return false;
}
function isClickBreadcrumb(breadcrumb) {
  return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}

// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds() {
  return Date.now() / 1000;
}

/** Update the click detector based on a recording event of rrweb. */
function updateClickDetectorForRecordingEvent(clickDetector, event) {
  try {
    // note: We only consider incremental snapshots here
    // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
    // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
    // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
    // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
    // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
    // But this should be more unlikely as we'd generally capture the incremental snapshot right away

    if (!isIncrementalEvent(event)) {
      return;
    }
    var source = event.data.source;
    if (IncrementalMutationSources.has(source)) {
      clickDetector.registerMutation(event.timestamp);
    }
    if (source === IncrementalSource.Scroll) {
      clickDetector.registerScroll(event.timestamp);
    }
    if (isIncrementalMouseInteraction(event)) {
      var _event$data = event.data,
        type = _event$data.type,
        id = _event$data.id;
      var node = record.mirror.getNode(id);
      if (node instanceof HTMLElement && type === MouseInteractions.Click) {
        clickDetector.registerClick(node);
      }
    }
  } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
  }
}
function isIncrementalEvent(event) {
  return event.type === ReplayEventTypeIncrementalSnapshot;
}
function isIncrementalMouseInteraction(event) {
  return event.data.source === IncrementalSource.MouseInteraction;
}

/**
 * Create a breadcrumb for a replay.
 */
function createBreadcrumb(breadcrumb) {
  return _objectSpread({
    timestamp: Date.now() / 1000,
    type: 'default'
  }, breadcrumb);
}
var NodeType;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));

// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
var ATTRIBUTES_TO_RECORD = new Set(['id', 'class', 'aria-label', 'role', 'name', 'alt', 'title', 'data-test-id', 'data-testid', 'disabled', 'aria-disabled', 'data-sentry-component']);

/**
 * Inclusion list of attributes that we want to record from the DOM element
 */
function getAttributesToRecord(attributes) {
  var obj = {};
  if (!attributes['data-sentry-component'] && attributes['data-sentry-element']) {
    attributes['data-sentry-component'] = attributes['data-sentry-element'];
  }
  for (var key in attributes) {
    if (ATTRIBUTES_TO_RECORD.has(key)) {
      var normalizedKey = key;
      if (key === 'data-testid' || key === 'data-test-id') {
        normalizedKey = 'testId';
      }
      obj[normalizedKey] = attributes[key];
    }
  }
  return obj;
}
var handleDomListener = function handleDomListener(replay) {
  return function (handlerData) {
    if (!replay.isEnabled()) {
      return;
    }
    var result = handleDom(handlerData);
    if (!result) {
      return;
    }
    var isClick = handlerData.name === 'click';
    var event = isClick ? handlerData.event : undefined;
    // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
    if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      handleClick(replay.clickDetector, result, getClickTargetNode(handlerData.event));
    }
    addBreadcrumbEvent(replay, result);
  };
};

/** Get the base DOM breadcrumb. */
function getBaseDomBreadcrumb(target, message) {
  var nodeId = record.mirror.getId(target);
  var node = nodeId && record.mirror.getNode(nodeId);
  var meta = node && record.mirror.getMeta(node);
  var element = meta && isElement(meta) ? meta : null;
  return {
    message: message,
    data: element ? {
      nodeId: nodeId,
      node: {
        id: nodeId,
        tagName: element.tagName,
        textContent: Array.from(element.childNodes).map(function (node) {
          return node.type === NodeType.Text && node.textContent;
        }).filter(Boolean) // filter out empty values
        .map(function (text) {
          return text.trim();
        }).join(''),
        attributes: getAttributesToRecord(element.attributes)
      }
    } : {}
  };
}

/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */
function handleDom(handlerData) {
  var _getDomTarget = getDomTarget(handlerData),
    target = _getDomTarget.target,
    message = _getDomTarget.message;
  return createBreadcrumb(_objectSpread({
    category: "ui.".concat(handlerData.name)
  }, getBaseDomBreadcrumb(target, message)));
}
function getDomTarget(handlerData) {
  var isClick = handlerData.name === 'click';
  var message;
  var target = null;

  // Accessing event.target can throw (see getsentry/raven-js#838, #768)
  try {
    target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
    message = htmlTreeAsString(target, {
      maxStringLength: 200
    }) || '<unknown>';
  } catch (e) {
    message = '<unknown>';
  }
  return {
    target: target,
    message: message
  };
}
function isElement(node) {
  return node.type === NodeType.Element;
}

/** Handle keyboard events & create breadcrumbs. */
function handleKeyboardEvent(replay, event) {
  if (!replay.isEnabled()) {
    return;
  }

  // Update user activity, but do not restart recording as it can create
  // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
  // session with a single "keydown" breadcrumb is created)
  replay.updateUserActivity();
  var breadcrumb = getKeyboardBreadcrumb(event);
  if (!breadcrumb) {
    return;
  }
  addBreadcrumbEvent(replay, breadcrumb);
}

/** exported only for tests */
function getKeyboardBreadcrumb(event) {
  var metaKey = event.metaKey,
    shiftKey = event.shiftKey,
    ctrlKey = event.ctrlKey,
    altKey = event.altKey,
    key = event.key,
    target = event.target;

  // never capture for input fields
  if (!target || isInputElement(target) || !key) {
    return null;
  }

  // Note: We do not consider shift here, as that means "uppercase"
  var hasModifierKey = metaKey || ctrlKey || altKey;
  var isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length

  // Do not capture breadcrumb if only a word key is pressed
  // This could leak e.g. user input
  if (!hasModifierKey && isCharacterKey) {
    return null;
  }
  var message = htmlTreeAsString(target, {
    maxStringLength: 200
  }) || '<unknown>';
  var baseBreadcrumb = getBaseDomBreadcrumb(target, message);
  return createBreadcrumb({
    category: 'ui.keyDown',
    message: message,
    data: _objectSpread(_objectSpread({}, baseBreadcrumb.data), {}, {
      metaKey: metaKey,
      shiftKey: shiftKey,
      ctrlKey: ctrlKey,
      altKey: altKey,
      key: key
    })
  });
}
function isInputElement(target) {
  return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}

// Map entryType -> function to normalize data for event
var ENTRY_TYPES = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: createResourceEntry,
  paint: createPaintEntry,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: createNavigationEntry
};

/**
 * Handler creater for web vitals
 */
function webVitalHandler(getter, replay) {
  return function (_ref23) {
    var metric = _ref23.metric;
    return void replay.replayPerformanceEntries.push(getter(metric));
  };
}

/**
 * Create replay performance entries from the browser performance entries.
 */
function createPerformanceEntries(entries) {
  return entries.map(createPerformanceEntry).filter(Boolean);
}
function createPerformanceEntry(entry) {
  var entryType = ENTRY_TYPES[entry.entryType];
  if (!entryType) {
    return null;
  }
  return entryType(entry);
}
function getAbsoluteTime(time) {
  // browserPerformanceTimeOrigin can be undefined if `performance` or
  // `performance.now` doesn't exist, but this is already checked by this integration
  return ((browserPerformanceTimeOrigin || WINDOW.performance.timeOrigin) + time) / 1000;
}
function createPaintEntry(entry) {
  var duration = entry.duration,
    entryType = entry.entryType,
    name = entry.name,
    startTime = entry.startTime;
  var start = getAbsoluteTime(startTime);
  return {
    type: entryType,
    name: name,
    start: start,
    end: start + duration,
    data: undefined
  };
}
function createNavigationEntry(entry) {
  var entryType = entry.entryType,
    name = entry.name,
    decodedBodySize = entry.decodedBodySize,
    duration = entry.duration,
    domComplete = entry.domComplete,
    encodedBodySize = entry.encodedBodySize,
    domContentLoadedEventStart = entry.domContentLoadedEventStart,
    domContentLoadedEventEnd = entry.domContentLoadedEventEnd,
    domInteractive = entry.domInteractive,
    loadEventStart = entry.loadEventStart,
    loadEventEnd = entry.loadEventEnd,
    redirectCount = entry.redirectCount,
    startTime = entry.startTime,
    transferSize = entry.transferSize,
    type = entry.type;

  // Ignore entries with no duration, they do not seem to be useful and cause dupes
  if (duration === 0) {
    return null;
  }
  return {
    type: "".concat(entryType, ".").concat(type),
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(domComplete),
    name: name,
    data: {
      size: transferSize,
      decodedBodySize: decodedBodySize,
      encodedBodySize: encodedBodySize,
      duration: duration,
      domInteractive: domInteractive,
      domContentLoadedEventStart: domContentLoadedEventStart,
      domContentLoadedEventEnd: domContentLoadedEventEnd,
      loadEventStart: loadEventStart,
      loadEventEnd: loadEventEnd,
      domComplete: domComplete,
      redirectCount: redirectCount
    }
  };
}
function createResourceEntry(entry) {
  var entryType = entry.entryType,
    initiatorType = entry.initiatorType,
    name = entry.name,
    responseEnd = entry.responseEnd,
    startTime = entry.startTime,
    decodedBodySize = entry.decodedBodySize,
    encodedBodySize = entry.encodedBodySize,
    responseStatus = entry.responseStatus,
    transferSize = entry.transferSize;

  // Core SDK handles these
  if (['fetch', 'xmlhttprequest'].includes(initiatorType)) {
    return null;
  }
  return {
    type: "".concat(entryType, ".").concat(initiatorType),
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(responseEnd),
    name: name,
    data: {
      size: transferSize,
      statusCode: responseStatus,
      decodedBodySize: decodedBodySize,
      encodedBodySize: encodedBodySize
    }
  };
}

/**
 * Add a LCP event to the replay based on a LCP metric.
 */
function getLargestContentfulPaint(metric) {
  var lastEntry = metric.entries[metric.entries.length - 1];
  var node = lastEntry && lastEntry.element ? [lastEntry.element] : undefined;
  return getWebVital(metric, 'largest-contentful-paint', node);
}
function isLayoutShift(entry) {
  return entry.sources !== undefined;
}

/**
 * Add a CLS event to the replay based on a CLS metric.
 */
function getCumulativeLayoutShift(metric) {
  var layoutShifts = [];
  var nodes = [];
  var _iterator9 = _createForOfIteratorHelper(metric.entries),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var entry = _step9.value;
      if (isLayoutShift(entry)) {
        var nodeIds = [];
        var _iterator10 = _createForOfIteratorHelper(entry.sources),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var source = _step10.value;
            if (source.node) {
              nodes.push(source.node);
              var nodeId = record.mirror.getId(source.node);
              if (nodeId) {
                nodeIds.push(nodeId);
              }
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
        layoutShifts.push({
          value: entry.value,
          nodeIds: nodeIds.length ? nodeIds : undefined
        });
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  return getWebVital(metric, 'cumulative-layout-shift', nodes, layoutShifts);
}

/**
 * Add a FID event to the replay based on a FID metric.
 */
function getFirstInputDelay(metric) {
  var lastEntry = metric.entries[metric.entries.length - 1];
  var node = lastEntry && lastEntry.target ? [lastEntry.target] : undefined;
  return getWebVital(metric, 'first-input-delay', node);
}

/**
 * Add an INP event to the replay based on an INP metric.
 */
function getInteractionToNextPaint(metric) {
  var lastEntry = metric.entries[metric.entries.length - 1];
  var node = lastEntry && lastEntry.target ? [lastEntry.target] : undefined;
  return getWebVital(metric, 'interaction-to-next-paint', node);
}

/**
 * Add an web vital event to the replay based on the web vital metric.
 */
function getWebVital(metric, name, nodes, attributions) {
  var value = metric.value;
  var rating = metric.rating;
  var end = getAbsoluteTime(value);
  return {
    type: 'web-vital',
    name: name,
    start: end,
    end: end,
    data: {
      value: value,
      size: value,
      rating: rating,
      nodeIds: nodes ? nodes.map(function (node) {
        return record.mirror.getId(node);
      }) : undefined,
      attributions: attributions
    }
  };
}

/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */
function setupPerformanceObserver(replay) {
  function addPerformanceEntry(entry) {
    // It is possible for entries to come up multiple times
    if (!replay.performanceEntries.includes(entry)) {
      replay.performanceEntries.push(entry);
    }
  }
  function onEntries(_ref24) {
    var entries = _ref24.entries;
    entries.forEach(addPerformanceEntry);
  }
  var clearCallbacks = [];
  ['navigation', 'paint', 'resource'].forEach(function (type) {
    clearCallbacks.push(addPerformanceInstrumentationHandler(type, onEntries));
  });
  clearCallbacks.push(addLcpInstrumentationHandler(webVitalHandler(getLargestContentfulPaint, replay)), addClsInstrumentationHandler(webVitalHandler(getCumulativeLayoutShift, replay)), addFidInstrumentationHandler(webVitalHandler(getFirstInputDelay, replay)), addInpInstrumentationHandler(webVitalHandler(getInteractionToNextPaint, replay)));

  // A callback to cleanup all handlers
  return function () {
    clearCallbacks.forEach(function (clearCallback) {
      return clearCallback();
    });
  };
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
var r = "var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=[\"unexpected EOF\",\"invalid block type\",\"invalid length/literal\",\"invalid distance\",\"stream finished\",\"no stream handler\",,\"no callback\",\"invalid UTF-8 data\",\"extra field too long\",\"date not in range 1980-2099\",\"filename too long\",\"stream finishing\",\"invalid zip data\"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=A(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},U=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=x(f,15),M=b.t,E=b.l,A=x(h,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=C[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(a[t]^a[t+1]<<A^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=U(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=U(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if(\"function\"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J=\"undefined\"!=typeof TextEncoder&&new TextEncoder,K=\"undefined\"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),a=0,s=function(t){i[a++]=t},o=0;o<e;++o){if(a+5>i.length){var f=new t(a+8+(e-o<<1));f.set(i),i=f}var h=n.charCodeAt(o);h<128||r?s(h):h<2048?(s(192|h>>6),s(128|63&h)):h>55295&&h<57344?(s(240|(h=65536+(1047552&h)|1023&n.charCodeAt(++o))>>18),s(128|h>>12&63),s(128|h>>6&63),s(128|63&h)):(s(224|h>>12),s(128|h>>6&63),s(128|63&h))}return b(i,0,a)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error(\"Adding invalid event\");const n=this._hasEvents?\",\":\"\";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push(\"]\",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push(\"[\")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener(\"message\",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&\"function\"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:\"init\",success:!0,response:void 0});";
function e() {
  var e = new Blob([r]);
  return URL.createObjectURL(e);
}
var CONSOLE_LEVELS = ['info', 'warn', 'error', 'log'];
var PREFIX = '[Replay] ';
function _addBreadcrumb(message) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
  addBreadcrumb({
    category: 'console',
    data: {
      logger: 'replay'
    },
    level: level,
    message: "".concat(PREFIX).concat(message)
  }, {
    level: level
  });
}
function makeReplayLogger() {
  var _capture = false;
  var _trace = false;
  var _logger = {
    exception: function exception() {
      return undefined;
    },
    infoTick: function infoTick() {
      return undefined;
    },
    setConfig: function setConfig(opts) {
      _capture = opts.captureExceptions;
      _trace = opts.traceInternals;
    }
  };
  if (DEBUG_BUILD) {
    CONSOLE_LEVELS.forEach(function (name) {
      _logger[name] = function () {
        for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
          args[_key9] = arguments[_key9];
        }
        logger$1[name].apply(logger$1, [PREFIX].concat(args));
        if (_trace) {
          _addBreadcrumb(args.join(''), severityLevelFromString(name));
        }
      };
    });
    _logger.exception = function (error) {
      for (var _len10 = arguments.length, message = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        message[_key10 - 1] = arguments[_key10];
      }
      if (message.length && _logger.error) {
        _logger.error.apply(_logger, message);
      }
      logger$1.error(PREFIX, error);
      if (_capture) {
        captureException(error);
      } else if (_trace) {
        // No need for a breadcrumb if `_capture` is enabled since it should be
        // captured as an exception
        _addBreadcrumb(error, 'error');
      }
    };
    _logger.infoTick = function () {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }
      logger$1.info.apply(logger$1, [PREFIX].concat(args));
      if (_trace) {
        // Wait a tick here to avoid race conditions for some initial logs
        // which may be added before replay is initialized
        setTimeout(function () {
          return _addBreadcrumb(args[0]);
        }, 0);
      }
    };
  } else {
    CONSOLE_LEVELS.forEach(function (name) {
      _logger[name] = function () {
        return undefined;
      };
    });
  }
  return _logger;
}
var logger = makeReplayLogger();

/** This error indicates that the event buffer size exceeded the limit.. */
var EventBufferSizeExceededError = /*#__PURE__*/function (_Error) {
  _inherits(EventBufferSizeExceededError, _Error);
  var _super = _createSuper(EventBufferSizeExceededError);
  function EventBufferSizeExceededError() {
    _classCallCheck(this, EventBufferSizeExceededError);
    return _super.call(this, "Event buffer exceeded maximum size of ".concat(REPLAY_MAX_EVENT_BUFFER_SIZE, "."));
  }
  return _createClass(EventBufferSizeExceededError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */
var EventBufferArray = /*#__PURE__*/function () {
  /** All the events that are buffered to be sent. */

  /** @inheritdoc */

  /** @inheritdoc */

  function EventBufferArray() {
    _classCallCheck(this, EventBufferArray);
    this.events = [];
    this._totalSize = 0;
    this.hasCheckout = false;
    this.waitForCheckout = false;
  }

  /** @inheritdoc */
  _createClass(EventBufferArray, [{
    key: "hasEvents",
    get: function get() {
      return this.events.length > 0;
    }

    /** @inheritdoc */
  }, {
    key: "type",
    get: function get() {
      return 'sync';
    }

    /** @inheritdoc */
  }, {
    key: "destroy",
    value: function destroy() {
      this.events = [];
    }

    /** @inheritdoc */
  }, {
    key: "addEvent",
    value: function () {
      var _addEvent2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var eventSize;
        return regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              eventSize = JSON.stringify(event).length;
              this._totalSize += eventSize;
              if (!(this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE)) {
                _context2.next = 4;
                break;
              }
              throw new EventBufferSizeExceededError();
            case 4:
              this.events.push(event);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function addEvent(_x) {
        return _addEvent2.apply(this, arguments);
      }
      return addEvent;
    }() /** @inheritdoc */
  }, {
    key: "finish",
    value: function finish() {
      var _this18 = this;
      return new Promise(function (resolve) {
        // Make a copy of the events array reference and immediately clear the
        // events member so that we do not lose new events while uploading
        // attachment.
        var eventsRet = _this18.events;
        _this18.clear();
        resolve(JSON.stringify(eventsRet));
      });
    }

    /** @inheritdoc */
  }, {
    key: "clear",
    value: function clear() {
      this.events = [];
      this._totalSize = 0;
      this.hasCheckout = false;
    }

    /** @inheritdoc */
  }, {
    key: "getEarliestTimestamp",
    value: function getEarliestTimestamp() {
      var timestamp = this.events.map(function (event) {
        return event.timestamp;
      }).sort()[0];
      if (!timestamp) {
        return null;
      }
      return timestampToMs(timestamp);
    }
  }]);
  return EventBufferArray;
}();
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
var WorkerHandler = /*#__PURE__*/function () {
  function WorkerHandler(worker) {
    _classCallCheck(this, WorkerHandler);
    this._worker = worker;
    this._id = 0;
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  _createClass(WorkerHandler, [{
    key: "ensureReady",
    value: function ensureReady() {
      var _this19 = this;
      // Ensure we only check once
      if (this._ensureReadyPromise) {
        return this._ensureReadyPromise;
      }
      this._ensureReadyPromise = new Promise(function (resolve, reject) {
        _this19._worker.addEventListener('message', function (_ref25) {
          var data = _ref25.data;
          if (data.success) {
            resolve();
          } else {
            reject();
          }
        }, {
          once: true
        });
        _this19._worker.addEventListener('error', function (error) {
          reject(error);
        }, {
          once: true
        });
      });
      return this._ensureReadyPromise;
    }

    /**
     * Destroy the worker.
     */
  }, {
    key: "destroy",
    value: function destroy() {
      DEBUG_BUILD && logger.info('Destroying compression worker');
      this._worker.terminate();
    }

    /**
     * Post message to worker and wait for response before resolving promise.
     */
  }, {
    key: "postMessage",
    value: function postMessage(method, arg) {
      var _this20 = this;
      var id = this._getAndIncrementId();
      return new Promise(function (resolve, reject) {
        var listener = function listener(_ref26) {
          var data = _ref26.data;
          var response = data;
          if (response.method !== method) {
            return;
          }

          // There can be multiple listeners for a single method, the id ensures
          // that the response matches the caller.
          if (response.id !== id) {
            return;
          }

          // At this point, we'll always want to remove listener regardless of result status
          _this20._worker.removeEventListener('message', listener);
          if (!response.success) {
            // TODO: Do some error handling, not sure what
            DEBUG_BUILD && logger.error('Error in compression worker: ', response.response);
            reject(new Error('Error in compression worker'));
            return;
          }
          resolve(response.response);
        };

        // Note: we can't use `once` option because it's possible it needs to
        // listen to multiple messages
        _this20._worker.addEventListener('message', listener);
        _this20._worker.postMessage({
          id: id,
          method: method,
          arg: arg
        });
      });
    }

    /** Get the current ID and increment it for the next call. */
  }, {
    key: "_getAndIncrementId",
    value: function _getAndIncrementId() {
      return this._id++;
    }
  }]);
  return WorkerHandler;
}();
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
var EventBufferCompressionWorker = /*#__PURE__*/function () {
  /** @inheritdoc */

  /** @inheritdoc */

  function EventBufferCompressionWorker(worker) {
    _classCallCheck(this, EventBufferCompressionWorker);
    this._worker = new WorkerHandler(worker);
    this._earliestTimestamp = null;
    this._totalSize = 0;
    this.hasCheckout = false;
    this.waitForCheckout = false;
  }

  /** @inheritdoc */
  _createClass(EventBufferCompressionWorker, [{
    key: "hasEvents",
    get: function get() {
      return !!this._earliestTimestamp;
    }

    /** @inheritdoc */
  }, {
    key: "type",
    get: function get() {
      return 'worker';
    }

    /**
     * Ensure the worker is ready (or not).
     * This will either resolve when the worker is ready, or reject if an error occurred.
     */
  }, {
    key: "ensureReady",
    value: function ensureReady() {
      return this._worker.ensureReady();
    }

    /**
     * Destroy the event buffer.
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this._worker.destroy();
    }

    /**
     * Add an event to the event buffer.
     *
     * Returns true if event was successfully received and processed by worker.
     */
  }, {
    key: "addEvent",
    value: function addEvent(event) {
      var timestamp = timestampToMs(event.timestamp);
      if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) {
        this._earliestTimestamp = timestamp;
      }
      var data = JSON.stringify(event);
      this._totalSize += data.length;
      if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
        return Promise.reject(new EventBufferSizeExceededError());
      }
      return this._sendEventToWorker(data);
    }

    /**
     * Finish the event buffer and return the compressed data.
     */
  }, {
    key: "finish",
    value: function finish() {
      return this._finishRequest();
    }

    /** @inheritdoc */
  }, {
    key: "clear",
    value: function clear() {
      this._earliestTimestamp = null;
      this._totalSize = 0;
      this.hasCheckout = false;

      // We do not wait on this, as we assume the order of messages is consistent for the worker
      this._worker.postMessage('clear').then(null, function (e) {
        DEBUG_BUILD && logger.exception(e, 'Sending "clear" message to worker failed', e);
      });
    }

    /** @inheritdoc */
  }, {
    key: "getEarliestTimestamp",
    value: function getEarliestTimestamp() {
      return this._earliestTimestamp;
    }

    /**
     * Send the event to the worker.
     */
  }, {
    key: "_sendEventToWorker",
    value: function _sendEventToWorker(data) {
      return this._worker.postMessage('addEvent', data);
    }

    /**
     * Finish the request and return the compressed data from the worker.
     */
  }, {
    key: "_finishRequest",
    value: function () {
      var _finishRequest2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this._worker.postMessage('finish');
            case 2:
              response = _context3.sent;
              this._earliestTimestamp = null;
              this._totalSize = 0;
              return _context3.abrupt("return", response);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function _finishRequest() {
        return _finishRequest2.apply(this, arguments);
      }
      return _finishRequest;
    }()
  }]);
  return EventBufferCompressionWorker;
}();
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */
var EventBufferProxy = /*#__PURE__*/function () {
  function EventBufferProxy(worker) {
    _classCallCheck(this, EventBufferProxy);
    this._fallback = new EventBufferArray();
    this._compression = new EventBufferCompressionWorker(worker);
    this._used = this._fallback;
    this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }

  /** @inheritdoc */
  _createClass(EventBufferProxy, [{
    key: "waitForCheckout",
    get: function get() {
      return this._used.waitForCheckout;
    }

    /** @inheritdoc */,
    set: /** @inheritdoc */
    // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    function set(value) {
      this._used.waitForCheckout = value;
    }

    /** @inheritDoc */
  }, {
    key: "type",
    get: function get() {
      return this._used.type;
    }

    /** @inheritDoc */
  }, {
    key: "hasEvents",
    get: function get() {
      return this._used.hasEvents;
    }

    /** @inheritdoc */
  }, {
    key: "hasCheckout",
    get: function get() {
      return this._used.hasCheckout;
    }
    /** @inheritdoc */,
    set: function set(value) {
      this._used.hasCheckout = value;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._fallback.destroy();
      this._compression.destroy();
    }

    /** @inheritdoc */
  }, {
    key: "clear",
    value: function clear() {
      return this._used.clear();
    }

    /** @inheritdoc */
  }, {
    key: "getEarliestTimestamp",
    value: function getEarliestTimestamp() {
      return this._used.getEarliestTimestamp();
    }

    /**
     * Add an event to the event buffer.
     *
     * Returns true if event was successfully added.
     */
  }, {
    key: "addEvent",
    value: function addEvent(event) {
      return this._used.addEvent(event);
    }

    /** @inheritDoc */
  }, {
    key: "finish",
    value: function () {
      var _finish = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.ensureWorkerIsLoaded();
            case 2:
              return _context4.abrupt("return", this._used.finish());
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this);
      }));
      function finish() {
        return _finish.apply(this, arguments);
      }
      return finish;
    }() /** Ensure the worker has loaded. */
  }, {
    key: "ensureWorkerIsLoaded",
    value: function ensureWorkerIsLoaded() {
      return this._ensureWorkerIsLoadedPromise;
    }

    /** Actually check if the worker has been loaded. */
  }, {
    key: "_ensureWorkerIsLoaded",
    value: function () {
      var _ensureWorkerIsLoaded2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this._compression.ensureReady();
            case 3:
              _context5.next = 9;
              break;
            case 5:
              _context5.prev = 5;
              _context5.t0 = _context5["catch"](0);
              // If the worker fails to load, we fall back to the simple buffer.
              // Nothing more to do from our side here
              DEBUG_BUILD && logger.exception(_context5.t0, 'Failed to load the compression worker, falling back to simple buffer');
              return _context5.abrupt("return");
            case 9:
              _context5.next = 11;
              return this._switchToCompressionWorker();
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this, [[0, 5]]);
      }));
      function _ensureWorkerIsLoaded() {
        return _ensureWorkerIsLoaded2.apply(this, arguments);
      }
      return _ensureWorkerIsLoaded;
    }() /** Switch the used buffer to the compression worker. */
  }, {
    key: "_switchToCompressionWorker",
    value: function () {
      var _switchToCompressionWorker2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this$_fallback, events, hasCheckout, waitForCheckout, addEventPromises, _iterator11, _step11, event;
        return regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this$_fallback = this._fallback, events = _this$_fallback.events, hasCheckout = _this$_fallback.hasCheckout, waitForCheckout = _this$_fallback.waitForCheckout;
              addEventPromises = [];
              _iterator11 = _createForOfIteratorHelper(events);
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  event = _step11.value;
                  addEventPromises.push(this._compression.addEvent(event));
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              this._compression.hasCheckout = hasCheckout;
              this._compression.waitForCheckout = waitForCheckout;

              // We switch over to the new buffer immediately - any further events will be added
              // after the previously buffered ones
              this._used = this._compression;

              // Wait for original events to be re-added before resolving
              _context6.prev = 7;
              _context6.next = 10;
              return Promise.all(addEventPromises);
            case 10:
              // Can now clear fallback buffer as it's no longer necessary
              this._fallback.clear();
              _context6.next = 16;
              break;
            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](7);
              DEBUG_BUILD && logger.exception(_context6.t0, 'Failed to add events when switching buffers.');
            case 16:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this, [[7, 13]]);
      }));
      function _switchToCompressionWorker() {
        return _switchToCompressionWorker2.apply(this, arguments);
      }
      return _switchToCompressionWorker;
    }()
  }]);
  return EventBufferProxy;
}();
/**
 * Create an event buffer for replays.
 */
function createEventBuffer(_ref27) {
  var useCompression = _ref27.useCompression,
    customWorkerUrl = _ref27.workerUrl;
  if (useCompression &&
  // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    var worker = _loadWorker(customWorkerUrl);
    if (worker) {
      return worker;
    }
  }
  DEBUG_BUILD && logger.info('Using simple buffer');
  return new EventBufferArray();
}
function _loadWorker(customWorkerUrl) {
  try {
    var workerUrl = customWorkerUrl || _getWorkerUrl();
    if (!workerUrl) {
      return;
    }
    DEBUG_BUILD && logger.info("Using compression worker".concat(customWorkerUrl ? " from ".concat(customWorkerUrl) : ''));
    var worker = new Worker(workerUrl);
    return new EventBufferProxy(worker);
  } catch (error) {
    DEBUG_BUILD && logger.exception(error, 'Failed to create compression worker');
    // Fall back to use simple event buffer array
  }
}

function _getWorkerUrl() {
  if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) {
    return e();
  }
  return '';
}

/** If sessionStorage is available. */
function hasSessionStorage() {
  try {
    // This can throw, e.g. when being accessed in a sandboxed iframe
    return 'sessionStorage' in WINDOW && !!WINDOW.sessionStorage;
  } catch (e) {
    return false;
  }
}

/**
 * Removes the session from Session Storage and unsets session in replay instance
 */
function clearSession(replay) {
  deleteSession();
  replay.session = undefined;
}

/**
 * Deletes a session from storage
 */
function deleteSession() {
  if (!hasSessionStorage()) {
    return;
  }
  try {
    WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */
function isSampled(sampleRate) {
  if (sampleRate === undefined) {
    return false;
  }

  // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
  return Math.random() < sampleRate;
}

/**
 * Get a session with defaults & applied sampling.
 */
function makeSession(session) {
  var now = Date.now();
  var id = session.id || uuid4();
  // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
  var started = session.started || now;
  var lastActivity = session.lastActivity || now;
  var segmentId = session.segmentId || 0;
  var sampled = session.sampled;
  var previousSessionId = session.previousSessionId;
  return {
    id: id,
    started: started,
    lastActivity: lastActivity,
    segmentId: segmentId,
    sampled: sampled,
    previousSessionId: previousSessionId
  };
}

/**
 * Save a session to session storage.
 */
function saveSession(session) {
  if (!hasSessionStorage()) {
    return;
  }
  try {
    WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */
function getSessionSampleType(sessionSampleRate, allowBuffering) {
  return isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}

/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */
function createSession(_ref28) {
  var sessionSampleRate = _ref28.sessionSampleRate,
    allowBuffering = _ref28.allowBuffering,
    _ref28$stickySession = _ref28.stickySession,
    stickySession = _ref28$stickySession === void 0 ? false : _ref28$stickySession;
  var _ref29 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    previousSessionId = _ref29.previousSessionId;
  var sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
  var session = makeSession({
    sampled: sampled,
    previousSessionId: previousSessionId
  });
  if (stickySession) {
    saveSession(session);
  }
  return session;
}

/**
 * Fetches a session from storage
 */
function fetchSession() {
  if (!hasSessionStorage()) {
    return null;
  }
  try {
    // This can throw if cookies are disabled
    var sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);
    if (!sessionStringFromStorage) {
      return null;
    }
    var sessionObj = JSON.parse(sessionStringFromStorage);
    DEBUG_BUILD && logger.infoTick('Loading existing session');
    return makeSession(sessionObj);
  } catch (e) {
    return null;
  }
}

/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */
function isExpired(initialTime, expiry) {
  var targetTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : +new Date();
  // Always expired if < 0
  if (initialTime === null || expiry === undefined || expiry < 0) {
    return true;
  }

  // Never expires if == 0
  if (expiry === 0) {
    return false;
  }
  return initialTime + expiry <= targetTime;
}

/**
 * Checks to see if session is expired
 */
function isSessionExpired(session, _ref30) {
  var maxReplayDuration = _ref30.maxReplayDuration,
    sessionIdleExpire = _ref30.sessionIdleExpire,
    _ref30$targetTime = _ref30.targetTime,
    targetTime = _ref30$targetTime === void 0 ? Date.now() : _ref30$targetTime;
  return (
    // First, check that maximum session length has not been exceeded
    isExpired(session.started, maxReplayDuration, targetTime) ||
    // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, sessionIdleExpire, targetTime)
  );
}

/** If the session should be refreshed or not. */
function shouldRefreshSession(session, _ref31) {
  var sessionIdleExpire = _ref31.sessionIdleExpire,
    maxReplayDuration = _ref31.maxReplayDuration;
  // If not expired, all good, just keep the session
  if (!isSessionExpired(session, {
    sessionIdleExpire: sessionIdleExpire,
    maxReplayDuration: maxReplayDuration
  })) {
    return false;
  }

  // If we are buffering & haven't ever flushed yet, always continue
  if (session.sampled === 'buffer' && session.segmentId === 0) {
    return false;
  }
  return true;
}

/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */
function loadOrCreateSession(_ref32, sessionOptions) {
  var sessionIdleExpire = _ref32.sessionIdleExpire,
    maxReplayDuration = _ref32.maxReplayDuration,
    previousSessionId = _ref32.previousSessionId;
  var existingSession = sessionOptions.stickySession && fetchSession();

  // No session exists yet, just create a new one
  if (!existingSession) {
    DEBUG_BUILD && logger.infoTick('Creating new session');
    return createSession(sessionOptions, {
      previousSessionId: previousSessionId
    });
  }
  if (!shouldRefreshSession(existingSession, {
    sessionIdleExpire: sessionIdleExpire,
    maxReplayDuration: maxReplayDuration
  })) {
    return existingSession;
  }
  DEBUG_BUILD && logger.infoTick('Session in sessionStorage is expired, creating new one...');
  return createSession(sessionOptions, {
    previousSessionId: existingSession.id
  });
}
function isCustomEvent(event) {
  return event.type === EventType.Custom;
}

/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */
function addEventSync(replay, event, isCheckout) {
  if (!shouldAddEvent(replay, event)) {
    return false;
  }

  // This should never reject
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  _addEvent(replay, event, isCheckout);
  return true;
}

/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */
function addEvent(replay, event, isCheckout) {
  if (!shouldAddEvent(replay, event)) {
    return Promise.resolve(null);
  }
  return _addEvent(replay, event, isCheckout);
}
function _addEvent(_x2, _x3, _x4) {
  return _addEvent3.apply(this, arguments);
}
/** Exported only for tests. */
function _addEvent3() {
  _addEvent3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(replay, event, isCheckout) {
    var eventBuffer, isBufferMode, replayOptions, eventAfterPossibleCallback, isExceeded, reason, client;
    return regeneratorRuntime.wrap(function _callee12$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          eventBuffer = replay.eventBuffer;
          if (!(!eventBuffer || eventBuffer.waitForCheckout && !isCheckout)) {
            _context13.next = 3;
            break;
          }
          return _context13.abrupt("return", null);
        case 3:
          isBufferMode = replay.recordingMode === 'buffer';
          _context13.prev = 4;
          if (isCheckout && isBufferMode) {
            eventBuffer.clear();
          }
          if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
          }
          replayOptions = replay.getOptions();
          eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
          if (eventAfterPossibleCallback) {
            _context13.next = 11;
            break;
          }
          return _context13.abrupt("return");
        case 11:
          _context13.next = 13;
          return eventBuffer.addEvent(eventAfterPossibleCallback);
        case 13:
          return _context13.abrupt("return", _context13.sent);
        case 16:
          _context13.prev = 16;
          _context13.t0 = _context13["catch"](4);
          isExceeded = _context13.t0 && _context13.t0 instanceof EventBufferSizeExceededError;
          reason = isExceeded ? 'addEventSizeExceeded' : 'addEvent';
          if (!(isExceeded && isBufferMode)) {
            _context13.next = 24;
            break;
          }
          // Clear buffer and wait for next checkout
          eventBuffer.clear();
          eventBuffer.waitForCheckout = true;
          return _context13.abrupt("return", null);
        case 24:
          replay.handleException(_context13.t0);
          _context13.next = 27;
          return replay.stop({
            reason: reason
          });
        case 27:
          client = getClient();
          if (client) {
            client.recordDroppedEvent('internal_sdk_error', 'replay');
          }
        case 29:
        case "end":
          return _context13.stop();
      }
    }, _callee12, null, [[4, 16]]);
  }));
  return _addEvent3.apply(this, arguments);
}
function shouldAddEvent(replay, event) {
  if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) {
    return false;
  }
  var timestampInMs = timestampToMs(event.timestamp);

  // Throw out events that happen more than 5 minutes ago. This can happen if
  // page has been left open and idle for a long period of time and user
  // comes back to trigger a new session. The performance entries rely on
  // `performance.timeOrigin`, which is when the page first opened.
  if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) {
    return false;
  }

  // Throw out events that are +60min from the initial timestamp
  if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
    DEBUG_BUILD && logger.infoTick("Skipping event with timestamp ".concat(timestampInMs, " because it is after maxReplayDuration"));
    return false;
  }
  return true;
}
function maybeApplyCallback(event, callback) {
  try {
    if (typeof callback === 'function' && isCustomEvent(event)) {
      return callback(event);
    }
  } catch (error) {
    DEBUG_BUILD && logger.exception(error, 'An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...');
    return null;
  }
  return event;
}

/** If the event is an error event */
function isErrorEvent(event) {
  return !event.type;
}

/** If the event is a transaction event */
function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/** If the event is an replay event */
function isReplayEvent(event) {
  return event.type === 'replay_event';
}

/** If the event is a feedback event */
function isFeedbackEvent(event) {
  return event.type === 'feedback';
}

/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */
function handleAfterSendEvent(replay) {
  return function (event, sendResponse) {
    if (!replay.isEnabled() || !isErrorEvent(event) && !isTransactionEvent(event)) {
      return;
    }
    var statusCode = sendResponse && sendResponse.statusCode;

    // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
    // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
    // If we do use the base transport, we skip if we encountered an non-OK status code
    if (!statusCode || statusCode < 200 || statusCode >= 300) {
      return;
    }
    if (isTransactionEvent(event)) {
      handleTransactionEvent(replay, event);
      return;
    }
    handleErrorEvent(replay, event);
  };
}
function handleTransactionEvent(replay, event) {
  var replayContext = replay.getContext();

  // Collect traceIds in _context regardless of `recordingMode`
  // In error mode, _context gets cleared on every checkout
  // We limit to max. 100 transactions linked
  if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) {
    replayContext.traceIds.add(event.contexts.trace.trace_id);
  }
}
function handleErrorEvent(replay, event) {
  var replayContext = replay.getContext();

  // Add error to list of errorIds of replay. This is ok to do even if not
  // sampled because context will get reset at next checkout.
  // XXX: There is also a race condition where it's possible to capture an
  // error to Sentry before Replay SDK has loaded, but response returns after
  // it was loaded, and this gets called.
  // We limit to max. 100 errors linked
  if (event.event_id && replayContext.errorIds.size < 100) {
    replayContext.errorIds.add(event.event_id);
  }

  // If error event is tagged with replay id it means it was sampled (when in buffer mode)
  // Need to be very careful that this does not cause an infinite loop
  if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) {
    return;
  }
  var _replay$getOptions = replay.getOptions(),
    beforeErrorSampling = _replay$getOptions.beforeErrorSampling;
  if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) {
    return;
  }
  setTimeout$3( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    return regeneratorRuntime.wrap(function _callee6$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return replay.sendBufferedReplayOrFlush();
        case 3:
          _context7.next = 8;
          break;
        case 5:
          _context7.prev = 5;
          _context7.t0 = _context7["catch"](0);
          replay.handleException(_context7.t0);
        case 8:
        case "end":
          return _context7.stop();
      }
    }, _callee6, null, [[0, 5]]);
  })));
}

/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */
function handleBeforeSendEvent(replay) {
  return function (event) {
    if (!replay.isEnabled() || !isErrorEvent(event)) {
      return;
    }
    handleHydrationError(replay, event);
  };
}
function handleHydrationError(replay, event) {
  var exceptionValue = event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].value;
  if (typeof exceptionValue !== 'string') {
    return;
  }
  if (
  // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  // With newer React versions, the messages changed to a different website https://react.dev/errors/418
  exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) ||
  // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
    var breadcrumb = createBreadcrumb({
      category: 'replay.hydrate-error',
      data: {
        url: getLocationHref()
      }
    });
    addBreadcrumbEvent(replay, breadcrumb);
  }
}

/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */
function handleBreadcrumbs(replay) {
  var client = getClient();
  if (!client) {
    return;
  }
  client.on('beforeAddBreadcrumb', function (breadcrumb) {
    return beforeAddBreadcrumb(replay, breadcrumb);
  });
}
function beforeAddBreadcrumb(replay, breadcrumb) {
  if (!replay.isEnabled() || !isBreadcrumbWithCategory(breadcrumb)) {
    return;
  }
  var result = normalizeBreadcrumb(breadcrumb);
  if (result) {
    addBreadcrumbEvent(replay, result);
  }
}

/** Exported only for tests. */
function normalizeBreadcrumb(breadcrumb) {
  if (!isBreadcrumbWithCategory(breadcrumb) || [
  // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
  'fetch', 'xhr',
  // These two are breadcrumbs for emitted sentry events, we don't care about them
  'sentry.event', 'sentry.transaction'].includes(breadcrumb.category) ||
  // We capture UI breadcrumbs separately
  breadcrumb.category.startsWith('ui.')) {
    return null;
  }
  if (breadcrumb.category === 'console') {
    return normalizeConsoleBreadcrumb(breadcrumb);
  }
  return createBreadcrumb(breadcrumb);
}

/** exported for tests only */
function normalizeConsoleBreadcrumb(breadcrumb) {
  var args = breadcrumb.data && breadcrumb.data.arguments;
  if (!Array.isArray(args) || args.length === 0) {
    return createBreadcrumb(breadcrumb);
  }
  var isTruncated = false;

  // Avoid giant args captures
  var normalizedArgs = args.map(function (arg) {
    if (!arg) {
      return arg;
    }
    if (typeof arg === 'string') {
      if (arg.length > CONSOLE_ARG_MAX_SIZE) {
        isTruncated = true;
        return "".concat(arg.slice(0, CONSOLE_ARG_MAX_SIZE), "\u2026");
      }
      return arg;
    }
    if (_typeof(arg) === 'object') {
      try {
        var normalizedArg = normalize(arg, 7);
        var stringified = JSON.stringify(normalizedArg);
        if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
          isTruncated = true;
          // We use the pretty printed JSON string here as a base
          return "".concat(JSON.stringify(normalizedArg, null, 2).slice(0, CONSOLE_ARG_MAX_SIZE), "\u2026");
        }
        return normalizedArg;
      } catch (e) {
        // fall back to default
      }
    }
    return arg;
  });
  return createBreadcrumb(_objectSpread(_objectSpread({}, breadcrumb), {}, {
    data: _objectSpread(_objectSpread({}, breadcrumb.data), {}, {
      arguments: normalizedArgs
    }, isTruncated ? {
      _meta: {
        warnings: ['CONSOLE_ARG_TRUNCATED']
      }
    } : {})
  }));
}
function isBreadcrumbWithCategory(breadcrumb) {
  return !!breadcrumb.category;
}

/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */
function isRrwebError(event, hint) {
  if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) {
    return false;
  }

  // @ts-expect-error this may be set by rrweb when it finds errors
  if (hint.originalException && hint.originalException.__rrweb__) {
    return true;
  }
  return false;
}

/**
 * Reset the `replay_id` field on the DSC.
 */
function resetReplayIdOnDynamicSamplingContext() {
  // Reset DSC on the current scope, if there is one
  var dsc = getCurrentScope().getPropagationContext().dsc;
  if (dsc) {
    delete dsc.replay_id;
  }

  // Clear it from frozen DSC on the active span
  var activeSpan = getActiveSpan();
  if (activeSpan) {
    var _dsc = getDynamicSamplingContextFromSpan(activeSpan);
    delete _dsc.replay_id;
  }
}

/**
 * Add a feedback breadcrumb event to replay.
 */
function addFeedbackBreadcrumb(replay, event) {
  replay.triggerUserActivity();
  replay.addUpdate(function () {
    if (!event.timestamp) {
      // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
      // Return true here so that we don't flush
      return true;
    }

    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: event.timestamp * 1000,
      data: {
        tag: 'breadcrumb',
        payload: {
          timestamp: event.timestamp,
          type: 'default',
          category: 'sentry.feedback',
          data: {
            feedbackId: event.event_id
          }
        }
      }
    });
    return false;
  });
}

/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */
function shouldSampleForBufferEvent(replay, event) {
  if (replay.recordingMode !== 'buffer') {
    return false;
  }

  // ignore this error because otherwise we could loop indefinitely with
  // trying to capture replay and failing
  if (event.message === UNABLE_TO_SEND_REPLAY) {
    return false;
  }

  // Require the event to be an error event & to have an exception
  if (!event.exception || event.type) {
    return false;
  }
  return isSampled(replay.getOptions().errorSampleRate);
}

/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */
function handleGlobalEventListener(replay) {
  return Object.assign(function (event, hint) {
    // Do nothing if replay has been disabled or paused
    if (!replay.isEnabled() || replay.isPaused()) {
      return event;
    }
    if (isReplayEvent(event)) {
      // Replays have separate set of breadcrumbs, do not include breadcrumbs
      // from core SDK
      delete event.breadcrumbs;
      return event;
    }

    // We only want to handle errors, transactions, and feedbacks, nothing else
    if (!isErrorEvent(event) && !isTransactionEvent(event) && !isFeedbackEvent(event)) {
      return event;
    }

    // Ensure we do not add replay_id if the session is expired
    var isSessionActive = replay.checkAndHandleExpiredSession();
    if (!isSessionActive) {
      // prevent exceeding replay durations by removing the expired replayId from the DSC
      resetReplayIdOnDynamicSamplingContext();
      return event;
    }
    if (isFeedbackEvent(event)) {
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      replay.flush();
      event.contexts.feedback.replay_id = replay.getSessionId();
      // Add a replay breadcrumb for this piece of feedback
      addFeedbackBreadcrumb(replay, event);
      return event;
    }

    // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
    // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
    if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
      DEBUG_BUILD && logger.log('Ignoring error from rrweb internals', event);
      return null;
    }

    // When in buffer mode, we decide to sample here.
    // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
    // And convert the buffer session to a full session
    var isErrorEventSampled = shouldSampleForBufferEvent(replay, event);

    // Tag errors if it has been sampled in buffer mode, or if it is session mode
    // Only tag transactions if in session mode
    var shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
    if (shouldTagReplayId) {
      event.tags = _objectSpread(_objectSpread({}, event.tags), {}, {
        replayId: replay.getSessionId()
      });
    }
    return event;
  }, {
    id: 'Replay'
  });
}

/**
 * Create a "span" for each performance entry.
 */
function createPerformanceSpans(replay, entries) {
  return entries.map(function (_ref34) {
    var type = _ref34.type,
      start = _ref34.start,
      end = _ref34.end,
      name = _ref34.name,
      data = _ref34.data;
    var response = replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: start,
      data: {
        tag: 'performanceSpan',
        payload: {
          op: type,
          description: name,
          startTimestamp: start,
          endTimestamp: end,
          data: data
        }
      }
    });

    // If response is a string, it means its either THROTTLED or SKIPPED
    return typeof response === 'string' ? Promise.resolve(null) : response;
  });
}
function handleHistory(handlerData) {
  var from = handlerData.from,
    to = handlerData.to;
  var now = Date.now() / 1000;
  return {
    type: 'navigation.push',
    start: now,
    end: now,
    name: to,
    data: {
      previous: from
    }
  };
}

/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */
function handleHistorySpanListener(replay) {
  return function (handlerData) {
    if (!replay.isEnabled()) {
      return;
    }
    var result = handleHistory(handlerData);
    if (result === null) {
      return;
    }

    // Need to collect visited URLs
    replay.getContext().urls.push(result.name);
    replay.triggerUserActivity();
    replay.addUpdate(function () {
      createPerformanceSpans(replay, [result]);
      // Returning false to flush
      return false;
    });
  };
}

/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */
function shouldFilterRequest(replay, url) {
  // If we enabled the `traceInternals` experiment, we want to trace everything
  if (DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) {
    return false;
  }
  return isSentryRequestUrl(url, getClient());
}

/** Add a performance entry breadcrumb */
function addNetworkBreadcrumb(replay, result) {
  if (!replay.isEnabled()) {
    return;
  }
  if (result === null) {
    return;
  }
  if (shouldFilterRequest(replay, result.name)) {
    return;
  }
  replay.addUpdate(function () {
    createPerformanceSpans(replay, [result]);
    // Returning true will cause `addUpdate` to not flush
    // We do not want network requests to cause a flush. This will prevent
    // recurring/polling requests from keeping the replay session alive.
    return true;
  });
}

/** Get the size of a body. */
function getBodySize(body) {
  if (!body) {
    return undefined;
  }
  var textEncoder = new TextEncoder();
  try {
    if (typeof body === 'string') {
      return textEncoder.encode(body).length;
    }
    if (body instanceof URLSearchParams) {
      return textEncoder.encode(body.toString()).length;
    }
    if (body instanceof FormData) {
      var formDataStr = _serializeFormData(body);
      return textEncoder.encode(formDataStr).length;
    }
    if (body instanceof Blob) {
      return body.size;
    }
    if (body instanceof ArrayBuffer) {
      return body.byteLength;
    }

    // Currently unhandled types: ArrayBufferView, ReadableStream
  } catch (e) {
    // just return undefined
  }
  return undefined;
}

/** Convert a Content-Length header to number/undefined.  */
function parseContentLengthHeader(header) {
  if (!header) {
    return undefined;
  }
  var size = parseInt(header, 10);
  return isNaN(size) ? undefined : size;
}

/** Get the string representation of a body. */
function getBodyString(body) {
  try {
    if (typeof body === 'string') {
      return [body];
    }
    if (body instanceof URLSearchParams) {
      return [body.toString()];
    }
    if (body instanceof FormData) {
      return [_serializeFormData(body)];
    }
    if (!body) {
      return [undefined];
    }
  } catch (error) {
    DEBUG_BUILD && logger.exception(error, 'Failed to serialize body', body);
    return [undefined, 'BODY_PARSE_ERROR'];
  }
  DEBUG_BUILD && logger.info('Skipping network body because of body type', body);
  return [undefined, 'UNPARSEABLE_BODY_TYPE'];
}

/** Merge a warning into an existing network request/response. */
function mergeWarning(info, warning) {
  if (!info) {
    return {
      headers: {},
      size: undefined,
      _meta: {
        warnings: [warning]
      }
    };
  }
  var newMeta = _objectSpread({}, info._meta);
  var existingWarnings = newMeta.warnings || [];
  newMeta.warnings = [].concat(_toConsumableArray(existingWarnings), [warning]);
  info._meta = newMeta;
  return info;
}

/** Convert ReplayNetworkRequestData to a PerformanceEntry. */
function makeNetworkReplayBreadcrumb(type, data) {
  if (!data) {
    return null;
  }
  var startTimestamp = data.startTimestamp,
    endTimestamp = data.endTimestamp,
    url = data.url,
    method = data.method,
    statusCode = data.statusCode,
    request = data.request,
    response = data.response;
  var result = {
    type: type,
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: url,
    data: dropUndefinedKeys({
      method: method,
      statusCode: statusCode,
      request: request,
      response: response
    })
  };
  return result;
}

/** Build the request or response part of a replay network breadcrumb that was skipped. */
function buildSkippedNetworkRequestOrResponse(bodySize) {
  return {
    headers: {},
    size: bodySize,
    _meta: {
      warnings: ['URL_SKIPPED']
    }
  };
}

/** Build the request or response part of a replay network breadcrumb. */
function buildNetworkRequestOrResponse(headers, bodySize, body) {
  if (!bodySize && Object.keys(headers).length === 0) {
    return undefined;
  }
  if (!bodySize) {
    return {
      headers: headers
    };
  }
  if (!body) {
    return {
      headers: headers,
      size: bodySize
    };
  }
  var info = {
    headers: headers,
    size: bodySize
  };
  var _normalizeNetworkBody = normalizeNetworkBody(body),
    normalizedBody = _normalizeNetworkBody.body,
    warnings = _normalizeNetworkBody.warnings;
  info.body = normalizedBody;
  if (warnings && warnings.length > 0) {
    info._meta = {
      warnings: warnings
    };
  }
  return info;
}

/** Filter a set of headers */
function getAllowedHeaders(headers, allowedHeaders) {
  return Object.entries(headers).reduce(function (filteredHeaders, _ref35) {
    var _ref36 = _slicedToArray(_ref35, 2),
      key = _ref36[0],
      value = _ref36[1];
    var normalizedKey = key.toLowerCase();
    // Avoid putting empty strings into the headers
    if (allowedHeaders.includes(normalizedKey) && headers[key]) {
      filteredHeaders[normalizedKey] = value;
    }
    return filteredHeaders;
  }, {});
}
function _serializeFormData(formData) {
  // This is a bit simplified, but gives us a decent estimate
  // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
  // @ts-expect-error passing FormData to URLSearchParams actually works
  return new URLSearchParams(formData).toString();
}
function normalizeNetworkBody(body) {
  if (!body || typeof body !== 'string') {
    return {
      body: body
    };
  }
  var exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;
  var isProbablyJson = _strIsProbablyJson(body);
  if (exceedsSizeLimit) {
    var truncatedBody = body.slice(0, NETWORK_BODY_MAX_SIZE);
    if (isProbablyJson) {
      return {
        body: truncatedBody,
        warnings: ['MAYBE_JSON_TRUNCATED']
      };
    }
    return {
      body: "".concat(truncatedBody, "\u2026"),
      warnings: ['TEXT_TRUNCATED']
    };
  }
  if (isProbablyJson) {
    try {
      var jsonBody = JSON.parse(body);
      return {
        body: jsonBody
      };
    } catch (e2) {
      // fall back to just send the body as string
    }
  }
  return {
    body: body
  };
}
function _strIsProbablyJson(str) {
  var first = str[0];
  var last = str[str.length - 1];

  // Simple check: If this does not start & end with {} or [], it's not JSON
  return first === '[' && last === ']' || first === '{' && last === '}';
}

/** Match an URL against a list of strings/Regex. */
function urlMatches(url, urls) {
  var fullUrl = getFullUrl(url);
  return stringMatchesSomePattern(fullUrl, urls);
}

/** exported for tests */
function getFullUrl(url) {
  var baseURI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WINDOW.document.baseURI;
  // Short circuit for common cases:
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith(WINDOW.location.origin)) {
    return url;
  }
  var fixedUrl = new URL(url, baseURI);

  // If these do not match, we are not dealing with a relative URL, so just return it
  if (fixedUrl.origin !== new URL(baseURI).origin) {
    return url;
  }
  var fullUrl = fixedUrl.href;

  // Remove trailing slashes, if they don't match the original URL
  if (!url.endsWith('/') && fullUrl.endsWith('/')) {
    return fullUrl.slice(0, -1);
  }
  return fullUrl;
}

/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */
function captureFetchBreadcrumbToReplay(_x5, _x6, _x7) {
  return _captureFetchBreadcrumbToReplay.apply(this, arguments);
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function _captureFetchBreadcrumbToReplay() {
  _captureFetchBreadcrumbToReplay = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(breadcrumb, hint, options) {
    var data, result;
    return regeneratorRuntime.wrap(function _callee13$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return _prepareFetchData(breadcrumb, hint, options);
        case 3:
          data = _context14.sent;
          // Create a replay performance entry from this breadcrumb
          result = makeNetworkReplayBreadcrumb('resource.fetch', data);
          addNetworkBreadcrumb(options.replay, result);
          _context14.next = 11;
          break;
        case 8:
          _context14.prev = 8;
          _context14.t0 = _context14["catch"](0);
          DEBUG_BUILD && logger.exception(_context14.t0, 'Failed to capture fetch breadcrumb');
        case 11:
        case "end":
          return _context14.stop();
      }
    }, _callee13, null, [[0, 8]]);
  }));
  return _captureFetchBreadcrumbToReplay.apply(this, arguments);
}
function enrichFetchBreadcrumb(breadcrumb, hint) {
  var input = hint.input,
    response = hint.response;
  var body = input ? _getFetchRequestArgBody(input) : undefined;
  var reqSize = getBodySize(body);
  var resSize = response ? parseContentLengthHeader(response.headers.get('content-length')) : undefined;
  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}
function _prepareFetchData(_x8, _x9, _x10) {
  return _prepareFetchData2.apply(this, arguments);
}
function _prepareFetchData2() {
  _prepareFetchData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(breadcrumb, hint, options) {
    var now, _hint$startTimestamp2, startTimestamp, _hint$endTimestamp2, endTimestamp, _breadcrumb$data2, url, method, _breadcrumb$data2$sta, statusCode, requestBodySize, responseBodySize, captureDetails, request, response;
    return regeneratorRuntime.wrap(function _callee14$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          now = Date.now();
          _hint$startTimestamp2 = hint.startTimestamp, startTimestamp = _hint$startTimestamp2 === void 0 ? now : _hint$startTimestamp2, _hint$endTimestamp2 = hint.endTimestamp, endTimestamp = _hint$endTimestamp2 === void 0 ? now : _hint$endTimestamp2;
          _breadcrumb$data2 = breadcrumb.data, url = _breadcrumb$data2.url, method = _breadcrumb$data2.method, _breadcrumb$data2$sta = _breadcrumb$data2.status_code, statusCode = _breadcrumb$data2$sta === void 0 ? 0 : _breadcrumb$data2$sta, requestBodySize = _breadcrumb$data2.request_body_size, responseBodySize = _breadcrumb$data2.response_body_size;
          captureDetails = urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);
          request = captureDetails ? _getRequestInfo(options, hint.input, requestBodySize) : buildSkippedNetworkRequestOrResponse(requestBodySize);
          _context15.next = 7;
          return _getResponseInfo(captureDetails, options, hint.response, responseBodySize);
        case 7:
          response = _context15.sent;
          return _context15.abrupt("return", {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
          });
        case 9:
        case "end":
          return _context15.stop();
      }
    }, _callee14);
  }));
  return _prepareFetchData2.apply(this, arguments);
}
function _getRequestInfo(_ref37, input, requestBodySize) {
  var networkCaptureBodies = _ref37.networkCaptureBodies,
    networkRequestHeaders = _ref37.networkRequestHeaders;
  var headers = input ? getRequestHeaders(input, networkRequestHeaders) : {};
  if (!networkCaptureBodies) {
    return buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
  }

  // We only want to transmit string or string-like bodies
  var requestBody = _getFetchRequestArgBody(input);
  var _getBodyString = getBodyString(requestBody),
    _getBodyString2 = _slicedToArray(_getBodyString, 2),
    bodyStr = _getBodyString2[0],
    warning = _getBodyString2[1];
  var data = buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
  if (warning) {
    return mergeWarning(data, warning);
  }
  return data;
}

/** Exported only for tests. */
function _getResponseInfo(_x11, _x12, _x13, _x14) {
  return _getResponseInfo2.apply(this, arguments);
}
function _getResponseInfo2() {
  _getResponseInfo2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(captureDetails, _ref38, response, responseBodySize) {
    var networkCaptureBodies, networkResponseHeaders, headers, _yield$_parseFetchRes, _yield$_parseFetchRes2, bodyText, warning, result;
    return regeneratorRuntime.wrap(function _callee15$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          networkCaptureBodies = _ref38.networkCaptureBodies, networkResponseHeaders = _ref38.networkResponseHeaders;
          if (!(!captureDetails && responseBodySize !== undefined)) {
            _context16.next = 3;
            break;
          }
          return _context16.abrupt("return", buildSkippedNetworkRequestOrResponse(responseBodySize));
        case 3:
          headers = response ? getAllHeaders(response.headers, networkResponseHeaders) : {};
          if (!(!response || !networkCaptureBodies && responseBodySize !== undefined)) {
            _context16.next = 6;
            break;
          }
          return _context16.abrupt("return", buildNetworkRequestOrResponse(headers, responseBodySize, undefined));
        case 6:
          _context16.next = 8;
          return _parseFetchResponseBody(response);
        case 8:
          _yield$_parseFetchRes = _context16.sent;
          _yield$_parseFetchRes2 = _slicedToArray(_yield$_parseFetchRes, 2);
          bodyText = _yield$_parseFetchRes2[0];
          warning = _yield$_parseFetchRes2[1];
          result = getResponseData(bodyText, {
            networkCaptureBodies: networkCaptureBodies,
            responseBodySize: responseBodySize,
            captureDetails: captureDetails,
            headers: headers
          });
          if (!warning) {
            _context16.next = 15;
            break;
          }
          return _context16.abrupt("return", mergeWarning(result, warning));
        case 15:
          return _context16.abrupt("return", result);
        case 16:
        case "end":
          return _context16.stop();
      }
    }, _callee15);
  }));
  return _getResponseInfo2.apply(this, arguments);
}
function getResponseData(bodyText, _ref39) {
  var networkCaptureBodies = _ref39.networkCaptureBodies,
    responseBodySize = _ref39.responseBodySize,
    captureDetails = _ref39.captureDetails,
    headers = _ref39.headers;
  try {
    var size = bodyText && bodyText.length && responseBodySize === undefined ? getBodySize(bodyText) : responseBodySize;
    if (!captureDetails) {
      return buildSkippedNetworkRequestOrResponse(size);
    }
    if (networkCaptureBodies) {
      return buildNetworkRequestOrResponse(headers, size, bodyText);
    }
    return buildNetworkRequestOrResponse(headers, size, undefined);
  } catch (error) {
    DEBUG_BUILD && logger.exception(error, 'Failed to serialize response body');
    // fallback
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }
}
function _parseFetchResponseBody(_x15) {
  return _parseFetchResponseBody2.apply(this, arguments);
}
function _parseFetchResponseBody2() {
  _parseFetchResponseBody2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(response) {
    var res, text;
    return regeneratorRuntime.wrap(function _callee16$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          res = _tryCloneResponse(response);
          if (res) {
            _context17.next = 3;
            break;
          }
          return _context17.abrupt("return", [undefined, 'BODY_PARSE_ERROR']);
        case 3:
          _context17.prev = 3;
          _context17.next = 6;
          return _tryGetResponseText(res);
        case 6:
          text = _context17.sent;
          return _context17.abrupt("return", [text]);
        case 10:
          _context17.prev = 10;
          _context17.t0 = _context17["catch"](3);
          if (!(_context17.t0 instanceof Error && _context17.t0.message.indexOf('Timeout') > -1)) {
            _context17.next = 15;
            break;
          }
          DEBUG_BUILD && logger.warn('Parsing text body from response timed out');
          return _context17.abrupt("return", [undefined, 'BODY_PARSE_TIMEOUT']);
        case 15:
          DEBUG_BUILD && logger.exception(_context17.t0, 'Failed to get text body from response');
          return _context17.abrupt("return", [undefined, 'BODY_PARSE_ERROR']);
        case 17:
        case "end":
          return _context17.stop();
      }
    }, _callee16, null, [[3, 10]]);
  }));
  return _parseFetchResponseBody2.apply(this, arguments);
}
function _getFetchRequestArgBody() {
  var fetchArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // We only support getting the body from the fetch options
  if (fetchArgs.length !== 2 || _typeof(fetchArgs[1]) !== 'object') {
    return undefined;
  }
  return fetchArgs[1].body;
}
function getAllHeaders(headers, allowedHeaders) {
  var allHeaders = {};
  allowedHeaders.forEach(function (header) {
    if (headers.get(header)) {
      allHeaders[header] = headers.get(header);
    }
  });
  return allHeaders;
}
function getRequestHeaders(fetchArgs, allowedHeaders) {
  if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') {
    return getHeadersFromOptions(fetchArgs[0], allowedHeaders);
  }
  if (fetchArgs.length === 2) {
    return getHeadersFromOptions(fetchArgs[1], allowedHeaders);
  }
  return {};
}
function getHeadersFromOptions(input, allowedHeaders) {
  if (!input) {
    return {};
  }
  var headers = input.headers;
  if (!headers) {
    return {};
  }
  if (headers instanceof Headers) {
    return getAllHeaders(headers, allowedHeaders);
  }

  // We do not support this, as it is not really documented (anymore?)
  if (Array.isArray(headers)) {
    return {};
  }
  return getAllowedHeaders(headers, allowedHeaders);
}
function _tryCloneResponse(response) {
  try {
    // We have to clone this, as the body can only be read once
    return response.clone();
  } catch (error) {
    // this can throw if the response was already consumed before
    DEBUG_BUILD && logger.exception(error, 'Failed to clone response body');
  }
}

/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */
function _tryGetResponseText(response) {
  return new Promise(function (resolve, reject) {
    var timeout = setTimeout$3(function () {
      return reject(new Error('Timeout while trying to read response body'));
    }, 500);
    _getResponseText(response).then(function (txt) {
      return resolve(txt);
    }, function (reason) {
      return reject(reason);
    }).finally(function () {
      return clearTimeout(timeout);
    });
  });
}
function _getResponseText(_x16) {
  return _getResponseText2.apply(this, arguments);
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */
function _getResponseText2() {
  _getResponseText2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(response) {
    return regeneratorRuntime.wrap(function _callee17$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return response.text();
        case 2:
          return _context18.abrupt("return", _context18.sent);
        case 3:
        case "end":
          return _context18.stop();
      }
    }, _callee17);
  }));
  return _getResponseText2.apply(this, arguments);
}
function captureXhrBreadcrumbToReplay(_x17, _x18, _x19) {
  return _captureXhrBreadcrumbToReplay.apply(this, arguments);
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function _captureXhrBreadcrumbToReplay() {
  _captureXhrBreadcrumbToReplay = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(breadcrumb, hint, options) {
    var data, result;
    return regeneratorRuntime.wrap(function _callee18$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          try {
            data = _prepareXhrData(breadcrumb, hint, options); // Create a replay performance entry from this breadcrumb
            result = makeNetworkReplayBreadcrumb('resource.xhr', data);
            addNetworkBreadcrumb(options.replay, result);
          } catch (error) {
            DEBUG_BUILD && logger.exception(error, 'Failed to capture xhr breadcrumb');
          }
        case 1:
        case "end":
          return _context19.stop();
      }
    }, _callee18);
  }));
  return _captureXhrBreadcrumbToReplay.apply(this, arguments);
}
function enrichXhrBreadcrumb(breadcrumb, hint) {
  var xhr = hint.xhr,
    input = hint.input;
  if (!xhr) {
    return;
  }
  var reqSize = getBodySize(input);
  var resSize = xhr.getResponseHeader('content-length') ? parseContentLengthHeader(xhr.getResponseHeader('content-length')) : _getBodySize(xhr.response, xhr.responseType);
  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}
function _prepareXhrData(breadcrumb, hint, options) {
  var now = Date.now();
  var _hint$startTimestamp = hint.startTimestamp,
    startTimestamp = _hint$startTimestamp === void 0 ? now : _hint$startTimestamp,
    _hint$endTimestamp = hint.endTimestamp,
    endTimestamp = _hint$endTimestamp === void 0 ? now : _hint$endTimestamp,
    input = hint.input,
    xhr = hint.xhr;
  var _breadcrumb$data = breadcrumb.data,
    url = _breadcrumb$data.url,
    method = _breadcrumb$data.method,
    _breadcrumb$data$stat = _breadcrumb$data.status_code,
    statusCode = _breadcrumb$data$stat === void 0 ? 0 : _breadcrumb$data$stat,
    requestBodySize = _breadcrumb$data.request_body_size,
    responseBodySize = _breadcrumb$data.response_body_size;
  if (!url) {
    return null;
  }
  if (!xhr || !urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
    var _request = buildSkippedNetworkRequestOrResponse(requestBodySize);
    var _response = buildSkippedNetworkRequestOrResponse(responseBodySize);
    return {
      startTimestamp: startTimestamp,
      endTimestamp: endTimestamp,
      url: url,
      method: method,
      statusCode: statusCode,
      request: _request,
      response: _response
    };
  }
  var xhrInfo = xhr[SENTRY_XHR_DATA_KEY];
  var networkRequestHeaders = xhrInfo ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
  var networkResponseHeaders = getAllowedHeaders(getResponseHeaders(xhr), options.networkResponseHeaders);
  var _ref40 = options.networkCaptureBodies ? getBodyString(input) : [undefined],
    _ref41 = _slicedToArray(_ref40, 2),
    requestBody = _ref41[0],
    requestWarning = _ref41[1];
  var _ref42 = options.networkCaptureBodies ? _getXhrResponseBody(xhr) : [undefined],
    _ref43 = _slicedToArray(_ref42, 2),
    responseBody = _ref43[0],
    responseWarning = _ref43[1];
  var request = buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
  var response = buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
  return {
    startTimestamp: startTimestamp,
    endTimestamp: endTimestamp,
    url: url,
    method: method,
    statusCode: statusCode,
    request: requestWarning ? mergeWarning(request, requestWarning) : request,
    response: responseWarning ? mergeWarning(response, responseWarning) : response
  };
}
function getResponseHeaders(xhr) {
  var headers = xhr.getAllResponseHeaders();
  if (!headers) {
    return {};
  }
  return headers.split('\r\n').reduce(function (acc, line) {
    var _line$split = line.split(': '),
      _line$split2 = _slicedToArray(_line$split, 2),
      key = _line$split2[0],
      value = _line$split2[1];
    if (value) {
      acc[key.toLowerCase()] = value;
    }
    return acc;
  }, {});
}
function _getXhrResponseBody(xhr) {
  // We collect errors that happen, but only log them if we can't get any response body
  var errors = [];
  try {
    return [xhr.responseText];
  } catch (e) {
    errors.push(e);
  }

  // Try to manually parse the response body, if responseText fails
  try {
    return _parseXhrResponse(xhr.response, xhr.responseType);
  } catch (e) {
    errors.push(e);
  }
  DEBUG_BUILD && logger.warn.apply(logger, ['Failed to get xhr response body'].concat(errors));
  return [undefined];
}

/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */
function _parseXhrResponse(body, responseType) {
  try {
    if (typeof body === 'string') {
      return [body];
    }
    if (body instanceof Document) {
      return [body.body.outerHTML];
    }
    if (responseType === 'json' && body && _typeof(body) === 'object') {
      return [JSON.stringify(body)];
    }
    if (!body) {
      return [undefined];
    }
  } catch (error) {
    DEBUG_BUILD && logger.exception(error, 'Failed to serialize body', body);
    return [undefined, 'BODY_PARSE_ERROR'];
  }
  DEBUG_BUILD && logger.info('Skipping network body because of body type', body);
  return [undefined, 'UNPARSEABLE_BODY_TYPE'];
}
function _getBodySize(body, responseType) {
  try {
    var bodyStr = responseType === 'json' && body && _typeof(body) === 'object' ? JSON.stringify(body) : body;
    return getBodySize(bodyStr);
  } catch (e2) {
    return undefined;
  }
}

/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */
function handleNetworkBreadcrumbs(replay) {
  var client = getClient();
  try {
    var _replay$getOptions2 = replay.getOptions(),
      networkDetailAllowUrls = _replay$getOptions2.networkDetailAllowUrls,
      networkDetailDenyUrls = _replay$getOptions2.networkDetailDenyUrls,
      networkCaptureBodies = _replay$getOptions2.networkCaptureBodies,
      networkRequestHeaders = _replay$getOptions2.networkRequestHeaders,
      networkResponseHeaders = _replay$getOptions2.networkResponseHeaders;
    var options = {
      replay: replay,
      networkDetailAllowUrls: networkDetailAllowUrls,
      networkDetailDenyUrls: networkDetailDenyUrls,
      networkCaptureBodies: networkCaptureBodies,
      networkRequestHeaders: networkRequestHeaders,
      networkResponseHeaders: networkResponseHeaders
    };
    if (client) {
      client.on('beforeAddBreadcrumb', function (breadcrumb, hint) {
        return beforeAddNetworkBreadcrumb(options, breadcrumb, hint);
      });
    }
  } catch (e2) {
    // Do nothing
  }
}

/** just exported for tests */
function beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
  if (!breadcrumb.data) {
    return;
  }
  try {
    if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichXhrBreadcrumb(breadcrumb, hint);

      // This call should not reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
    }
    if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichFetchBreadcrumb(breadcrumb, hint);

      // This call should not reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
    }
  } catch (e) {
    DEBUG_BUILD && logger.exception(e, 'Error when enriching network breadcrumb');
  }
}
function _isXhrBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'xhr';
}
function _isFetchBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'fetch';
}
function _isXhrHint(hint) {
  return hint && hint.xhr;
}
function _isFetchHint(hint) {
  return hint && hint.response;
}

/**
 * Add global listeners that cannot be removed.
 */
function addGlobalListeners(replay) {
  // Listeners from core SDK //
  var client = getClient();
  addClickKeypressInstrumentationHandler(handleDomListener(replay));
  addHistoryInstrumentationHandler(handleHistorySpanListener(replay));
  handleBreadcrumbs(replay);
  handleNetworkBreadcrumbs(replay);

  // Tag all (non replay) events that get sent to Sentry with the current
  // replay ID so that we can reference them later in the UI
  var eventProcessor = handleGlobalEventListener(replay);
  addEventProcessor(eventProcessor);

  // If a custom client has no hooks yet, we continue to use the "old" implementation
  if (client) {
    client.on('beforeSendEvent', handleBeforeSendEvent(replay));
    client.on('afterSendEvent', handleAfterSendEvent(replay));
    client.on('createDsc', function (dsc) {
      var replayId = replay.getSessionId();
      // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
      if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
        // Ensure to check that the session is still active - it could have expired in the meanwhile
        var isSessionActive = replay.checkAndHandleExpiredSession();
        if (isSessionActive) {
          dsc.replay_id = replayId;
        }
      }
    });
    client.on('spanStart', function (span) {
      replay.lastActiveSpan = span;
    });

    // We may be missing the initial spanStart due to timing issues,
    // so we capture it on finish again.
    client.on('spanEnd', function (span) {
      replay.lastActiveSpan = span;
    });

    // We want to flush replay
    client.on('beforeSendFeedback', function (feedbackEvent, options) {
      var replayId = replay.getSessionId();
      if (options && options.includeReplay && replay.isEnabled() && replayId) {
        // This should never reject
        if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) {
          feedbackEvent.contexts.feedback.replay_id = replayId;
        }
      }
    });
  }
}

/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */
function addMemoryEntry(_x20) {
  return _addMemoryEntry.apply(this, arguments);
}
function _addMemoryEntry() {
  _addMemoryEntry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(replay) {
    return regeneratorRuntime.wrap(function _callee19$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          return _context20.abrupt("return", Promise.all(createPerformanceSpans(replay, [
          // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
          createMemoryEntry(WINDOW.performance.memory)])));
        case 4:
          _context20.prev = 4;
          _context20.t0 = _context20["catch"](0);
          return _context20.abrupt("return", []);
        case 7:
        case "end":
          return _context20.stop();
      }
    }, _callee19, null, [[0, 4]]);
  }));
  return _addMemoryEntry.apply(this, arguments);
}
function createMemoryEntry(memoryEntry) {
  var jsHeapSizeLimit = memoryEntry.jsHeapSizeLimit,
    totalJSHeapSize = memoryEntry.totalJSHeapSize,
    usedJSHeapSize = memoryEntry.usedJSHeapSize;
  // we don't want to use `getAbsoluteTime` because it adds the event time to the
  // time origin, so we get the current timestamp instead
  var time = Date.now() / 1000;
  return {
    type: 'memory',
    name: 'memory',
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit: jsHeapSizeLimit,
        totalJSHeapSize: totalJSHeapSize,
        usedJSHeapSize: usedJSHeapSize
      }
    }
  };
}

/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */
function debounce(func, wait, options) {
  var callbackReturnValue;
  var timerId;
  var maxTimerId;
  var maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
  function invokeFunc() {
    cancelTimers();
    callbackReturnValue = func();
    return callbackReturnValue;
  }
  function cancelTimers() {
    timerId !== undefined && clearTimeout(timerId);
    maxTimerId !== undefined && clearTimeout(maxTimerId);
    timerId = maxTimerId = undefined;
  }
  function flush() {
    if (timerId !== undefined || maxTimerId !== undefined) {
      return invokeFunc();
    }
    return callbackReturnValue;
  }
  function debounced() {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout$3(invokeFunc, wait);
    if (maxWait && maxTimerId === undefined) {
      maxTimerId = setTimeout$3(invokeFunc, maxWait);
    }
    return callbackReturnValue;
  }
  debounced.cancel = cancelTimers;
  debounced.flush = flush;
  return debounced;
}
var NAVIGATOR = GLOBAL_OBJ.navigator;

/**
 *  Disable sampling mousemove events on iOS browsers as this can cause blocking the main thread
 *  https://github.com/getsentry/sentry-javascript/issues/14534
 */
function getRecordingSamplingOptions() {
  if (/iPhone|iPad|iPod/i.test(NAVIGATOR && NAVIGATOR.userAgent || '') || /Macintosh/i.test(NAVIGATOR && NAVIGATOR.userAgent || '') && NAVIGATOR && NAVIGATOR.maxTouchPoints && NAVIGATOR.maxTouchPoints > 1) {
    return {
      sampling: {
        mousemove: false
      }
    };
  }
  return {};
}

/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */
function getHandleRecordingEmit(replay) {
  var hadFirstEvent = false;
  return function (event, _isCheckout) {
    // If this is false, it means session is expired, create and a new session and wait for checkout
    if (!replay.checkAndHandleExpiredSession()) {
      DEBUG_BUILD && logger.warn('Received replay event after session expired.');
      return;
    }

    // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
    // We also want to treat the first event as a checkout, so we handle this specifically here
    var isCheckout = _isCheckout || !hadFirstEvent;
    hadFirstEvent = true;
    if (replay.clickDetector) {
      updateClickDetectorForRecordingEvent(replay.clickDetector, event);
    }

    // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
    replay.addUpdate(function () {
      // The session is always started immediately on pageload/init, but for
      // error-only replays, it should reflect the most recent checkout
      // when an error occurs. Clear any state that happens before this current
      // checkout. This needs to happen before `addEvent()` which updates state
      // dependent on this reset.
      if (replay.recordingMode === 'buffer' && isCheckout) {
        replay.setInitialState();
      }

      // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
      // Skip all further steps
      if (!addEventSync(replay, event, isCheckout)) {
        // Return true to skip scheduling a debounced flush
        return true;
      }

      // Different behavior for full snapshots (type=2), ignore other event types
      // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
      if (!isCheckout) {
        return false;
      }
      var session = replay.session;

      // Additionally, create a meta event that will capture certain SDK settings.
      // In order to handle buffer mode, this needs to either be done when we
      // receive checkout events or at flush time. We have an experimental mode
      // to perform multiple checkouts a session (the idea is to improve
      // seeking during playback), so also only include if segmentId is 0
      // (handled in `addSettingsEvent`).
      //
      // `isCheckout` is always true, but want to be explicit that it should
      // only be added for checkouts
      addSettingsEvent(replay, isCheckout);

      // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
      // this should usually be the timestamp of the checkout event, but to be safe...
      if (replay.recordingMode === 'buffer' && session && replay.eventBuffer) {
        var earliestEvent = replay.eventBuffer.getEarliestTimestamp();
        if (earliestEvent) {
          DEBUG_BUILD && logger.info("Updating session start time to earliest event in buffer to ".concat(new Date(earliestEvent)));
          session.started = earliestEvent;
          if (replay.getOptions().stickySession) {
            saveSession(session);
          }
        }
      }

      // If there is a previousSessionId after a full snapshot occurs, then
      // the replay session was started due to session expiration. The new session
      // is started before triggering a new checkout and contains the id
      // of the previous session. Do not immediately flush in this case
      // to avoid capturing only the checkout and instead the replay will
      // be captured if they perform any follow-up actions.
      if (session && session.previousSessionId) {
        return true;
      }
      if (replay.recordingMode === 'session') {
        // If the full snapshot is due to an initial load, we will not have
        // a previous session ID. In this case, we want to buffer events
        // for a set amount of time before flushing. This can help avoid
        // capturing replays of users that immediately close the window.

        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        void replay.flush();
      }
      return true;
    });
  };
}

/**
 * Exported for tests
 */
function createOptionsEvent(replay) {
  var options = replay.getOptions();
  return {
    type: EventType.Custom,
    timestamp: Date.now(),
    data: {
      tag: 'options',
      payload: {
        shouldRecordCanvas: replay.isRecordingCanvas(),
        sessionSampleRate: options.sessionSampleRate,
        errorSampleRate: options.errorSampleRate,
        useCompressionOption: options.useCompression,
        blockAllMedia: options.blockAllMedia,
        maskAllText: options.maskAllText,
        maskAllInputs: options.maskAllInputs,
        useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
        networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: options.networkCaptureBodies,
        networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: options.networkResponseHeaders.length > 0
      }
    }
  };
}

/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */
function addSettingsEvent(replay, isCheckout) {
  // Only need to add this event when sending the first segment
  if (!isCheckout || !replay.session || replay.session.segmentId !== 0) {
    return;
  }
  addEventSync(replay, createOptionsEvent(replay), false);
}

/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */
function createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
  return createEnvelope(createEventEnvelopeHeaders(replayEvent, getSdkMetadataForEnvelopeHeader(replayEvent), tunnel, dsn), [[{
    type: 'replay_event'
  }, replayEvent], [{
    type: 'replay_recording',
    // If string then we need to encode to UTF8, otherwise will have
    // wrong size. TextEncoder has similar browser support to
    // MutationObserver, although it does not accept IE11.
    length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
  }, recordingData]]);
}

/**
 * Prepare the recording data ready to be sent.
 */
function prepareRecordingData(_ref44) {
  var recordingData = _ref44.recordingData,
    headers = _ref44.headers;
  var payloadWithSequence;

  // XXX: newline is needed to separate sequence id from events
  var replayHeaders = "".concat(JSON.stringify(headers), "\n");
  if (typeof recordingData === 'string') {
    payloadWithSequence = "".concat(replayHeaders).concat(recordingData);
  } else {
    var enc = new TextEncoder();
    // XXX: newline is needed to separate sequence id from events
    var sequence = enc.encode(replayHeaders);
    // Merge the two Uint8Arrays
    payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
    payloadWithSequence.set(sequence);
    payloadWithSequence.set(recordingData, sequence.length);
  }
  return payloadWithSequence;
}

/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */
function prepareReplayEvent(_x21) {
  return _prepareReplayEvent.apply(this, arguments);
}
/**
 * Send replay attachment using `fetch()`
 */
function _prepareReplayEvent() {
  _prepareReplayEvent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(_ref45) {
    var client, scope, event_id, event, integrations, eventHint, preparedEvent, metadata, _ref55, name, version;
    return regeneratorRuntime.wrap(function _callee20$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          client = _ref45.client, scope = _ref45.scope, event_id = _ref45.replayId, event = _ref45.event;
          integrations = _typeof(client._integrations) === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
          eventHint = {
            event_id: event_id,
            integrations: integrations
          };
          client.emit('preprocessEvent', event, eventHint);
          _context21.next = 6;
          return prepareEvent(client.getOptions(), event, eventHint, scope, client, getIsolationScope());
        case 6:
          preparedEvent = _context21.sent;
          if (preparedEvent) {
            _context21.next = 9;
            break;
          }
          return _context21.abrupt("return", null);
        case 9:
          // This normally happens in browser client "_prepareEvent"
          // but since we do not use this private method from the client, but rather the plain import
          // we need to do this manually.
          preparedEvent.platform = preparedEvent.platform || 'javascript';

          // extract the SDK name because `client._prepareEvent` doesn't add it to the event
          metadata = client.getSdkMetadata();
          _ref55 = metadata && metadata.sdk || {}, name = _ref55.name, version = _ref55.version;
          preparedEvent.sdk = _objectSpread(_objectSpread({}, preparedEvent.sdk), {}, {
            name: name || 'sentry.javascript.unknown',
            version: version || '0.0.0'
          });
          return _context21.abrupt("return", preparedEvent);
        case 14:
        case "end":
          return _context21.stop();
      }
    }, _callee20);
  }));
  return _prepareReplayEvent.apply(this, arguments);
}
function sendReplayRequest(_x22) {
  return _sendReplayRequest.apply(this, arguments);
}
/**
 * This error indicates that the transport returned an invalid status code.
 */
function _sendReplayRequest() {
  _sendReplayRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(_ref46) {
    var recordingData, replayId, segment_id, eventContext, timestamp, session, preparedRecordingData, urls, errorIds, traceIds, initialTimestamp, client, scope, transport, dsn, baseEvent, replayEvent, envelope, response, error, rateLimits;
    return regeneratorRuntime.wrap(function _callee21$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          recordingData = _ref46.recordingData, replayId = _ref46.replayId, segment_id = _ref46.segmentId, eventContext = _ref46.eventContext, timestamp = _ref46.timestamp, session = _ref46.session;
          preparedRecordingData = prepareRecordingData({
            recordingData: recordingData,
            headers: {
              segment_id: segment_id
            }
          });
          urls = eventContext.urls, errorIds = eventContext.errorIds, traceIds = eventContext.traceIds, initialTimestamp = eventContext.initialTimestamp;
          client = getClient();
          scope = getCurrentScope();
          transport = client && client.getTransport();
          dsn = client && client.getDsn();
          if (!(!client || !transport || !dsn || !session.sampled)) {
            _context22.next = 9;
            break;
          }
          return _context22.abrupt("return", resolvedSyncPromise({}));
        case 9:
          baseEvent = {
            type: REPLAY_EVENT_NAME,
            replay_start_timestamp: initialTimestamp / 1000,
            timestamp: timestamp / 1000,
            error_ids: errorIds,
            trace_ids: traceIds,
            urls: urls,
            replay_id: replayId,
            segment_id: segment_id,
            replay_type: session.sampled
          };
          _context22.next = 12;
          return prepareReplayEvent({
            scope: scope,
            client: client,
            replayId: replayId,
            event: baseEvent
          });
        case 12:
          replayEvent = _context22.sent;
          if (replayEvent) {
            _context22.next = 17;
            break;
          }
          // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
          client.recordDroppedEvent('event_processor', 'replay', baseEvent);
          DEBUG_BUILD && logger.info('An event processor returned `null`, will not send event.');
          return _context22.abrupt("return", resolvedSyncPromise({}));
        case 17:
          /*
          For reference, the fully built event looks something like this:
          {
              "type": "replay_event",
              "timestamp": 1670837008.634,
              "error_ids": [
                  "errorId"
              ],
              "trace_ids": [
                  "traceId"
              ],
              "urls": [
                  "https://example.com"
              ],
              "replay_id": "eventId",
              "segment_id": 3,
              "replay_type": "error",
              "platform": "javascript",
              "event_id": "eventId",
              "environment": "production",
              "sdk": {
                  "integrations": [
                      "BrowserTracing",
                      "Replay"
                  ],
                  "name": "sentry.javascript.browser",
                  "version": "7.25.0"
              },
              "sdkProcessingMetadata": {},
              "contexts": {
              },
          }
          */

          // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
          // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
          // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
          // of this `delete`, lest we miss putting it back in the next time the property is in use.)
          delete replayEvent.sdkProcessingMetadata;
          envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
          _context22.prev = 19;
          _context22.next = 22;
          return transport.send(envelope);
        case 22:
          response = _context22.sent;
          _context22.next = 30;
          break;
        case 25:
          _context22.prev = 25;
          _context22.t0 = _context22["catch"](19);
          error = new Error(UNABLE_TO_SEND_REPLAY);
          try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = _context22.t0;
          } catch (e) {
            // nothing to do
          }
          throw error;
        case 30:
          if (!(typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300))) {
            _context22.next = 32;
            break;
          }
          throw new TransportStatusCodeError(response.statusCode);
        case 32:
          rateLimits = updateRateLimits({}, response);
          if (!isRateLimited(rateLimits, 'replay')) {
            _context22.next = 35;
            break;
          }
          throw new RateLimitError(rateLimits);
        case 35:
          return _context22.abrupt("return", response);
        case 36:
        case "end":
          return _context22.stop();
      }
    }, _callee21, null, [[19, 25]]);
  }));
  return _sendReplayRequest.apply(this, arguments);
}
var TransportStatusCodeError = /*#__PURE__*/function (_Error2) {
  _inherits(TransportStatusCodeError, _Error2);
  var _super2 = _createSuper(TransportStatusCodeError);
  function TransportStatusCodeError(statusCode) {
    _classCallCheck(this, TransportStatusCodeError);
    return _super2.call(this, "Transport returned status code ".concat(statusCode));
  }
  return _createClass(TransportStatusCodeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * This error indicates that we hit a rate limit API error.
 */
var RateLimitError = /*#__PURE__*/function (_Error3) {
  _inherits(RateLimitError, _Error3);
  var _super3 = _createSuper(RateLimitError);
  function RateLimitError(rateLimits) {
    var _this21;
    _classCallCheck(this, RateLimitError);
    _this21 = _super3.call(this, 'Rate limit hit');
    _this21.rateLimits = rateLimits;
    return _this21;
  }
  return _createClass(RateLimitError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Finalize and send the current replay event to Sentry
 */
function sendReplay(_x23) {
  return _sendReplay.apply(this, arguments);
}
function _sendReplay() {
  _sendReplay = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(replayData) {
    var retryConfig,
      recordingData,
      onError,
      error,
      _args23 = arguments;
    return regeneratorRuntime.wrap(function _callee23$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          retryConfig = _args23.length > 1 && _args23[1] !== undefined ? _args23[1] : {
            count: 0,
            interval: RETRY_BASE_INTERVAL
          };
          recordingData = replayData.recordingData, onError = replayData.onError; // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
          if (recordingData.length) {
            _context24.next = 4;
            break;
          }
          return _context24.abrupt("return");
        case 4:
          _context24.prev = 4;
          _context24.next = 7;
          return sendReplayRequest(replayData);
        case 7:
          return _context24.abrupt("return", true);
        case 10:
          _context24.prev = 10;
          _context24.t0 = _context24["catch"](4);
          if (!(_context24.t0 instanceof TransportStatusCodeError || _context24.t0 instanceof RateLimitError)) {
            _context24.next = 14;
            break;
          }
          throw _context24.t0;
        case 14:
          // Capture error for every failed replay
          setContext('Replays', {
            _retryCount: retryConfig.count
          });
          if (onError) {
            onError(_context24.t0);
          }

          // If an error happened here, it's likely that uploading the attachment
          // failed, we'll can retry with the same events payload
          if (!(retryConfig.count >= RETRY_MAX_COUNT)) {
            _context24.next = 20;
            break;
          }
          error = new Error("".concat(UNABLE_TO_SEND_REPLAY, " - max retries exceeded"));
          try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = _context24.t0;
          } catch (e) {
            // nothing to do
          }
          throw error;
        case 20:
          // will retry in intervals of 5, 10, 30
          retryConfig.interval *= ++retryConfig.count;
          return _context24.abrupt("return", new Promise(function (resolve, reject) {
            setTimeout$3( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
              return regeneratorRuntime.wrap(function _callee22$(_context23) {
                while (1) switch (_context23.prev = _context23.next) {
                  case 0:
                    _context23.prev = 0;
                    _context23.next = 3;
                    return sendReplay(replayData, retryConfig);
                  case 3:
                    resolve(true);
                    _context23.next = 9;
                    break;
                  case 6:
                    _context23.prev = 6;
                    _context23.t0 = _context23["catch"](0);
                    reject(_context23.t0);
                  case 9:
                  case "end":
                    return _context23.stop();
                }
              }, _callee22, null, [[0, 6]]);
            })), retryConfig.interval);
          }));
        case 22:
        case "end":
          return _context24.stop();
      }
    }, _callee23, null, [[4, 10]]);
  }));
  return _sendReplay.apply(this, arguments);
}
var THROTTLED = '__THROTTLED';
var SKIPPED = '__SKIPPED';

/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(fn, maxCount, durationSeconds) {
  var counter = new Map();
  var _cleanup = function _cleanup(now) {
    var threshold = now - durationSeconds;
    counter.forEach(function (_value, key) {
      if (key < threshold) {
        counter.delete(key);
      }
    });
  };
  var _getTotalCount = function _getTotalCount() {
    return _toConsumableArray(counter.values()).reduce(function (a, b) {
      return a + b;
    }, 0);
  };
  var isThrottled = false;
  return function () {
    // Date in second-precision, which we use as basis for the throttling
    var now = Math.floor(Date.now() / 1000);

    // First, make sure to delete any old entries
    _cleanup(now);

    // If already over limit, do nothing
    if (_getTotalCount() >= maxCount) {
      var wasThrottled = isThrottled;
      isThrottled = true;
      return wasThrottled ? SKIPPED : THROTTLED;
    }
    isThrottled = false;
    var count = counter.get(now) || 0;
    counter.set(now, count + 1);
    return fn.apply(void 0, arguments);
  };
}

/* eslint-disable max-lines */ // TODO: We might want to split this file up

/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */
var ReplayContainer = /*#__PURE__*/function () {
  /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */

  /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */

  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */

  /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */

  /**
   * Options to pass to `rrweb.record()`
   */

  /**
   * Timestamp of the last user activity. This lives across sessions.
   */

  /**
   * Is the integration currently active?
   */

  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */

  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */

  /**
   * Function to stop recording
   */

  /**
   * Internal use for canvas recording options
   */

  function ReplayContainer(_ref47) {
    var _this22 = this;
    var options = _ref47.options,
      recordingOptions = _ref47.recordingOptions;
    _classCallCheck(this, ReplayContainer);
    ReplayContainer.prototype.__init.call(this);
    ReplayContainer.prototype.__init2.call(this);
    ReplayContainer.prototype.__init3.call(this);
    ReplayContainer.prototype.__init4.call(this);
    ReplayContainer.prototype.__init5.call(this);
    ReplayContainer.prototype.__init6.call(this);
    this.eventBuffer = null;
    this.performanceEntries = [];
    this.replayPerformanceEntries = [];
    this.recordingMode = 'session';
    this.timeouts = {
      sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
      sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION
    };
    this._lastActivity = Date.now();
    this._isEnabled = false;
    this._isPaused = false;
    this._requiresManualStart = false;
    this._hasInitializedCoreListeners = false;
    this._context = {
      errorIds: new Set(),
      traceIds: new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ''
    };
    this._recordingOptions = recordingOptions;
    this._options = options;
    this._debouncedFlush = debounce(function () {
      return _this22._flush();
    }, this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    });
    this._throttledAddEvent = throttle(function (event, isCheckout) {
      return addEvent(_this22, event, isCheckout);
    },
    // Max 300 events...
    300,
    // ... per 5s
    5);
    var _this$getOptions = this.getOptions(),
      slowClickTimeout = _this$getOptions.slowClickTimeout,
      slowClickIgnoreSelectors = _this$getOptions.slowClickIgnoreSelectors;
    var slowClickConfig = slowClickTimeout ? {
      threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
      timeout: slowClickTimeout,
      scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
      ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
    } : undefined;
    if (slowClickConfig) {
      this.clickDetector = new ClickDetector(this, slowClickConfig);
    }

    // Configure replay logger w/ experimental options
    if (DEBUG_BUILD) {
      var experiments = options._experiments;
      logger.setConfig({
        captureExceptions: !!experiments.captureExceptions,
        traceInternals: !!experiments.traceInternals
      });
    }
  }

  /** Get the event context. */
  _createClass(ReplayContainer, [{
    key: "getContext",
    value: function getContext() {
      return this._context;
    }

    /** If recording is currently enabled. */
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this._isEnabled;
    }

    /** If recording is currently paused. */
  }, {
    key: "isPaused",
    value: function isPaused() {
      return this._isPaused;
    }

    /**
     * Determine if canvas recording is enabled
     */
  }, {
    key: "isRecordingCanvas",
    value: function isRecordingCanvas() {
      return Boolean(this._canvas);
    }

    /** Get the replay integration options. */
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this._options;
    }

    /** A wrapper to conditionally capture exceptions. */
  }, {
    key: "handleException",
    value: function handleException(error) {
      DEBUG_BUILD && logger.exception(error);
      if (this._options.onError) {
        this._options.onError(error);
      }
    }

    /**
     * Initializes the plugin based on sampling configuration. Should not be
     * called outside of constructor.
     */
  }, {
    key: "initializeSampling",
    value: function initializeSampling(previousSessionId) {
      var _this$_options = this._options,
        errorSampleRate = _this$_options.errorSampleRate,
        sessionSampleRate = _this$_options.sessionSampleRate;

      // If neither sample rate is > 0, then do nothing - user will need to call one of
      // `start()` or `startBuffering` themselves.
      var requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
      this._requiresManualStart = requiresManualStart;
      if (requiresManualStart) {
        return;
      }

      // Otherwise if there is _any_ sample rate set, try to load an existing
      // session, or create a new one.
      this._initializeSessionForSampling(previousSessionId);
      if (!this.session) {
        // This should not happen, something wrong has occurred
        DEBUG_BUILD && logger.exception(new Error('Unable to initialize and create session'));
        return;
      }
      if (this.session.sampled === false) {
        // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
      }

      // If segmentId > 0, it means we've previously already captured this session
      // In this case, we still want to continue in `session` recording mode
      this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
      DEBUG_BUILD && logger.infoTick("Starting replay in ".concat(this.recordingMode, " mode"));
      this._initializeRecording();
    }

    /**
     * Start a replay regardless of sampling rate. Calling this will always
     * create a new session. Will log a message if replay is already in progress.
     *
     * Creates or loads a session, attaches listeners to varying events (DOM,
     * _performanceObserver, Recording, Sentry SDK, etc)
     */
  }, {
    key: "start",
    value: function start() {
      if (this._isEnabled && this.recordingMode === 'session') {
        DEBUG_BUILD && logger.info('Recording is already in progress');
        return;
      }
      if (this._isEnabled && this.recordingMode === 'buffer') {
        DEBUG_BUILD && logger.info('Buffering is in progress, call `flush()` to save the replay');
        return;
      }
      DEBUG_BUILD && logger.infoTick('Starting replay in session mode');

      // Required as user activity is initially set in
      // constructor, so if `start()` is called after
      // session idle expiration, a replay will not be
      // created due to an idle timeout.
      this._updateUserActivity();
      var session = loadOrCreateSession({
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire
      }, {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: false
      });
      this.session = session;
      this._initializeRecording();
    }

    /**
     * Start replay buffering. Buffers until `flush()` is called or, if
     * `replaysOnErrorSampleRate` > 0, an error occurs.
     */
  }, {
    key: "startBuffering",
    value: function startBuffering() {
      if (this._isEnabled) {
        DEBUG_BUILD && logger.info('Buffering is in progress, call `flush()` to save the replay');
        return;
      }
      DEBUG_BUILD && logger.infoTick('Starting replay in buffer mode');
      var session = loadOrCreateSession({
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration
      }, {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: true
      });
      this.session = session;
      this.recordingMode = 'buffer';
      this._initializeRecording();
    }

    /**
     * Start recording.
     *
     * Note that this will cause a new DOM checkout
     */
  }, {
    key: "startRecording",
    value: function startRecording() {
      try {
        var canvasOptions = this._canvas;
        this._stopRecording = record(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this._recordingOptions), this.recordingMode === 'buffer' ? {
          checkoutEveryNms: BUFFER_CHECKOUT_TIME
        } :
        // Otherwise, use experimental option w/ min checkout time of 6 minutes
        // This is to improve playback seeking as there could potentially be
        // less mutations to process in the worse cases.
        //
        // checkout by "N" events is probably ideal, but means we have less
        // control about the number of checkouts we make (which generally
        // increases replay size)
        this._options._experiments.continuousCheckout && {
          // Minimum checkout time is 6 minutes
          checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
        }), {}, {
          emit: getHandleRecordingEmit(this)
        }, getRecordingSamplingOptions()), {}, {
          onMutation: this._onMutationHandler
        }, canvasOptions ? {
          recordCanvas: canvasOptions.recordCanvas,
          getCanvasManager: canvasOptions.getCanvasManager,
          sampling: canvasOptions.sampling,
          dataURLOptions: canvasOptions.dataURLOptions
        } : {}));
      } catch (err) {
        this.handleException(err);
      }
    }

    /**
     * Stops the recording, if it was running.
     *
     * Returns true if it was previously stopped, or is now stopped,
     * otherwise false.
     */
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      try {
        if (this._stopRecording) {
          this._stopRecording();
          this._stopRecording = undefined;
        }
        return true;
      } catch (err) {
        this.handleException(err);
        return false;
      }
    }

    /**
     * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
     * does not support a teardown
     */
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _ref48,
          _ref48$forceFlush,
          forceFlush,
          reason,
          _args7 = arguments;
        return regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _ref48 = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, _ref48$forceFlush = _ref48.forceFlush, forceFlush = _ref48$forceFlush === void 0 ? false : _ref48$forceFlush, reason = _ref48.reason;
              if (this._isEnabled) {
                _context8.next = 3;
                break;
              }
              return _context8.abrupt("return");
            case 3:
              // We can't move `_isEnabled` after awaiting a flush, otherwise we can
              // enter into an infinite loop when `stop()` is called while flushing.
              this._isEnabled = false;
              _context8.prev = 4;
              DEBUG_BUILD && logger.info("Stopping Replay".concat(reason ? " triggered by ".concat(reason) : ''));
              resetReplayIdOnDynamicSamplingContext();
              this._removeListeners();
              this.stopRecording();
              this._debouncedFlush.cancel();
              // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
              // `_isEnabled` state of the plugin since it was disabled above.
              if (!forceFlush) {
                _context8.next = 13;
                break;
              }
              _context8.next = 13;
              return this._flush({
                force: true
              });
            case 13:
              // After flush, destroy event buffer
              this.eventBuffer && this.eventBuffer.destroy();
              this.eventBuffer = null;

              // Clear session from session storage, note this means if a new session
              // is started after, it will not have `previousSessionId`
              clearSession(this);
              _context8.next = 21;
              break;
            case 18:
              _context8.prev = 18;
              _context8.t0 = _context8["catch"](4);
              this.handleException(_context8.t0);
            case 21:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this, [[4, 18]]);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
    /**
     * Pause some replay functionality. See comments for `_isPaused`.
     * This differs from stop as this only stops DOM recording, it is
     * not as thorough of a shutdown as `stop()`.
     */
  }, {
    key: "pause",
    value: function pause() {
      if (this._isPaused) {
        return;
      }
      this._isPaused = true;
      this.stopRecording();
      DEBUG_BUILD && logger.info('Pausing replay');
    }

    /**
     * Resumes recording, see notes for `pause().
     *
     * Note that calling `startRecording()` here will cause a
     * new DOM checkout.`
     */
  }, {
    key: "resume",
    value: function resume() {
      if (!this._isPaused || !this._checkSession()) {
        return;
      }
      this._isPaused = false;
      this.startRecording();
      DEBUG_BUILD && logger.info('Resuming replay');
    }

    /**
     * If not in "session" recording mode, flush event buffer which will create a new replay.
     * Unless `continueRecording` is false, the replay will continue to record and
     * behave as a "session"-based replay.
     *
     * Otherwise, queue up a flush.
     */
  }, {
    key: "sendBufferedReplayOrFlush",
    value: function () {
      var _sendBufferedReplayOrFlush = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _ref49,
          _ref49$continueRecord,
          continueRecording,
          activityTime,
          hasStoppedRecording,
          _args8 = arguments;
        return regeneratorRuntime.wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _ref49 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, _ref49$continueRecord = _ref49.continueRecording, continueRecording = _ref49$continueRecord === void 0 ? true : _ref49$continueRecord;
              if (!(this.recordingMode === 'session')) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return", this.flushImmediate());
            case 3:
              activityTime = Date.now();
              DEBUG_BUILD && logger.info('Converting buffer to session');

              // Allow flush to complete before resuming as a session recording, otherwise
              // the checkout from `startRecording` may be included in the payload.
              // Prefer to keep the error replay as a separate (and smaller) segment
              // than the session replay.
              _context9.next = 7;
              return this.flushImmediate();
            case 7:
              hasStoppedRecording = this.stopRecording();
              if (!(!continueRecording || !hasStoppedRecording)) {
                _context9.next = 10;
                break;
              }
              return _context9.abrupt("return");
            case 10:
              if (!(this.recordingMode === 'session')) {
                _context9.next = 12;
                break;
              }
              return _context9.abrupt("return");
            case 12:
              // Re-start recording in session-mode
              this.recordingMode = 'session';

              // Once this session ends, we do not want to refresh it
              if (this.session) {
                this._updateUserActivity(activityTime);
                this._updateSessionActivity(activityTime);
                this._maybeSaveSession();
              }
              this.startRecording();
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee8, this);
      }));
      function sendBufferedReplayOrFlush() {
        return _sendBufferedReplayOrFlush.apply(this, arguments);
      }
      return sendBufferedReplayOrFlush;
    }()
    /**
     * We want to batch uploads of replay events. Save events only if
     * `<flushMinDelay>` milliseconds have elapsed since the last event
     * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
     *
     * Accepts a callback to perform side-effects and returns true to stop batch
     * processing and hand back control to caller.
     */
  }, {
    key: "addUpdate",
    value: function addUpdate(cb) {
      // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
      var cbResult = cb();

      // If this option is turned on then we will only want to call `flush`
      // explicitly
      if (this.recordingMode === 'buffer') {
        return;
      }

      // If callback is true, we do not want to continue with flushing -- the
      // caller will need to handle it.
      if (cbResult === true) {
        return;
      }

      // addUpdate is called quite frequently - use _debouncedFlush so that it
      // respects the flush delays and does not flush immediately
      this._debouncedFlush();
    }

    /**
     * Updates the user activity timestamp and resumes recording. This should be
     * called in an event handler for a user action that we consider as the user
     * being "active" (e.g. a mouse click).
     */
  }, {
    key: "triggerUserActivity",
    value: function triggerUserActivity() {
      this._updateUserActivity();

      // This case means that recording was once stopped due to inactivity.
      // Ensure that recording is resumed.
      if (!this._stopRecording) {
        // Create a new session, otherwise when the user action is flushed, it
        // will get rejected due to an expired session.
        if (!this._checkSession()) {
          return;
        }

        // Note: This will cause a new DOM checkout
        this.resume();
        return;
      }

      // Otherwise... recording was never suspended, continue as normalish
      this.checkAndHandleExpiredSession();
      this._updateSessionActivity();
    }

    /**
     * Updates the user activity timestamp *without* resuming
     * recording. Some user events (e.g. keydown) can be create
     * low-value replays that only contain the keypress as a
     * breadcrumb. Instead this would require other events to
     * create a new replay after a session has expired.
     */
  }, {
    key: "updateUserActivity",
    value: function updateUserActivity() {
      this._updateUserActivity();
      this._updateSessionActivity();
    }

    /**
     * Only flush if `this.recordingMode === 'session'`
     */
  }, {
    key: "conditionalFlush",
    value: function conditionalFlush() {
      if (this.recordingMode === 'buffer') {
        return Promise.resolve();
      }
      return this.flushImmediate();
    }

    /**
     * Flush using debounce flush
     */
  }, {
    key: "flush",
    value: function flush() {
      return this._debouncedFlush();
    }

    /**
     * Always flush via `_debouncedFlush` so that we do not have flushes triggered
     * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
     * cases of multiple flushes happening closely together.
     */
  }, {
    key: "flushImmediate",
    value: function flushImmediate() {
      this._debouncedFlush();
      // `.flush` is provided by the debounced function, analogously to lodash.debounce
      return this._debouncedFlush.flush();
    }

    /**
     * Cancels queued up flushes.
     */
  }, {
    key: "cancelFlush",
    value: function cancelFlush() {
      this._debouncedFlush.cancel();
    }

    /** Get the current session (=replay) ID */
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      return this.session && this.session.id;
    }

    /**
     * Checks if recording should be stopped due to user inactivity. Otherwise
     * check if session is expired and create a new session if so. Triggers a new
     * full snapshot on new session.
     *
     * Returns true if session is not expired, false otherwise.
     * @hidden
     */
  }, {
    key: "checkAndHandleExpiredSession",
    value: function checkAndHandleExpiredSession() {
      // Prevent starting a new session if the last user activity is older than
      // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
      // session+recording. This creates noisy replays that do not have much
      // content in them.
      if (this._lastActivity && isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
        // Pause recording only for session-based replays. Otherwise, resuming
        // will create a new replay and will conflict with users who only choose
        // to record error-based replays only. (e.g. the resumed replay will not
        // contain a reference to an error)
        this.pause();
        return;
      }

      // --- There is recent user activity --- //
      // This will create a new session if expired, based on expiry length
      if (!this._checkSession()) {
        // Check session handles the refreshing itself
        return false;
      }
      return true;
    }

    /**
     * Capture some initial state that can change throughout the lifespan of the
     * replay. This is required because otherwise they would be captured at the
     * first flush.
     */
  }, {
    key: "setInitialState",
    value: function setInitialState() {
      var urlPath = "".concat(WINDOW.location.pathname).concat(WINDOW.location.hash).concat(WINDOW.location.search);
      var url = "".concat(WINDOW.location.origin).concat(urlPath);
      this.performanceEntries = [];
      this.replayPerformanceEntries = [];

      // Reset _context as well
      this._clearContext();
      this._context.initialUrl = url;
      this._context.initialTimestamp = Date.now();
      this._context.urls.push(url);
    }

    /**
     * Add a breadcrumb event, that may be throttled.
     * If it was throttled, we add a custom breadcrumb to indicate that.
     */
  }, {
    key: "throttledAddEvent",
    value: function throttledAddEvent(event, isCheckout) {
      var _this23 = this;
      var res = this._throttledAddEvent(event, isCheckout);

      // If this is THROTTLED, it means we have throttled the event for the first time
      // In this case, we want to add a breadcrumb indicating that something was skipped
      if (res === THROTTLED) {
        var breadcrumb = createBreadcrumb({
          category: 'replay.throttled'
        });
        this.addUpdate(function () {
          // Return `false` if the event _was_ added, as that means we schedule a flush
          return !addEventSync(_this23, {
            type: ReplayEventTypeCustom,
            timestamp: breadcrumb.timestamp || 0,
            data: {
              tag: 'breadcrumb',
              payload: breadcrumb,
              metric: true
            }
          });
        });
      }
      return res;
    }

    /**
     * This will get the parametrized route name of the current page.
     * This is only available if performance is enabled, and if an instrumented router is used.
     */
  }, {
    key: "getCurrentRoute",
    value: function getCurrentRoute() {
      var lastActiveSpan = this.lastActiveSpan || getActiveSpan();
      var lastRootSpan = lastActiveSpan && getRootSpan(lastActiveSpan);
      var attributes = lastRootSpan && spanToJSON(lastRootSpan).data || {};
      var source = attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
      if (!lastRootSpan || !source || !['route', 'custom'].includes(source)) {
        return undefined;
      }
      return spanToJSON(lastRootSpan).description;
    }

    /**
     * Initialize and start all listeners to varying events (DOM,
     * Performance Observer, Recording, Sentry SDK, etc)
     */
  }, {
    key: "_initializeRecording",
    value: function _initializeRecording() {
      this.setInitialState();

      // this method is generally called on page load or manually - in both cases
      // we should treat it as an activity
      this._updateSessionActivity();
      this.eventBuffer = createEventBuffer({
        useCompression: this._options.useCompression,
        workerUrl: this._options.workerUrl
      });
      this._removeListeners();
      this._addListeners();

      // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
      this._isEnabled = true;
      this._isPaused = false;
      this.startRecording();
    }

    /**
     * Loads (or refreshes) the current session.
     */
  }, {
    key: "_initializeSessionForSampling",
    value: function _initializeSessionForSampling(previousSessionId) {
      // Whenever there is _any_ error sample rate, we always allow buffering
      // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
      var allowBuffering = this._options.errorSampleRate > 0;
      var session = loadOrCreateSession({
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        previousSessionId: previousSessionId
      }, {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering: allowBuffering
      });
      this.session = session;
    }

    /**
     * Checks and potentially refreshes the current session.
     * Returns false if session is not recorded.
     */
  }, {
    key: "_checkSession",
    value: function _checkSession() {
      // If there is no session yet, we do not want to refresh anything
      // This should generally not happen, but to be safe....
      if (!this.session) {
        return false;
      }
      var currentSession = this.session;
      if (shouldRefreshSession(currentSession, {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration
      })) {
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._refreshSession(currentSession);
        return false;
      }
      return true;
    }

    /**
     * Refresh a session with a new one.
     * This stops the current session (without forcing a flush, as that would never work since we are expired),
     * and then does a new sampling based on the refreshed session.
     */
  }, {
    key: "_refreshSession",
    value: function () {
      var _refreshSession2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(session) {
        return regeneratorRuntime.wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (this._isEnabled) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return");
            case 2:
              _context10.next = 4;
              return this.stop({
                reason: 'refresh session'
              });
            case 4:
              this.initializeSampling(session.id);
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee9, this);
      }));
      function _refreshSession(_x24) {
        return _refreshSession2.apply(this, arguments);
      }
      return _refreshSession;
    }()
    /**
     * Adds listeners to record events for the replay
     */
  }, {
    key: "_addListeners",
    value: function _addListeners() {
      try {
        WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
        WINDOW.addEventListener('blur', this._handleWindowBlur);
        WINDOW.addEventListener('focus', this._handleWindowFocus);
        WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
        if (this.clickDetector) {
          this.clickDetector.addListeners();
        }

        // There is no way to remove these listeners, so ensure they are only added once
        if (!this._hasInitializedCoreListeners) {
          addGlobalListeners(this);
          this._hasInitializedCoreListeners = true;
        }
      } catch (err) {
        this.handleException(err);
      }
      this._performanceCleanupCallback = setupPerformanceObserver(this);
    }

    /**
     * Cleans up listeners that were created in `_addListeners`
     */
  }, {
    key: "_removeListeners",
    value: function _removeListeners() {
      try {
        WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
        WINDOW.removeEventListener('blur', this._handleWindowBlur);
        WINDOW.removeEventListener('focus', this._handleWindowFocus);
        WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
        if (this.clickDetector) {
          this.clickDetector.removeListeners();
        }
        if (this._performanceCleanupCallback) {
          this._performanceCleanupCallback();
        }
      } catch (err) {
        this.handleException(err);
      }
    }

    /**
     * Handle when visibility of the page content changes. Opening a new tab will
     * cause the state to change to hidden because of content of current page will
     * be hidden. Likewise, moving a different window to cover the contents of the
     * page will also trigger a change to a hidden state.
     */
  }, {
    key: "__init",
    value: function __init() {
      var _this24 = this;
      this._handleVisibilityChange = function () {
        if (WINDOW.document.visibilityState === 'visible') {
          _this24._doChangeToForegroundTasks();
        } else {
          _this24._doChangeToBackgroundTasks();
        }
      };
    }

    /**
     * Handle when page is blurred
     */
  }, {
    key: "__init2",
    value: function __init2() {
      var _this25 = this;
      this._handleWindowBlur = function () {
        var breadcrumb = createBreadcrumb({
          category: 'ui.blur'
        });

        // Do not count blur as a user action -- it's part of the process of them
        // leaving the page
        _this25._doChangeToBackgroundTasks(breadcrumb);
      };
    }

    /**
     * Handle when page is focused
     */
  }, {
    key: "__init3",
    value: function __init3() {
      var _this26 = this;
      this._handleWindowFocus = function () {
        var breadcrumb = createBreadcrumb({
          category: 'ui.focus'
        });

        // Do not count focus as a user action -- instead wait until they focus and
        // interactive with page
        _this26._doChangeToForegroundTasks(breadcrumb);
      };
    }

    /** Ensure page remains active when a key is pressed. */
  }, {
    key: "__init4",
    value: function __init4() {
      var _this27 = this;
      this._handleKeyboardEvent = function (event) {
        handleKeyboardEvent(_this27, event);
      };
    }

    /**
     * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
     */
  }, {
    key: "_doChangeToBackgroundTasks",
    value: function _doChangeToBackgroundTasks(breadcrumb) {
      if (!this.session) {
        return;
      }
      var expired = isSessionExpired(this.session, {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire
      });
      if (expired) {
        return;
      }
      if (breadcrumb) {
        this._createCustomBreadcrumb(breadcrumb);
      }

      // Send replay when the page/tab becomes hidden. There is no reason to send
      // replay if it becomes visible, since no actions we care about were done
      // while it was hidden
      // This should never reject
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      void this.conditionalFlush();
    }

    /**
     * Tasks to run when we consider a page to be visible (via focus and/or visibility)
     */
  }, {
    key: "_doChangeToForegroundTasks",
    value: function _doChangeToForegroundTasks(breadcrumb) {
      if (!this.session) {
        return;
      }
      var isSessionActive = this.checkAndHandleExpiredSession();
      if (!isSessionActive) {
        // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
        // ms, we will re-use the existing session, otherwise create a new
        // session
        DEBUG_BUILD && logger.info('Document has become active, but session has expired');
        return;
      }
      if (breadcrumb) {
        this._createCustomBreadcrumb(breadcrumb);
      }
    }

    /**
     * Update user activity (across session lifespans)
     */
  }, {
    key: "_updateUserActivity",
    value: function _updateUserActivity() {
      var _lastActivity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      this._lastActivity = _lastActivity;
    }

    /**
     * Updates the session's last activity timestamp
     */
  }, {
    key: "_updateSessionActivity",
    value: function _updateSessionActivity() {
      var _lastActivity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      if (this.session) {
        this.session.lastActivity = _lastActivity;
        this._maybeSaveSession();
      }
    }

    /**
     * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
     */
  }, {
    key: "_createCustomBreadcrumb",
    value: function _createCustomBreadcrumb(breadcrumb) {
      var _this28 = this;
      this.addUpdate(function () {
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        _this28.throttledAddEvent({
          type: EventType.Custom,
          timestamp: breadcrumb.timestamp || 0,
          data: {
            tag: 'breadcrumb',
            payload: breadcrumb
          }
        });
      });
    }

    /**
     * Observed performance events are added to `this.performanceEntries`. These
     * are included in the replay event before it is finished and sent to Sentry.
     */
  }, {
    key: "_addPerformanceEntries",
    value: function _addPerformanceEntries() {
      var performanceEntries = createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
      this.performanceEntries = [];
      this.replayPerformanceEntries = [];

      // If we are manually starting, we want to ensure we only include performance entries
      // that are after the initial timestamp
      // The reason for this is that we may have performance entries from the page load, but may decide to start
      // the replay later on, in which case we do not want to include these entries.
      // without this, manually started replays can have events long before the actual replay recording starts,
      // which messes with the timeline etc.
      if (this._requiresManualStart) {
        var initialTimestampInSeconds = this._context.initialTimestamp / 1000;
        performanceEntries = performanceEntries.filter(function (entry) {
          return entry.start >= initialTimestampInSeconds;
        });
      }
      return Promise.all(createPerformanceSpans(this, performanceEntries));
    }

    /**
     * Clear _context
     */
  }, {
    key: "_clearContext",
    value: function _clearContext() {
      // XXX: `initialTimestamp` and `initialUrl` do not get cleared
      this._context.errorIds.clear();
      this._context.traceIds.clear();
      this._context.urls = [];
    }

    /** Update the initial timestamp based on the buffer content. */
  }, {
    key: "_updateInitialTimestampFromEventBuffer",
    value: function _updateInitialTimestampFromEventBuffer() {
      var session = this.session,
        eventBuffer = this.eventBuffer;
      // If replay was started manually (=no sample rate was given),
      // We do not want to back-port the initial timestamp
      if (!session || !eventBuffer || this._requiresManualStart) {
        return;
      }

      // we only ever update this on the initial segment
      if (session.segmentId) {
        return;
      }
      var earliestEvent = eventBuffer.getEarliestTimestamp();
      if (earliestEvent && earliestEvent < this._context.initialTimestamp) {
        this._context.initialTimestamp = earliestEvent;
      }
    }

    /**
     * Return and clear _context
     */
  }, {
    key: "_popEventContext",
    value: function _popEventContext() {
      var _context = {
        initialTimestamp: this._context.initialTimestamp,
        initialUrl: this._context.initialUrl,
        errorIds: Array.from(this._context.errorIds),
        traceIds: Array.from(this._context.traceIds),
        urls: this._context.urls
      };
      this._clearContext();
      return _context;
    }

    /**
     * Flushes replay event buffer to Sentry.
     *
     * Performance events are only added right before flushing - this is
     * due to the buffered performance observer events.
     *
     * Should never be called directly, only by `flush`
     */
  }, {
    key: "_runFlush",
    value: function () {
      var _runFlush2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _this29 = this;
        var replayId, timestamp, eventContext, segmentId, recordingData, client, dropReason;
        return regeneratorRuntime.wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              replayId = this.getSessionId();
              if (!(!this.session || !this.eventBuffer || !replayId)) {
                _context11.next = 4;
                break;
              }
              DEBUG_BUILD && logger.error('No session or eventBuffer found to flush.');
              return _context11.abrupt("return");
            case 4:
              _context11.next = 6;
              return this._addPerformanceEntries();
            case 6:
              if (!(!this.eventBuffer || !this.eventBuffer.hasEvents)) {
                _context11.next = 8;
                break;
              }
              return _context11.abrupt("return");
            case 8:
              _context11.next = 10;
              return addMemoryEntry(this);
            case 10:
              if (this.eventBuffer) {
                _context11.next = 12;
                break;
              }
              return _context11.abrupt("return");
            case 12:
              if (!(replayId !== this.getSessionId())) {
                _context11.next = 14;
                break;
              }
              return _context11.abrupt("return");
            case 14:
              _context11.prev = 14;
              // This uses the data from the eventBuffer, so we need to call this before `finish()
              this._updateInitialTimestampFromEventBuffer();
              timestamp = Date.now(); // Check total duration again, to avoid sending outdated stuff
              // We leave 30s wiggle room to accommodate late flushing etc.
              // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
              if (!(timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000)) {
                _context11.next = 19;
                break;
              }
              throw new Error('Session is too long, not sending replay');
            case 19:
              eventContext = this._popEventContext(); // Always increment segmentId regardless of outcome of sending replay
              segmentId = this.session.segmentId++;
              this._maybeSaveSession();

              // Note this empties the event buffer regardless of outcome of sending replay
              _context11.next = 24;
              return this.eventBuffer.finish();
            case 24:
              recordingData = _context11.sent;
              _context11.next = 27;
              return sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: function onError(err) {
                  return _this29.handleException(err);
                }
              });
            case 27:
              _context11.next = 35;
              break;
            case 29:
              _context11.prev = 29;
              _context11.t0 = _context11["catch"](14);
              this.handleException(_context11.t0);

              // This means we retried 3 times and all of them failed,
              // or we ran into a problem we don't want to retry, like rate limiting.
              // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
              // This should never reject
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              this.stop({
                reason: 'sendReplay'
              });
              client = getClient();
              if (client) {
                dropReason = _context11.t0 instanceof RateLimitError ? 'ratelimit_backoff' : 'send_error';
                client.recordDroppedEvent(dropReason, 'replay');
              }
            case 35:
            case "end":
              return _context11.stop();
          }
        }, _callee10, this, [[14, 29]]);
      }));
      function _runFlush() {
        return _runFlush2.apply(this, arguments);
      }
      return _runFlush;
    }()
    /**
     * Flush recording data to Sentry. Creates a lock so that only a single flush
     * can be active at a time. Do not call this directly.
     */
  }, {
    key: "__init5",
    value: function __init5() {
      var _this30 = this;
      this._flush = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _ref51,
          _ref51$force,
          force,
          start,
          now,
          duration,
          tooShort,
          tooLong,
          eventBuffer,
          _flushInProgress,
          _args11 = arguments;
        return regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _ref51 = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {}, _ref51$force = _ref51.force, force = _ref51$force === void 0 ? false : _ref51$force;
              if (!(!_this30._isEnabled && !force)) {
                _context12.next = 3;
                break;
              }
              return _context12.abrupt("return");
            case 3:
              if (_this30.checkAndHandleExpiredSession()) {
                _context12.next = 6;
                break;
              }
              DEBUG_BUILD && logger.error('Attempting to finish replay event after session expired.');
              return _context12.abrupt("return");
            case 6:
              if (_this30.session) {
                _context12.next = 8;
                break;
              }
              return _context12.abrupt("return");
            case 8:
              start = _this30.session.started;
              now = Date.now();
              duration = now - start; // A flush is about to happen, cancel any queued flushes
              _this30._debouncedFlush.cancel();

              // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
              // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
              tooShort = duration < _this30._options.minReplayDuration;
              tooLong = duration > _this30._options.maxReplayDuration + 5000;
              if (!(tooShort || tooLong)) {
                _context12.next = 18;
                break;
              }
              DEBUG_BUILD && logger.info("Session duration (".concat(Math.floor(duration / 1000), "s) is too ").concat(tooShort ? 'short' : 'long', ", not sending replay."));
              if (tooShort) {
                _this30._debouncedFlush();
              }
              return _context12.abrupt("return");
            case 18:
              eventBuffer = _this30.eventBuffer;
              if (eventBuffer && _this30.session.segmentId === 0 && !eventBuffer.hasCheckout) {
                DEBUG_BUILD && logger.info('Flushing initial segment without checkout.');
                // TODO FN: Evaluate if we want to stop here, or remove this again?
              }
              _flushInProgress = !!_this30._flushLock; // this._flushLock acts as a lock so that future calls to `_flush()` will
              // be blocked until current flush is finished (i.e. this promise resolves)
              if (!_this30._flushLock) {
                _this30._flushLock = _this30._runFlush();
              }
              _context12.prev = 22;
              _context12.next = 25;
              return _this30._flushLock;
            case 25:
              _context12.next = 30;
              break;
            case 27:
              _context12.prev = 27;
              _context12.t0 = _context12["catch"](22);
              _this30.handleException(_context12.t0);
            case 30:
              _context12.prev = 30;
              _this30._flushLock = undefined;
              if (_flushInProgress) {
                // Wait for previous flush to finish, then call the debounced
                // `_flush()`. It's possible there are other flush requests queued and
                // waiting for it to resolve. We want to reduce all outstanding
                // requests (as well as any new flush requests that occur within a
                // second of the locked flush completing) into a single flush.
                _this30._debouncedFlush();
              }
              return _context12.finish(30);
            case 34:
            case "end":
              return _context12.stop();
          }
        }, _callee11, null, [[22, 27, 30, 34]]);
      }));
    }

    /** Save the session, if it is sticky */
  }, {
    key: "_maybeSaveSession",
    value: function _maybeSaveSession() {
      if (this.session && this._options.stickySession) {
        saveSession(this.session);
      }
    }

    /** Handler for rrweb.record.onMutation */
  }, {
    key: "__init6",
    value: function __init6() {
      var _this31 = this;
      this._onMutationHandler = function (mutations) {
        var count = mutations.length;
        var mutationLimit = _this31._options.mutationLimit;
        var mutationBreadcrumbLimit = _this31._options.mutationBreadcrumbLimit;
        var overMutationLimit = mutationLimit && count > mutationLimit;

        // Create a breadcrumb if a lot of mutations happen at the same time
        // We can show this in the UI as an information with potential performance improvements
        if (count > mutationBreadcrumbLimit || overMutationLimit) {
          var breadcrumb = createBreadcrumb({
            category: 'replay.mutations',
            data: {
              count: count,
              limit: overMutationLimit
            }
          });
          _this31._createCustomBreadcrumb(breadcrumb);
        }

        // Stop replay if over the mutation limit
        if (overMutationLimit) {
          // This should never reject
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          _this31.stop({
            reason: 'mutationLimit',
            forceFlush: _this31.recordingMode === 'session'
          });
          return false;
        }

        // `true` means we use the regular mutation handling by rrweb
        return true;
      };
    }
  }]);
  return ReplayContainer;
}();
function getOption(selectors, defaultSelectors) {
  return [].concat(_toConsumableArray(selectors), _toConsumableArray(defaultSelectors)).join(',');
}

/**
 * Returns privacy related configuration for use in rrweb
 */
function getPrivacyOptions(_ref52) {
  var mask = _ref52.mask,
    unmask = _ref52.unmask,
    block = _ref52.block,
    unblock = _ref52.unblock,
    ignore = _ref52.ignore;
  var defaultBlockedElements = ['base', 'iframe[srcdoc]:not([src])'];
  var maskSelector = getOption(mask, ['.sentry-mask', '[data-sentry-mask]']);
  var unmaskSelector = getOption(unmask, []);
  var options = {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: maskSelector,
    unmaskTextSelector: unmaskSelector,
    blockSelector: getOption(block, ['.sentry-block', '[data-sentry-block]'].concat(defaultBlockedElements)),
    unblockSelector: getOption(unblock, []),
    ignoreSelector: getOption(ignore, ['.sentry-ignore', '[data-sentry-ignore]', 'input[type="file"]'])
  };
  return options;
}

/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */
function maskAttribute(_ref53) {
  var el = _ref53.el,
    key = _ref53.key,
    maskAttributes = _ref53.maskAttributes,
    maskAllText = _ref53.maskAllText,
    privacyOptions = _ref53.privacyOptions,
    value = _ref53.value;
  // We only mask attributes if `maskAllText` is true
  if (!maskAllText) {
    return value;
  }

  // unmaskTextSelector takes precedence
  if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) {
    return value;
  }
  if (maskAttributes.includes(key) ||
  // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  key === 'value' && el.tagName === 'INPUT' && ['submit', 'button'].includes(el.getAttribute('type') || '')) {
    return value.replace(/[\S]/g, '*');
  }
  return value;
}
var MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
var DEFAULT_NETWORK_HEADERS = ['content-length', 'content-type', 'accept'];
var _initialized = false;

/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */
var replayIntegration = function replayIntegration(options) {
  return new Replay(options);
};

/**
 * Replay integration
 *
 * TODO: Rewrite this to be functional integration
 * Exported for tests.
 */
var Replay = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */

  /**
   * Options to pass to `rrweb.record()`
   */

  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */

  function Replay() {
    var _ref54 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref54$flushMinDelay = _ref54.flushMinDelay,
      flushMinDelay = _ref54$flushMinDelay === void 0 ? DEFAULT_FLUSH_MIN_DELAY : _ref54$flushMinDelay,
      _ref54$flushMaxDelay = _ref54.flushMaxDelay,
      flushMaxDelay = _ref54$flushMaxDelay === void 0 ? DEFAULT_FLUSH_MAX_DELAY : _ref54$flushMaxDelay,
      _ref54$minReplayDurat = _ref54.minReplayDuration,
      minReplayDuration = _ref54$minReplayDurat === void 0 ? MIN_REPLAY_DURATION : _ref54$minReplayDurat,
      _ref54$maxReplayDurat = _ref54.maxReplayDuration,
      maxReplayDuration = _ref54$maxReplayDurat === void 0 ? MAX_REPLAY_DURATION : _ref54$maxReplayDurat,
      _ref54$stickySession = _ref54.stickySession,
      stickySession = _ref54$stickySession === void 0 ? true : _ref54$stickySession,
      _ref54$useCompression = _ref54.useCompression,
      useCompression = _ref54$useCompression === void 0 ? true : _ref54$useCompression,
      workerUrl = _ref54.workerUrl,
      _ref54$_experiments = _ref54._experiments,
      _experiments = _ref54$_experiments === void 0 ? {} : _ref54$_experiments,
      _ref54$maskAllText = _ref54.maskAllText,
      maskAllText = _ref54$maskAllText === void 0 ? true : _ref54$maskAllText,
      _ref54$maskAllInputs = _ref54.maskAllInputs,
      maskAllInputs = _ref54$maskAllInputs === void 0 ? true : _ref54$maskAllInputs,
      _ref54$blockAllMedia = _ref54.blockAllMedia,
      blockAllMedia = _ref54$blockAllMedia === void 0 ? true : _ref54$blockAllMedia,
      _ref54$mutationBreadc = _ref54.mutationBreadcrumbLimit,
      mutationBreadcrumbLimit = _ref54$mutationBreadc === void 0 ? 750 : _ref54$mutationBreadc,
      _ref54$mutationLimit = _ref54.mutationLimit,
      mutationLimit = _ref54$mutationLimit === void 0 ? 10000 : _ref54$mutationLimit,
      _ref54$slowClickTimeo = _ref54.slowClickTimeout,
      slowClickTimeout = _ref54$slowClickTimeo === void 0 ? 7000 : _ref54$slowClickTimeo,
      _ref54$slowClickIgnor = _ref54.slowClickIgnoreSelectors,
      slowClickIgnoreSelectors = _ref54$slowClickIgnor === void 0 ? [] : _ref54$slowClickIgnor,
      _ref54$networkDetailA = _ref54.networkDetailAllowUrls,
      networkDetailAllowUrls = _ref54$networkDetailA === void 0 ? [] : _ref54$networkDetailA,
      _ref54$networkDetailD = _ref54.networkDetailDenyUrls,
      networkDetailDenyUrls = _ref54$networkDetailD === void 0 ? [] : _ref54$networkDetailD,
      _ref54$networkCapture = _ref54.networkCaptureBodies,
      networkCaptureBodies = _ref54$networkCapture === void 0 ? true : _ref54$networkCapture,
      _ref54$networkRequest = _ref54.networkRequestHeaders,
      networkRequestHeaders = _ref54$networkRequest === void 0 ? [] : _ref54$networkRequest,
      _ref54$networkRespons = _ref54.networkResponseHeaders,
      networkResponseHeaders = _ref54$networkRespons === void 0 ? [] : _ref54$networkRespons,
      _ref54$mask = _ref54.mask,
      mask = _ref54$mask === void 0 ? [] : _ref54$mask,
      _ref54$maskAttributes = _ref54.maskAttributes,
      maskAttributes = _ref54$maskAttributes === void 0 ? ['title', 'placeholder'] : _ref54$maskAttributes,
      _ref54$unmask = _ref54.unmask,
      unmask = _ref54$unmask === void 0 ? [] : _ref54$unmask,
      _ref54$block = _ref54.block,
      block = _ref54$block === void 0 ? [] : _ref54$block,
      _ref54$unblock = _ref54.unblock,
      unblock = _ref54$unblock === void 0 ? [] : _ref54$unblock,
      _ref54$ignore = _ref54.ignore,
      ignore = _ref54$ignore === void 0 ? [] : _ref54$ignore,
      maskFn = _ref54.maskFn,
      beforeAddRecordingEvent = _ref54.beforeAddRecordingEvent,
      beforeErrorSampling = _ref54.beforeErrorSampling,
      onError = _ref54.onError;
    _classCallCheck(this, Replay);
    this.name = Replay.id;
    var privacyOptions = getPrivacyOptions({
      mask: mask,
      unmask: unmask,
      block: block,
      unblock: unblock,
      ignore: ignore
    });
    this._recordingOptions = _objectSpread(_objectSpread({
      maskAllInputs: maskAllInputs,
      maskAllText: maskAllText,
      maskInputOptions: {
        password: true
      },
      maskTextFn: maskFn,
      maskInputFn: maskFn,
      maskAttributeFn: function maskAttributeFn(key, value, el) {
        return maskAttribute({
          maskAttributes: maskAttributes,
          maskAllText: maskAllText,
          privacyOptions: privacyOptions,
          key: key,
          value: value,
          el: el
        });
      }
    }, privacyOptions), {}, {
      // Our defaults
      slimDOMOptions: 'all',
      inlineStylesheet: true,
      // Disable inline images as it will increase segment/replay size
      inlineImages: false,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: true,
      errorHandler: function errorHandler(err) {
        try {
          err.__rrweb__ = true;
        } catch (error) {
          // ignore errors here
          // this can happen if the error is frozen or does not allow mutation for other reasons
        }
      }
    });
    this._initialOptions = {
      flushMinDelay: flushMinDelay,
      flushMaxDelay: flushMaxDelay,
      minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
      maxReplayDuration: Math.min(maxReplayDuration, MAX_REPLAY_DURATION),
      stickySession: stickySession,
      useCompression: useCompression,
      workerUrl: workerUrl,
      blockAllMedia: blockAllMedia,
      maskAllInputs: maskAllInputs,
      maskAllText: maskAllText,
      mutationBreadcrumbLimit: mutationBreadcrumbLimit,
      mutationLimit: mutationLimit,
      slowClickTimeout: slowClickTimeout,
      slowClickIgnoreSelectors: slowClickIgnoreSelectors,
      networkDetailAllowUrls: networkDetailAllowUrls,
      networkDetailDenyUrls: networkDetailDenyUrls,
      networkCaptureBodies: networkCaptureBodies,
      networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
      networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
      beforeAddRecordingEvent: beforeAddRecordingEvent,
      beforeErrorSampling: beforeErrorSampling,
      onError: onError,
      _experiments: _experiments
    };
    if (this._initialOptions.blockAllMedia) {
      // `blockAllMedia` is a more user friendly option to configure blocking
      // embedded media elements
      this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? MEDIA_SELECTORS : "".concat(this._recordingOptions.blockSelector, ",").concat(MEDIA_SELECTORS);
    }
    if (this._isInitialized && isBrowser()) {
      throw new Error('Multiple Sentry Session Replay instances are not supported');
    }
    this._isInitialized = true;
  }

  /** If replay has already been initialized */
  _createClass(Replay, [{
    key: "_isInitialized",
    get: function get() {
      return _initialized;
    }

    /** Update _isInitialized */,
    set: function set(value) {
      _initialized = value;
    }

    /**
     * Setup and initialize replay container
     */
  }, {
    key: "afterAllSetup",
    value: function afterAllSetup(client) {
      if (!isBrowser() || this._replay) {
        return;
      }
      this._setup(client);
      this._initialize(client);
    }

    /**
     * Start a replay regardless of sampling rate. Calling this will always
     * create a new session. Will log a message if replay is already in progress.
     *
     * Creates or loads a session, attaches listeners to varying events (DOM,
     * PerformanceObserver, Recording, Sentry SDK, etc)
     */
  }, {
    key: "start",
    value: function start() {
      if (!this._replay) {
        return;
      }
      this._replay.start();
    }

    /**
     * Start replay buffering. Buffers until `flush()` is called or, if
     * `replaysOnErrorSampleRate` > 0, until an error occurs.
     */
  }, {
    key: "startBuffering",
    value: function startBuffering() {
      if (!this._replay) {
        return;
      }
      this._replay.startBuffering();
    }

    /**
     * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
     * does not support a teardown
     */
  }, {
    key: "stop",
    value: function stop() {
      if (!this._replay) {
        return Promise.resolve();
      }
      return this._replay.stop({
        forceFlush: this._replay.recordingMode === 'session'
      });
    }

    /**
     * If not in "session" recording mode, flush event buffer which will create a new replay.
     * If replay is not enabled, a new session replay is started.
     * Unless `continueRecording` is false, the replay will continue to record and
     * behave as a "session"-based replay.
     *
     * Otherwise, queue up a flush.
     */
  }, {
    key: "flush",
    value: function flush(options) {
      if (!this._replay) {
        return Promise.resolve();
      }

      // assuming a session should be recorded in this case
      if (!this._replay.isEnabled()) {
        this._replay.start();
        return Promise.resolve();
      }
      return this._replay.sendBufferedReplayOrFlush(options);
    }

    /**
     * Get the current session ID.
     */
  }, {
    key: "getReplayId",
    value: function getReplayId() {
      if (!this._replay || !this._replay.isEnabled()) {
        return;
      }
      return this._replay.getSessionId();
    }

    /**
     * Get the current recording mode. This can be either `session` or `buffer`.
     *
     * `session`: Recording the whole session, sending it continuously
     * `buffer`: Always keeping the last 60s of recording, requires:
     *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
     *   - or calling `flush()` to send the replay
     */
  }, {
    key: "getRecordingMode",
    value: function getRecordingMode() {
      if (!this._replay || !this._replay.isEnabled()) {
        return;
      }
      return this._replay.recordingMode;
    }

    /**
     * Initializes replay.
     */
  }, {
    key: "_initialize",
    value: function _initialize(client) {
      if (!this._replay) {
        return;
      }
      this._maybeLoadFromReplayCanvasIntegration(client);
      this._replay.initializeSampling();
    }

    /** Setup the integration. */
  }, {
    key: "_setup",
    value: function _setup(client) {
      // Client is not available in constructor, so we need to wait until setupOnce
      var finalOptions = loadReplayOptionsFromClient(this._initialOptions, client);
      this._replay = new ReplayContainer({
        options: finalOptions,
        recordingOptions: this._recordingOptions
      });
    }

    /** Get canvas options from ReplayCanvas integration, if it is also added. */
  }, {
    key: "_maybeLoadFromReplayCanvasIntegration",
    value: function _maybeLoadFromReplayCanvasIntegration(client) {
      // To save bundle size, we skip checking for stuff here
      // and instead just try-catch everything - as generally this should all be defined
      /* eslint-disable @typescript-eslint/no-non-null-assertion */
      try {
        var canvasIntegration = client.getIntegrationByName('ReplayCanvas');
        if (!canvasIntegration) {
          return;
        }
        this._replay['_canvas'] = canvasIntegration.getOptions();
      } catch (e) {
        // ignore errors here
      }
      /* eslint-enable @typescript-eslint/no-non-null-assertion */
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Replay';
    }
  }]);
  return Replay;
}();
Replay.__initStatic();

/** Parse Replay-related options from SDK options */
function loadReplayOptionsFromClient(initialOptions, client) {
  var opt = client.getOptions();
  var finalOptions = _objectSpread({
    sessionSampleRate: 0,
    errorSampleRate: 0
  }, dropUndefinedKeys(initialOptions));
  var replaysSessionSampleRate = parseSampleRate(opt.replaysSessionSampleRate);
  var replaysOnErrorSampleRate = parseSampleRate(opt.replaysOnErrorSampleRate);
  if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) {
    consoleSandbox(function () {
      // eslint-disable-next-line no-console
      console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
  }
  if (replaysSessionSampleRate != null) {
    finalOptions.sessionSampleRate = replaysSessionSampleRate;
  }
  if (replaysOnErrorSampleRate != null) {
    finalOptions.errorSampleRate = replaysOnErrorSampleRate;
  }
  return finalOptions;
}
function _getMergedNetworkHeaders(headers) {
  return [].concat(DEFAULT_NETWORK_HEADERS, _toConsumableArray(headers.map(function (header) {
    return header.toLowerCase();
  })));
}

/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */
function getReplay() {
  var client = getClient();
  return client && client.getIntegrationByName('Replay');
}
export { getReplay, replayIntegration };